/**
 * Returns a list of all participles used for the Swedish passive voice assessment.
 * @returns {Array} The list with participles.
 */

export default [
	"åberopades",
	"åberopas",
	"åberopats",
	"aborterades",
	"aborteras",
	"absorberades",
	"absorberas",
	"abstraherats",
	"acceleras",
	"accelereras",
	"accentuerades",
	"accentueras",
	"accentuerats",
	"accepeteras",
	"accepterades",
	"accepteras",
	"accepterats",
	"äcklades",
	"äcklas",
	"äcklats",
	"ackompagnerades",
	"ackompanjerades",
	"ackompanjeras",
	"ackompanjerats",
	"ackumuleras",
	"ackumulerats",
	"ådagalades",
	"ådagaläggs",
	"adderades",
	"adderas",
	"adderats",
	"adelspalats",
	"åderlåtas",
	"åderlåtits",
	"adidas",
	"adlades",
	"adlas",
	"adlats",
	"administrerades",
	"administreras",
	"ådömas",
	"ådömdes",
	"ådömes",
	"ådöms",
	"ådömts",
	"adopterades",
	"adopteras",
	"adopterats",
	"adresserades",
	"adresseras",
	"adresserats",
	"adventures",
	"affaires",
	"affischeras",
	"aflägsnas",
	"agades",
	"agas",
	"ägas",
	"ägdes",
	"ageras",
	"ägnades",
	"agnas",
	"ägnas",
	"ägnats",
	"ägs",
	"ägts",
	"åhördes",
	"aidstestas",
	"ajournerades",
	"ajourneras",
	"åkallades",
	"åkallas",
	"åkas",
	"aklagas",
	"åks",
	"aktades",
	"aktas",
	"akterseglas",
	"åktes",
	"äkthetsförklarades",
	"aktietips",
	"aktiverades",
	"aktiveras",
	"aktiverats",
	"aktivierats",
	"aktualiserades",
	"aktualiseras",
	"aktualiserats",
	"ålades",
	"åläggas",
	"åläggs",
	"ålagts",
	"alarmerades",
	"åldersbestämmas",
	"algas",
	"alienerades",
	"alldeldes",
	"alldelses",
	"alleles",
	"allendes",
	"allergiskadades",
	"allierades",
	"allokeras",
	"almsicks",
	"alouettes",
	"älskas",
	"älskats",
	"alstrades",
	"alstras",
	"alstrats",
	"ältades",
	"ältas",
	"ältats",
	"amatöriserades",
	"amerikaniseras",
	"ammades",
	"ammas",
	"ammats",
	"amores",
	"amorteras",
	"amorterats",
	"amputerades",
	"amputeras",
	"amputerats",
	"anades",
	"analyserades",
	"analyseras",
	"analyserats",
	"anammades",
	"anammas",
	"anammats",
	"anas",
	"anats",
	"anbefalldes",
	"anbefalles",
	"anbefalls",
	"anbringas",
	"anbringats",
	"anbudsupphandlas",
	"ändhållplats",
	"ändrades",
	"andras",
	"ändras",
	"ändrats",
	"anfäktades",
	"anfäktas",
	"anfäktats",
	"anfallas",
	"anfallits",
	"anfalls",
	"anfölls",
	"anföras",
	"anfördes",
	"anföres",
	"anförs",
	"anförtroddes",
	"anförtros",
	"anförtrotts",
	"anförts",
	"anfrätas",
	"ångades",
	"ångas",
	"ångats",
	"angavs",
	"anges",
	"angetts",
	"angives",
	"angivits",
	"angivs",
	"angjordes",
	"ångkokas",
	"angöras",
	"angörs",
	"ångras",
	"ångrats",
	"angreps",
	"angripas",
	"angripits",
	"angrips",
	"ängslades",
	"ängslas",
	"ängslats",
	"anhållas",
	"anhålles",
	"anhållits",
	"anhålls",
	"anhölls",
	"anhopas",
	"animeras",
	"ankalagas",
	"anklagades",
	"anklagas",
	"anklagats",
	"anklagts",
	"anknyts",
	"ankrades",
	"anlades",
	"anläggas",
	"anläggs",
	"anlagts",
	"anlitades",
	"anlitas",
	"anlitats",
	"anmälas",
	"anmäldes",
	"anmäles",
	"anmäls",
	"anmälts",
	"anmanas",
	"anmärkas",
	"anmärks",
	"anmärkts",
	"anmodades",
	"anmodas",
	"anmodats",
	"annekterades",
	"annekteras",
	"annekterats",
	"annonserades",
	"annonseras",
	"annonserats",
	"annuleras",
	"annullerades",
	"annulleras",
	"annvänds",
	"anordnades",
	"anordnas",
	"anordnats",
	"anpassades",
	"anpassas",
	"anpassats",
	"anrås",
	"anrättas",
	"anrättats",
	"anrikas",
	"anropas",
	"ansades",
	"ansågs",
	"ansamlades",
	"ansamlas",
	"ansamlats",
	"ansas",
	"ansättas",
	"ansattes",
	"ansatts",
	"ansätts",
	"anses",
	"ansetts",
	"anskaffades",
	"anskaffas",
	"anskaffats",
	"anslagits",
	"anslagsfinansierats",
	"anslås",
	"anslogs",
	"anslöts",
	"anslutas",
	"anslutits",
	"ansluts",
	"ansökas",
	"ansökes",
	"ansöktes",
	"ansökts",
	"anspelas",
	"anställas",
	"anställdes",
	"anställes",
	"anställs",
	"anställts",
	"ansträngas",
	"ansträngdes",
	"ansträngs",
	"ansträngts",
	"ansvisas",
	"antagas",
	"antages",
	"antagits",
	"antändas",
	"antändes",
	"antänds",
	"antänts",
	"antas",
	"antastas",
	"antastats",
	"anteciperas",
	"antecknades",
	"antecknas",
	"antecknats",
	"anteras",
	"antogs",
	"antologiserats",
	"anträddes",
	"anträffas",
	"anträffats",
	"äntras",
	"antydas",
	"antyddes",
	"antydes",
	"antyds",
	"antytts",
	"anvämdas",
	"användas",
	"användes",
	"används",
	"använts",
	"anvisades",
	"anvisas",
	"anvisats",
	"apéritifdags",
	"apostroferades",
	"applåderades",
	"applåderas",
	"applåderats",
	"applicerades",
	"appliceras",
	"applicerats",
	"apprecieras",
	"aprilskämtas",
	"apterades",
	"apteras",
	"apterats",
	"ärades",
	"åräknas",
	"äras",
	"ärats",
	"arbetades",
	"arbetas",
	"arbetats",
	"argumenterades",
	"argumenteras",
	"arielvas",
	"aristokratpalats",
	"arkebuserades",
	"arkebuseras",
	"arkebuserats",
	"arkiverades",
	"arkiveras",
	"arkiverats",
	"armbågas",
	"armeras",
	"armerats",
	"ärnas",
	"arrangerades",
	"arrangeras",
	"arrangerats",
	"arrenderades",
	"arrenderas",
	"arrenderats",
	"arresterades",
	"arresteras",
	"arresterats",
	"årsundas",
	"artbestäms",
	"artbestämts",
	"artikulerades",
	"artikuleras",
	"ärvas",
	"arvoderades",
	"arvoderas",
	"ärvs",
	"ärvts",
	"åsågs",
	"åsamkades",
	"åsamkas",
	"åsamkats",
	"åsättas",
	"åsatts",
	"åsätts",
	"åsetts",
	"asfalteras",
	"asfalterats",
	"åsidosättas",
	"åsidosattes",
	"åsidosättes",
	"åsidosatts",
	"åsidosätts",
	"åsiktsnäts",
	"åskades",
	"åskådliggjorts",
	"åskådliggöras",
	"åskådliggörs",
	"åskådligörs",
	"äskas",
	"assimilerades",
	"assimileras",
	"assimilerats",
	"assisterades",
	"assisteras",
	"associationeras",
	"associerades",
	"associeras",
	"åstadkommas",
	"åstadkommes",
	"åstadkommits",
	"åstadkoms",
	"åstakommas",
	"åstakoms",
	"asturias",
	"åsyftades",
	"åsyftas",
	"åtalades",
	"åtalas",
	"åtalats",
	"åtaldes",
	"ätas",
	"åteförenas",
	"ateljéplats",
	"återanpassas",
	"återanställdes",
	"återanställs",
	"återanställts",
	"återantändas",
	"återanvändas",
	"återanvändes",
	"återanvänds",
	"återbefolkades",
	"återbefolkas",
	"återberättades",
	"återberättas",
	"återbesättas",
	"återbesätts",
	"återbetalades",
	"återbetalas",
	"återbetalats",
	"återbildas",
	"återbildats",
	"återbördades",
	"återbördas",
	"återbördats",
	"återbrukas",
	"återerövras",
	"återerövrats",
	"återexploateras",
	"återfångas",
	"återfanns",
	"återfås",
	"återfinnas",
	"återfinnes",
	"återfinns",
	"återfödas",
	"återföddes",
	"återföds",
	"återföras",
	"återfördes",
	"återförenades",
	"återförenas",
	"återförenats",
	"återförs",
	"återförts",
	"återförvildas",
	"återförvisades",
	"återförvisas",
	"återfunnits",
	"återgavs",
	"återges",
	"återgetts",
	"återgives",
	"återgivits",
	"återhämtades",
	"återhämtats",
	"återiföras",
	"återimporteras",
	"återinföras",
	"återinfördes",
	"återinförs",
	"återinförts",
	"återinrättades",
	"återinrättas",
	"återinsättas",
	"återinsattes",
	"återinstallerades",
	"återintegreras",
	"återinvesterades",
	"återinvesteras",
	"återinvigas",
	"återinvigdes",
	"återinvigs",
	"återkallades",
	"återkallas",
	"återkallats",
	"återkastades",
	"återkastas",
	"återkatoliceras",
	"återknutits",
	"återknytas",
	"återköpas",
	"återkopplas",
	"återköptes",
	"återkrävas",
	"återladdas",
	"återlämnades",
	"återlämnas",
	"återlämnats",
	"återlevererats",
	"återlöses",
	"återmatas",
	"åternationaliseras",
	"åternoterades",
	"återönskas",
	"återöppnas",
	"återöppnats",
	"återplanteras",
	"återreglerades",
	"återregleras",
	"återremitterades",
	"återremitteras",
	"återremitterats",
	"återropades",
	"återsågs",
	"återsamlades",
	"återsamlas",
	"återsändas",
	"återsändes",
	"återsänds",
	"återses",
	"återskapades",
	"återskapas",
	"återskapats",
	"återskolas",
	"återspeglades",
	"återspeglas",
	"återspeglats",
	"återställas",
	"återställdes",
	"återställes",
	"återställs",
	"återställts",
	"återstartas",
	"återtagas",
	"återtas",
	"återtogs",
	"återuppbyggas",
	"återuppbyggdes",
	"återuppbyggts",
	"återuppföras",
	"återuppfördes",
	"återuppförts",
	"återupplevs",
	"återupplivades",
	"återupplivas",
	"återupplivats",
	"återuppnås",
	"återupprättades",
	"återupprättas",
	"återupprättats",
	"återupprepades",
	"återupprepas",
	"återuppsattes",
	"återupptäckas",
	"återupptäcktes",
	"återupptäckts",
	"återupptagits",
	"återupptas",
	"återupptogs",
	"återuppväckas",
	"återuppväcks",
	"återuppväcktes",
	"återuppväckts",
	"återutges",
	"återutgetts",
	"återutgivits",
	"återutnämnas",
	"återutnämnts",
	"återväcktes",
	"återvaldes",
	"återväljs",
	"återvändas",
	"återvanns",
	"återvinnas",
	"återvinns",
	"återvisades",
	"återvisas",
	"återvunnits",
	"ätes",
	"åtföljas",
	"åtföljdes",
	"åtföljs",
	"åtföljts",
	"åtgärdades",
	"åtgärdas",
	"åtgärdats",
	"åthutas",
	"ätits",
	"åtlydas",
	"åtlyddes",
	"åtlyds",
	"åtnjuts",
	"åtrås",
	"åts",
	"äts",
	"åtsadkommas",
	"åtskildes",
	"åtskiljas",
	"åtskiljs",
	"attackerades",
	"attackeras",
	"attackerats",
	"attackutrustas",
	"attesterades",
	"attesterats",
	"attraherades",
	"attraheras",
	"attraherats",
	"auktionerades",
	"auktioneras",
	"auktoriserades",
	"auktoriseras",
	"automatiserades",
	"automatiseras",
	"automatiserats",
	"avanmälas",
	"avanmäls",
	"avåts",
	"avbalkats",
	"avbeställdes",
	"avbeställts",
	"avbetades",
	"avbetalas",
	"avbildades",
	"avbildas",
	"avbildats",
	"avblåsas",
	"avblåses",
	"avblåstes",
	"avblåsts",
	"avblockerades",
	"avböjas",
	"avböjdes",
	"avbokas",
	"avbördas",
	"avbröts",
	"avbrutits",
	"avbrytas",
	"avbryts",
	"avdelas",
	"avdelats",
	"avdemokratiserades",
	"avdömas",
	"avdömdes",
	"avdramatiseras",
	"avdramatiserats",
	"äventyras",
	"äventyrats",
	"averages",
	"averotiseras",
	"avfärdades",
	"avfärdas",
	"avfärdats",
	"avfattades",
	"avfattas",
	"avfestas",
	"avfiras",
	"avfolkades",
	"avfolkas",
	"avfolkats",
	"avföras",
	"avfördes",
	"avföres",
	"avförs",
	"avförts",
	"avfotograferades",
	"avfyrades",
	"avfyras",
	"avfyrats",
	"avges",
	"avgiftades",
	"avgiftas",
	"avgiftsbelades",
	"avgiftsbeskattas",
	"avgivits",
	"avgjordes",
	"avgjorts",
	"avgöras",
	"avgöres",
	"avgörs",
	"avgränsades",
	"avgränsas",
	"avhållas",
	"avhålles",
	"avhållits",
	"avhålls",
	"avhånades",
	"avhånas",
	"avhändes",
	"avhandlades",
	"avhandlas",
	"avhandlats",
	"avhänds",
	"avhästades",
	"avhjälpas",
	"avhjälps",
	"avhjälptes",
	"avhjälpts",
	"avhölls",
	"avhöras",
	"avhördes",
	"avhörts",
	"avhysas",
	"avhyses",
	"avidentifieras",
	"avideologiseras",
	"avindividualiserats",
	"avisades",
	"avisas",
	"aviserades",
	"aviseras",
	"aviserats",
	"avjapaniseras",
	"avjoniserats",
	"avklädas",
	"avkläddes",
	"avklarades",
	"avklaras",
	"avklassificerades",
	"avknoppades",
	"avknoppas",
	"avknoppats",
	"avkodas",
	"avkrävas",
	"avkrävdes",
	"avkrävs",
	"avkrävts",
	"avkriminaliseras",
	"avkunnades",
	"avkunnas",
	"avkunnats",
	"avkyls",
	"avlades",
	"avläggas",
	"avlägges",
	"avlägsnades",
	"avlägsnas",
	"avlägsnats",
	"avlämnades",
	"avlämnas",
	"avlämnats",
	"avlas",
	"avläs",
	"avläsas",
	"avläses",
	"avlastades",
	"avlastas",
	"avlästes",
	"avlats",
	"avledas",
	"avleds",
	"avlevereras",
	"avlivades",
	"avlivas",
	"avlivats",
	"avlockas",
	"avlockats",
	"avlöjas",
	"avlönades",
	"avlönas",
	"avlönats",
	"avlösas",
	"avlöses",
	"avlossades",
	"avlossas",
	"avlossats",
	"avlöstes",
	"avlösts",
	"avlövas",
	"avlutas",
	"avlyssnades",
	"avlyssnas",
	"avlystes",
	"avmagnetiseras",
	"avmattas",
	"avmobiliserades",
	"avmumiefieras",
	"avmystifieras",
	"avnavlades",
	"avnjöts",
	"avnjutas",
	"avnjutes",
	"avnjuts",
	"avnoterades",
	"avnoteras",
	"avpassas",
	"avpatrulleras",
	"avpolitiseras",
	"avpolleterades",
	"avpolleteras",
	"avpolletterades",
	"avpolletteras",
	"avporträtterades",
	"avporträtteras",
	"avprogrammeras",
	"avprogrammerats",
	"avprutades",
	"avrådas",
	"avråddes",
	"avråds",
	"avräknas",
	"avrapporteras",
	"avrapporterats",
	"avrättades",
	"avrättas",
	"avrättats",
	"avråtts",
	"avregistrerades",
	"avregistreras",
	"avregistrerats",
	"avreglerades",
	"avregleras",
	"avreglerats",
	"avritas",
	"avrundades",
	"avrundas",
	"avrustades",
	"avrustas",
	"avs",
	"avsågs",
	"avsändas",
	"avsändes",
	"avsänds",
	"avsänts",
	"avsättas",
	"avsattes",
	"avsatts",
	"avsätts",
	"avses",
	"avsetts",
	"avskaffades",
	"avskaffas",
	"avskaffats",
	"avskäras",
	"avskärmas",
	"avskedades",
	"avskedas",
	"avskedats",
	"avskedshyllades",
	"avskildes",
	"avskiljas",
	"avskiljes",
	"avskiljs",
	"avskilts",
	"avskjutas",
	"avskjutits",
	"avskräckas",
	"avskräcks",
	"avskräcktes",
	"avskräckts",
	"avskrevs",
	"avskrivas",
	"avskrivits",
	"avskrivs",
	"avskurits",
	"avskys",
	"avslagits",
	"avslås",
	"avslogs",
	"avslöjades",
	"avslöjas",
	"avslöjats",
	"avslöjtas",
	"avslutades",
	"avslutas",
	"avslutats",
	"avsmakades",
	"avsökas",
	"avsöndras",
	"avspänningsglödgas",
	"avspärrades",
	"avspärrats",
	"avspeglades",
	"avspeglas",
	"avspeglats",
	"avspelas",
	"avspisades",
	"avspisas",
	"avstängas",
	"avstängdes",
	"avstängs",
	"avstängts",
	"avstyras",
	"avstyrks",
	"avstyrktes",
	"avstyrkts",
	"avsynas",
	"avsyras",
	"avtackades",
	"avtackas",
	"avtäckas",
	"avtackats",
	"avtäcks",
	"avtäcktes",
	"avtäckts",
	"avtagas",
	"avtalades",
	"avtalas",
	"avtalats",
	"avtecknas",
	"avtjänas",
	"avtjänats",
	"avträdas",
	"avträddes",
	"avtrappas",
	"avtrubbas",
	"avtrubbats",
	"avtvås",
	"avtvingades",
	"avtvingas",
	"avundades",
	"avundats",
	"avvägas",
	"avvaktas",
	"avväpnades",
	"avväpnas",
	"avväpnats",
	"avvaras",
	"avvärjas",
	"avvärjdes",
	"avvärjs",
	"avvärjts",
	"avvattnas",
	"avvecklades",
	"avvecklas",
	"avvecklats",
	"avverkades",
	"avverkas",
	"avverkats",
	"avvinnas",
	"avvisades",
	"avvisas",
	"avvisats",
	"avyttrades",
	"avyttras",
	"avyttrats",
	"axlades",
	"axlas",
	"axlats",
	"babblades",
	"babettes",
	"backades",
	"backas",
	"backats",
	"badades",
	"badas",
	"bäddades",
	"baddas",
	"bäddas",
	"bäddats",
	"bads",
	"bagatelliserades",
	"bagatelliseras",
	"bagatelliserats",
	"bagoas",
	"bakades",
	"bakas",
	"bakats",
	"bakbands",
	"bakbinds",
	"baksits",
	"baktalas",
	"baktalats",
	"balanserades",
	"balanseras",
	"balanserats",
	"balas",
	"balsamerades",
	"balsameras",
	"banaliseras",
	"bananas",
	"banats",
	"bandades",
	"bandas",
	"bandats",
	"banderas",
	"bändes",
	"bands",
	"bänds",
	"bänkades",
	"bankas",
	"bankats",
	"bannas",
	"bannlysas",
	"bannlyses",
	"bannlystes",
	"bantades",
	"bantas",
	"bantats",
	"barabbas",
	"bäras",
	"bäres",
	"bärgades",
	"bärgas",
	"bärgats",
	"barings",
	"barnablods",
	"barnes",
	"barrantes",
	"bars",
	"bärs",
	"barthes",
	"baserades",
	"baseras",
	"baserats",
	"basunerades",
	"basuneras",
	"basunerats",
	"bättrades",
	"bättras",
	"bättrats",
	"baxades",
	"baxas",
	"baxats",
	"beaktades",
	"beaktas",
	"beaktats",
	"bearbetades",
	"bearbetas",
	"bearbetats",
	"beättas",
	"bebådas",
	"beblandas",
	"beboddes",
	"bebos",
	"bebotts",
	"bebyggas",
	"bebyggdes",
	"bebyggs",
	"bedårades",
	"bedåras",
	"bedjas",
	"bedömas",
	"bedömdes",
	"bedömms",
	"bedöms",
	"bedömts",
	"bedövades",
	"bedövas",
	"bedragas",
	"bedras",
	"bedrevs",
	"bedrivas",
	"bedrives",
	"bedrivits",
	"bedrivs",
	"beds",
	"bedyras",
	"bedyrats",
	"beers",
	"befalldes",
	"befallts",
	"befanns",
	"befarades",
	"befaras",
	"befarats",
	"befästas",
	"befästes",
	"befästs",
	"befinnas",
	"befinnes",
	"befinns",
	"befläckats",
	"befodrats",
	"befolkades",
	"befolkas",
	"befolkats",
	"befordrades",
	"befordras",
	"befordrats",
	"befrämjades",
	"befrämjas",
	"befriades",
	"befrias",
	"befriats",
	"befruktades",
	"befruktas",
	"befruktats",
	"befunnits",
	"begagnas",
	"begapas",
	"begäras",
	"begärdes",
	"begärs",
	"begärts",
	"begås",
	"begåtts",
	"begåvades",
	"begåvas",
	"begåvats",
	"begicks",
	"begöts",
	"begränas",
	"begränsades",
	"begränsas",
	"begränsats",
	"begravas",
	"begravdes",
	"begravs",
	"begravts",
	"begreps",
	"begripas",
	"begrips",
	"begrovs",
	"begrundades",
	"begrundas",
	"behäftas",
	"behagas",
	"behållas",
	"behållits",
	"behålls",
	"behandlades",
	"behandlas",
	"behandlats",
	"behängts",
	"behärskades",
	"behärskas",
	"behölls",
	"behövas",
	"behövdes",
	"behöves",
	"behövs",
	"behovsprövas",
	"behövts",
	"beivras",
	"beivrats",
	"bejakas",
	"bejakats",
	"bejublades",
	"bejublas",
	"bejublats",
	"bekämpades",
	"bekämpas",
	"bekämpats",
	"bekändes",
	"bekännas",
	"bekänns",
	"bekantas",
	"bekantgjorts",
	"békas",
	"bekikas",
	"bekläddes",
	"beklagades",
	"beklagas",
	"beklagats",
	"beklas",
	"beklätts",
	"bekommas",
	"bekostades",
	"bekostas",
	"bekostats",
	"beköts",
	"bekräftades",
	"bekräftas",
	"bekräftats",
	"bekymras",
	"belades",
	"beläggas",
	"beläggs",
	"belägrades",
	"belägras",
	"belägrats",
	"belagts",
	"belamrades",
	"belamras",
	"belastades",
	"belastas",
	"belastats",
	"beledsagades",
	"beledsagas",
	"beles",
	"belönades",
	"belönas",
	"belönats",
	"belys",
	"belysas",
	"belyses",
	"belystes",
	"belysts",
	"bemålats",
	"bemannades",
	"bemannas",
	"bemannats",
	"bemästras",
	"bemästrats",
	"bemötas",
	"bemöts",
	"bemöttes",
	"bemötts",
	"bemyndigades",
	"bemyndigas",
	"benådades",
	"benådas",
	"benådats",
	"benaissas",
	"benämnas",
	"benämndes",
	"benämnes",
	"benämns",
	"benämnts",
	"benas",
	"benedikts",
	"bennetts",
	"benskadats",
	"beöms",
	"beordrades",
	"beordras",
	"beordrats",
	"bepudrades",
	"beräknades",
	"beräknas",
	"beräknats",
	"berättades",
	"berättas",
	"berättats",
	"berättigades",
	"berättigas",
	"berättigats",
	"beredas",
	"bereddes",
	"beredes",
	"bereds",
	"beretts",
	"berikades",
	"berikas",
	"berikats",
	"berishas",
	"bermudas",
	"berömdes",
	"berömmas",
	"beröms",
	"beröras",
	"berördes",
	"berörs",
	"berörts",
	"berövades",
	"berövas",
	"berövats",
	"berusades",
	"berusats",
	"bes",
	"besåddes",
	"besågs",
	"besannades",
	"besannas",
	"besannats",
	"besås",
	"besättas",
	"besattes",
	"besatts",
	"besätts",
	"besegarades",
	"besegerades",
	"beseglades",
	"beseglas",
	"besegrades",
	"besegras",
	"besegrats",
	"beses",
	"besiktas",
	"besiktigas",
	"besiktigats",
	"besittes",
	"besitts",
	"besjälas",
	"besjöngs",
	"besjungas",
	"besjungits",
	"besjungs",
	"beskådades",
	"beskådas",
	"beskälls",
	"beskäras",
	"beskars",
	"beskärs",
	"beskattades",
	"beskattas",
	"beskattats",
	"beskedas",
	"beskevs",
	"beskjutas",
	"beskjutits",
	"beskjuts",
	"beskogats",
	"besköts",
	"beskrevs",
	"beskrivas",
	"beskrives",
	"beskrivits",
	"beskrivs",
	"beskurits",
	"beskyddades",
	"beskyddas",
	"beskyllas",
	"beskylldes",
	"beskylls",
	"beskyllts",
	"beslagits",
	"beslagtagits",
	"beslagtas",
	"beslagtogs",
	"beslås",
	"beslogs",
	"beslöjades",
	"beslöjas",
	"beslöts",
	"beslutades",
	"beslutas",
	"beslutats",
	"besmittats",
	"besökas",
	"besöks",
	"besöktes",
	"besökts",
	"besparades",
	"besparas",
	"besparats",
	"bespisas",
	"bespottas",
	"bespottats",
	"besprutades",
	"besprutas",
	"besprutats",
	"beställas",
	"beställdes",
	"beställes",
	"beställs",
	"beställts",
	"bestals",
	"bestämdes",
	"bestämmas",
	"bestämmes",
	"bestäms",
	"bestämts",
	"bestänktes",
	"bestås",
	"bestigas",
	"bestigits",
	"bestjäls",
	"bestods",
	"bestormas",
	"bestraffades",
	"bestraffas",
	"bestraffats",
	"bestrålas",
	"bestrålats",
	"bestreds",
	"bestridas",
	"bestriddes",
	"bestrids",
	"beströddes",
	"bestulits",
	"bestyckas",
	"bestyckats",
	"bestyras",
	"bestyrkas",
	"bestyrkes",
	"bestyrks",
	"besudlas",
	"besudlats",
	"besvarades",
	"besvärades",
	"besvaras",
	"besväras",
	"besvarats",
	"besvärats",
	"besvärjas",
	"betäckas",
	"betäcktes",
	"betäckts",
	"betades",
	"betalades",
	"betalas",
	"betalats",
	"betalts",
	"betänkas",
	"betas",
	"betats",
	"betcknas",
	"betecknades",
	"betecknas",
	"betecknats",
	"betingades",
	"betingas",
	"betitlades",
	"betjänas",
	"betonades",
	"betonas",
	"betonats",
	"beträdas",
	"beträddes",
	"betrakats",
	"betraktades",
	"betraktas",
	"betraktats",
	"betroddes",
	"betrotts",
	"bets",
	"betsas",
	"betslas",
	"betts",
	"betvingas",
	"betvingats",
	"betvivlas",
	"betvivlats",
	"betygas",
	"betygsättas",
	"betygsattes",
	"betygsatts",
	"betygsätts",
	"betygssättas",
	"beundrades",
	"beundras",
	"beundrats",
	"bevakades",
	"bevakas",
	"bevakats",
	"beväpnades",
	"beväpnats",
	"bevarades",
	"bevaras",
	"bevarats",
	"bevärdigades",
	"bevärdigats",
	"bevattnades",
	"bevattnas",
	"bevekas",
	"beviljades",
	"beviljas",
	"beviljats",
	"bevisades",
	"bevisas",
	"bevisats",
	"bevistas",
	"bevittnades",
	"bevittnas",
	"bevittnats",
	"bhopas",
	"bibehållas",
	"bibehålles",
	"bibehållits",
	"bibehålls",
	"bibehölls",
	"bibliograferas",
	"bibringades",
	"bibringas",
	"bibringats",
	"bidrags",
	"biesmes",
	"bifallas",
	"bifalles",
	"bifallits",
	"bifalls",
	"bifogades",
	"bifogas",
	"bifogats",
	"bifölls",
	"bilades",
	"biläggas",
	"biläggs",
	"bilagts",
	"bildades",
	"bildas",
	"bildats",
	"bildsättas",
	"bildsätts",
	"bilfraktas",
	"billhälls",
	"bilskjuts",
	"bindas",
	"bindes",
	"binds",
	"bisättas",
	"bisattes",
	"biscuits",
	"bitas",
	"bitits",
	"biträdas",
	"biträddes",
	"biträdes",
	"biträds",
	"bits",
	"bjöds",
	"bjudas",
	"bjudes",
	"bjudits",
	"bjuds",
	"bläddrades",
	"bläddras",
	"blades",
	"blåfärgats",
	"blåmärkas",
	"blandades",
	"bländades",
	"blandas",
	"bländas",
	"blandats",
	"bländats",
	"blandfärs",
	"blankslipades",
	"blankslitits",
	"blås",
	"blåsas",
	"blåses",
	"blåstes",
	"blästrades",
	"blästras",
	"blästrats",
	"blåsts",
	"blekas",
	"blekläggas",
	"bleks",
	"blekts",
	"blidkades",
	"blidkas",
	"blindmes",
	"blindtarmsopererats",
	"blindtestas",
	"blinkas",
	"blixtinkallades",
	"blixtinkallas",
	"blixtinkallats",
	"blixtutredas",
	"blockerades",
	"blockeras",
	"blockerats",
	"blodfylls",
	"blodfyllts",
	"blomsterhyllas",
	"blossas",
	"blötas",
	"blötläggas",
	"blötläggs",
	"blöts",
	"blottades",
	"blottas",
	"blottats",
	"blöttes",
	"blottlades",
	"blottläggas",
	"blottläggs",
	"blottlagts",
	"blötts",
	"blottställas",
	"bluddrats",
	"bluffas",
	"blygas",
	"blygdes",
	"blygs",
	"blylastas",
	"bockas",
	"bogserades",
	"bogseras",
	"bogserats",
	"böjas",
	"böjdes",
	"bojkottades",
	"bojkottas",
	"böjs",
	"böjts",
	"bokades",
	"bokas",
	"bokats",
	"bokföras",
	"bokfördes",
	"bokförs",
	"bokförts",
	"bolagiserades",
	"bolagiseras",
	"bolagiserats",
	"bolas",
	"bolivares",
	"bollades",
	"bollas",
	"bollats",
	"bombades",
	"bombarderades",
	"bombarderas",
	"bombarderats",
	"bombas",
	"bombats",
	"bombhotades",
	"bombhotas",
	"bombhotats",
	"bommades",
	"bommats",
	"bonades",
	"bonas",
	"bönhördes",
	"bordades",
	"bordlades",
	"bordläggas",
	"bordläggs",
	"bordlagts",
	"börgades",
	"börjades",
	"börjas",
	"borrades",
	"borras",
	"borrats",
	"börsintroducerades",
	"börsintroduceras",
	"börsnoterades",
	"börsnoteras",
	"börsnoterats",
	"börsstoppades",
	"borstas",
	"bortauktioneras",
	"bortdribblas",
	"bortfördes",
	"bortförklaras",
	"bortförklarats",
	"bortförlovades",
	"bortförts",
	"bortopereras",
	"borträknats",
	"bortrationaliserades",
	"bortrationaliseras",
	"bortses",
	"borttages",
	"bortträngts",
	"bortväljes",
	"botades",
	"botas",
	"botats",
	"bötfällas",
	"bötfälldes",
	"bötfälls",
	"bötfällts",
	"bothas",
	"bötläggas",
	"böts",
	"bottenskrapades",
	"bottenskrapats",
	"bottnas",
	"bräckas",
	"brackets",
	"bräcks",
	"bräcktes",
	"brädas",
	"bräddas",
	"bråddes",
	"brädfodras",
	"bragtes",
	"bragts",
	"bråkades",
	"bråkas",
	"bråkats",
	"brandmärkts",
	"brandskattas",
	"brännmärkas",
	"brännmärks",
	"brännmärktes",
	"branns",
	"brännskadades",
	"bräserats",
	"brassades",
	"breakas",
	"bredas",
	"breddades",
	"breddas",
	"breddats",
	"breddes",
	"brehmers",
	"bres",
	"bretts",
	"bricoles",
	"bringas",
	"bringats",
	"broddas",
	"broderades",
	"broderas",
	"broderats",
	"brölas",
	"bromsades",
	"bromsas",
	"bromsats",
	"bröts",
	"brudås",
	"brugueras",
	"brukades",
	"brukas",
	"brukats",
	"brunsminkades",
	"brutaliseras",
	"brutaliserats",
	"brutits",
	"bryggas",
	"brynas",
	"bryns",
	"bryssellörs",
	"brytas",
	"brytes",
	"bryts",
	"buades",
	"buas",
	"buats",
	"budades",
	"budgeterades",
	"budgeteras",
	"budgeterats",
	"buffas",
	"bugas",
	"buggas",
	"bullerbegränsas",
	"bullerisoleras",
	"bultas",
	"bundes",
	"bundits",
	"buntas",
	"buntats",
	"buras",
	"burits",
	"burrades",
	"busats",
	"bussades",
	"bussas",
	"bussats",
	"buteljeras",
	"buteljerats",
	"bygdes",
	"byggas",
	"byggdes",
	"bygges",
	"byggnadsminnesförklarades",
	"byggnadsminnesförklaras",
	"byggnadsminnesmärks",
	"byggs",
	"byggstartas",
	"byggts",
	"bykas",
	"bytas",
	"bytits",
	"byts",
	"byttes",
	"bytts",
	"caceres",
	"cajs",
	"cambrils",
	"camoufleras",
	"capras",
	"carlshamns",
	"catenas",
	"celebrerades",
	"celebreras",
	"cementas",
	"cementerades",
	"cementeras",
	"cementerats",
	"censurerades",
	"censureras",
	"censurerats",
	"centimes",
	"centraldirigeras",
	"centraliserades",
	"centraliseras",
	"centraliserats",
	"centralregleras",
	"centralstyrs",
	"centras",
	"centrats",
	"centrifugerats",
	"centrsimes",
	"ceres",
	"certifierats",
	"charmades",
	"charmas",
	"charmats",
	"chartras",
	"chartrats",
	"checkas",
	"chiapas",
	"chikanerats",
	"chines",
	"chivas",
	"chockades",
	"chockas",
	"chockats",
	"chockerades",
	"chockeras",
	"chockhöjs",
	"chockskadades",
	"chockskadas",
	"christmas",
	"cirkuleras",
	"citerades",
	"citeras",
	"citerats",
	"civiliseras",
	"coachas",
	"components",
	"comviqs",
	"contras",
	"cripps",
	"crosscheckades",
	"cruises",
	"cuplottades",
	"cyberfrogs",
	"cyklas",
	"däckades",
	"däckas",
	"däckats",
	"dagits",
	"daglidags",
	"dalaras",
	"dalas",
	"daltades",
	"daltas",
	"dämdes",
	"dammades",
	"dammas",
	"dämmas",
	"dammats",
	"dammsögs",
	"dammsugits",
	"dammsugs",
	"dammtorkas",
	"dämpades",
	"dämpas",
	"dämpats",
	"däms",
	"dämts",
	"danades",
	"danas",
	"danats",
	"danidas",
	"daniells",
	"dansades",
	"dansas",
	"dansats",
	"darras",
	"das",
	"databaseras",
	"databehandlas",
	"daterades",
	"dateras",
	"daterats",
	"datoriseras",
	"dealas",
	"debatterades",
	"debatteras",
	"debatterats",
	"debiteras",
	"debiterats",
	"decentraliserades",
	"decentraliseras",
	"dechiffreras",
	"decimaliseras",
	"decimerades",
	"decimeras",
	"decimerats",
	"dedicerades",
	"defineras",
	"definierades",
	"definieras",
	"definierats",
	"deformeras",
	"deformerats",
	"degas",
	"degenererats",
	"degraderades",
	"degraderas",
	"degraderats",
	"degradras",
	"deklamerades",
	"deklameras",
	"deklarerades",
	"deklareras",
	"deklarerats",
	"dekonstruerades",
	"dekonstrueras",
	"dekonstruerats",
	"dekorerades",
	"dekoreras",
	"dekorerats",
	"dekrypteras",
	"delades",
	"delas",
	"delats",
	"delegerades",
	"delegeras",
	"delegerats",
	"delexpedieras",
	"delfinansierades",
	"delfinansieras",
	"delgavs",
	"delges",
	"delgetts",
	"delgivits",
	"deltas",
	"delvalveras",
	"demaskerades",
	"demaskeras",
	"dematerialiseras",
	"dementerades",
	"dementeras",
	"dementerats",
	"demilitariserats",
	"demobiliserades",
	"demobiliseras",
	"demokratiserades",
	"demokratiseras",
	"demokratiserats",
	"demolerades",
	"demoleras",
	"demolerats",
	"demoniseras",
	"demonstrerades",
	"demonstreras",
	"demonstrerats",
	"demonterades",
	"demonteras",
	"demystifieras",
	"deponeras",
	"deponerats",
	"deporterades",
	"deporteras",
	"deporterats",
	"deppas",
	"desarmerades",
	"desarmerats",
	"deserves",
	"designas",
	"designats",
	"desillusioneras",
	"desinficeras",
	"desinficerats",
	"desorienteras",
	"destabiliserades",
	"destilleras",
	"destillerats",
	"destineras",
	"destrueras",
	"detaljgranskas",
	"detaljregleras",
	"detaljstuderas",
	"detaljstyrs",
	"detekteras",
	"detroniserades",
	"detroniseras",
	"detroniserats",
	"dettalas",
	"devalverades",
	"devalveras",
	"devalverats",
	"diagnosticerades",
	"diagnosticeras",
	"diagnosticerats",
	"diagnostiserades",
	"diagnostiseras",
	"diagnostiserats",
	"diagosticeras",
	"diarieföras",
	"diarieförs",
	"diarieförts",
	"dias",
	"differentieras",
	"differentierats",
	"diggats",
	"digitaliseras",
	"digitaliserats",
	"dikats",
	"diktats",
	"dikterades",
	"dikteras",
	"dikterats",
	"dikvalificerats",
	"dimensionerades",
	"dimensioneras",
	"dimensionerats",
	"diminueras",
	"dineras",
	"diplomerades",
	"directes",
	"direktavskrivas",
	"direktavvisas",
	"direktkonfronterades",
	"direktnoterades",
	"direktsändas",
	"direktsändes",
	"direktsänds",
	"direktsänts",
	"direktteleviserades",
	"direktväljas",
	"dirigerades",
	"dirigeras",
	"dirigerats",
	"disciplineras",
	"diskades",
	"diskas",
	"diskats",
	"diskonterades",
	"diskonteras",
	"diskonterats",
	"diskrediterades",
	"diskrediterats",
	"diskriminerades",
	"diskrimineras",
	"diskriminerats",
	"diskuterades",
	"diskuteras",
	"diskuterats",
	"diskvalificerades",
	"diskvalificeras",
	"diskvalificerats",
	"disponerades",
	"disponeras",
	"disponerats",
	"disputerades",
	"dissekerades",
	"dissekeras",
	"dissekerats",
	"dissikerades",
	"distanserades",
	"distanseras",
	"distraheras",
	"distribuerades",
	"distribueras",
	"distribuerats",
	"distribureras",
	"dites",
	"dittransporterats",
	"diversifieras",
	"divideras",
	"dividerats",
	"djäklas",
	"djärvas",
	"djärvdes",
	"djärves",
	"djävlades",
	"djävlas",
	"djilas",
	"djupdykas",
	"djupfrysas",
	"djupfryses",
	"djupintervjuas",
	"djupintervjuats",
	"dödades",
	"dödas",
	"dödats",
	"dödförklarades",
	"dödförklaras",
	"dödförklarats",
	"dödskallemärkas",
	"dogs",
	"dokes",
	"dokumenterades",
	"dokumenteras",
	"dokumenterats",
	"doldes",
	"döljas",
	"döljs",
	"döljts",
	"dollarras",
	"dolts",
	"domarbedömas",
	"dömas",
	"domderas",
	"dömdes",
	"dömes",
	"domesticeras",
	"domesticerats",
	"dominerades",
	"domineras",
	"dominerats",
	"dompteras",
	"döms",
	"dömts",
	"donerades",
	"doneras",
	"donerats",
	"döpas",
	"dopingtestades",
	"dopingtestas",
	"doppades",
	"doppas",
	"doppats",
	"döps",
	"döptes",
	"döpts",
	"doserades",
	"doseras",
	"douradores",
	"dövades",
	"dövas",
	"dövats",
	"dövtolkas",
	"drabbades",
	"drabbas",
	"drabbats",
	"drabbbades",
	"dracks",
	"draftades",
	"draftas",
	"dragas",
	"dragits",
	"dramatiseras",
	"dramatiserats",
	"drämdes",
	"dränerades",
	"dräneras",
	"dränerats",
	"dränkas",
	"dränkes",
	"dränks",
	"dränktes",
	"dränkts",
	"dräpas",
	"draperades",
	"draperas",
	"draperats",
	"dräps",
	"dräptes",
	"dras",
	"dreams",
	"drejades",
	"drejats",
	"dressas",
	"dresseras",
	"dresserats",
	"dressyrbas",
	"drevades",
	"drevs",
	"dribblades",
	"dribblas",
	"dribblats",
	"drickas",
	"drickes",
	"drillades",
	"drillas",
	"drillats",
	"drivas",
	"drives",
	"drivgas",
	"drivits",
	"drivs",
	"drogades",
	"drogas",
	"drogats",
	"drogs",
	"drogtestats",
	"drömdes",
	"drömmas",
	"droppades",
	"druckits",
	"drukpas",
	"dryftades",
	"dryftas",
	"dryftats",
	"drygades",
	"dubbas",
	"dubbats",
	"dubbelexponeras",
	"dubbelriktas",
	"dubblades",
	"dubblas",
	"dubblats",
	"dubblerades",
	"dubbleras",
	"dubblerats",
	"dukades",
	"dukas",
	"dukats",
	"dumpades",
	"dumpas",
	"dumpats",
	"dunas",
	"dundrades",
	"dundras",
	"dunkades",
	"dunkas",
	"duperades",
	"duperas",
	"duperats",
	"duplicerades",
	"durres",
	"duschades",
	"duschas",
	"dvaldes",
	"dväljs",
	"dvalts",
	"dyrkades",
	"dyrkas",
	"ebbas",
	"effektiverades",
	"effektiveras",
	"effektiviserades",
	"effektiviseras",
	"effektiviserats",
	"effektueras",
	"effektureras",
	"efteranmäldes",
	"efterbildas",
	"efterföljas",
	"efterföljdes",
	"efterföljs",
	"efterfrågades",
	"efterfrågas",
	"efterfrågats",
	"efterhördes",
	"efterkomposteras",
	"efterlämnades",
	"efterlämnas",
	"efterlevas",
	"efterlevdes",
	"efterlevs",
	"efterliknats",
	"efterlysas",
	"efterlyses",
	"efterlystes",
	"efterlysts",
	"eftersänds",
	"eftersänts",
	"eftersättas",
	"eftersattes",
	"eftersatts",
	"eftersätts",
	"efterskänkas",
	"eftersökas",
	"eftersöks",
	"eftersöktes",
	"efterspanas",
	"eftersträvades",
	"eftersträvas",
	"eftersynkroniseras",
	"eftertaxerades",
	"efterträdas",
	"efterträddes",
	"efterträdes",
	"efterträds",
	"efterträtts",
	"eggades",
	"eggas",
	"eggers",
	"ekas",
	"ekiperats",
	"eklärerades",
	"eklaterades",
	"eklateras",
	"eklaterats",
	"eldades",
	"eldas",
	"eldats",
	"eldhärjades",
	"eldhärjas",
	"eldhärjats",
	"elektras",
	"elektrifierades",
	"elektrifieras",
	"eliminerades",
	"elimineras",
	"eliminerats",
	"elitiseras",
	"ellerströms",
	"emballerades",
	"emitterades",
	"emitteras",
	"emotsågs",
	"emotses",
	"emottagas",
	"emottas",
	"emtungas",
	"enades",
	"enas",
	"enats",
	"engagerades",
	"engageras",
	"engagerats",
	"engagererats",
	"engells",
	"enhetliggöras",
	"enkelriktades",
	"enkelriktas",
	"enkelriktats",
	"enleverades",
	"enleveras",
	"enrollerades",
	"enrolleras",
	"enrollerats",
	"enskommits",
	"entledigades",
	"entledigas",
	"entledigats",
	"entusiasmeras",
	"envisades",
	"envisats",
	"erades",
	"erbjöds",
	"erbjudas",
	"erbjudes",
	"erbjudits",
	"erbjuds",
	"erfaras",
	"erfodras",
	"erfordrades",
	"erfordras",
	"erfors",
	"erhållas",
	"erhålles",
	"erhållits",
	"erhålls",
	"erhölls",
	"erinrades",
	"erinras",
	"erkändes",
	"erkännas",
	"erkännes",
	"erkännnas",
	"erkänns",
	"erkänts",
	"erlades",
	"erläggas",
	"erlägges",
	"erläggs",
	"erlagts",
	"eroderas",
	"erotiseras",
	"erövrades",
	"erövras",
	"erövrats",
	"ersättas",
	"ersattes",
	"ersättes",
	"ersatts",
	"ersätts",
	"ertappades",
	"ertappas",
	"ertappats",
	"esbjörs",
	"eskaleras",
	"eskorterades",
	"eskorteras",
	"eskorterats",
	"esseltes",
	"estetiseras",
	"etablerades",
	"etableras",
	"etablerats",
	"etappindelas",
	"etiketterades",
	"etiketteras",
	"etnifieras",
	"etnifierats",
	"etsades",
	"etsas",
	"eudokias",
	"europeiseras",
	"europes",
	"evakuerades",
	"evakueras",
	"evakuerats",
	"evalueras",
	"everglades",
	"evkuerats",
	"examinerades",
	"examineras",
	"examinerats",
	"exekverades",
	"exekveras",
	"exemplifieras",
	"exkluderas",
	"exkluderats",
	"exkommuniceras",
	"expanderas",
	"expedierades",
	"expedieras",
	"experimenterades",
	"experimenteras",
	"experimenterats",
	"explicitgjorts",
	"exploaterades",
	"exploateras",
	"exploaterats",
	"exponerades",
	"exponeras",
	"exponerats",
	"exporterades",
	"exporteras",
	"exporterats",
	"expropieras",
	"exproprierades",
	"exproprieras",
	"extrainkallas",
	"extraskjuts",
	"fackbas",
	"fägnats",
	"fajtades",
	"fajtas",
	"fajtats",
	"fäktades",
	"fäktas",
	"fakturerades",
	"faktureras",
	"fakturerats",
	"fållas",
	"fällas",
	"fälldes",
	"falles",
	"falls",
	"fälls",
	"fällts",
	"falsifieras",
	"fältprovas",
	"famnas",
	"fångades",
	"fångas",
	"fångats",
	"fängslades",
	"fängslas",
	"fängslats",
	"fanzines",
	"fårades",
	"färas",
	"fårats",
	"färdigbehandlas",
	"färdigförhandlades",
	"färdigrepareras",
	"färdigspelades",
	"färdigspelas",
	"färdigspelats",
	"färdigställas",
	"färdigställdes",
	"färdigställs",
	"färdigställts",
	"färdigutrustas",
	"fares",
	"färgades",
	"färgas",
	"färgats",
	"färgläggas",
	"färgläggs",
	"färgsättas",
	"färgsattes",
	"färgsätts",
	"färjades",
	"färjas",
	"farpas",
	"fås",
	"fasadputsas",
	"fasas",
	"fascinerades",
	"fascineras",
	"fascinerats",
	"fassetts",
	"fästas",
	"fästes",
	"fastlades",
	"fastläggas",
	"fastlagts",
	"fastnades",
	"fästs",
	"fastslagits",
	"fastslås",
	"fastslogs",
	"fastställas",
	"fastställdes",
	"fastställs",
	"fastställts",
	"fattades",
	"fattats",
	"fattiggjorts",
	"fåtts",
	"favoriserades",
	"favoriseras",
	"favoriserats",
	"favoritspelas",
	"faxades",
	"faxats",
	"fejas",
	"felbalanserades",
	"felbedöms",
	"felbetonades",
	"felciteras",
	"felkopplas",
	"felsökas",
	"feltolkades",
	"feltolkas",
	"feltolkats",
	"femdubblades",
	"femdubblas",
	"femdubblats",
	"femfaldigades",
	"femfaldigats",
	"feminiseras",
	"femmes",
	"fermentas",
	"fernissas",
	"fes",
	"festades",
	"festas",
	"festes",
	"festplats",
	"fickparkeras",
	"fifflas",
	"fightades",
	"fightas",
	"fightats",
	"figueras",
	"figureras",
	"fikas",
	"fiktionaliserats",
	"filas",
	"filmades",
	"filmas",
	"filmatiserades",
	"filmatiseras",
	"filmatiserats",
	"filmats",
	"filmtricks",
	"filotas",
	"filtreras",
	"filtrerats",
	"fimpas",
	"fimpats",
	"finalbesegrades",
	"finalbrottas",
	"finaniseras",
	"finanseras",
	"finanserats",
	"finanserias",
	"finansierades",
	"finansieras",
	"finansierats",
	"finansierieras",
	"finfördelats",
	"fingeras",
	"fingranskas",
	"fininställas",
	"fininställs",
	"finjusteras",
	"finkammades",
	"finkammas",
	"finkammats",
	"finkrattats",
	"finnes",
	"finnns",
	"finputsas",
	"finputsats",
	"finslipas",
	"finslipats",
	"fintades",
	"fintas",
	"firades",
	"firas",
	"firats",
	"fiskades",
	"fiskas",
	"fiskats",
	"fixades",
	"fixas",
	"fixats",
	"fixerades",
	"fixeras",
	"fixerats",
	"fjärmas",
	"fjärrstyras",
	"fjärrstyrs",
	"fjärtas",
	"fjäskas",
	"fjättrades",
	"fjättrats",
	"fläckades",
	"fläckas",
	"fläckats",
	"flåddes",
	"flaggades",
	"flaggas",
	"flaggats",
	"fläkas",
	"flakes",
	"flamberats",
	"flankerades",
	"flankeras",
	"flätades",
	"flätas",
	"flätats",
	"flerdubblades",
	"flerdubblas",
	"flerdubblats",
	"flerfaldigas",
	"flerfaldigats",
	"flintstones",
	"flirtas",
	"flögs",
	"flörtas",
	"flottades",
	"flugits",
	"flyers",
	"flygas",
	"flygbesprutas",
	"flygbombades",
	"flygbombas",
	"flygbombats",
	"flygfotograferades",
	"flygpats",
	"flygs",
	"flyttades",
	"flyttas",
	"flyttats",
	"fnissas",
	"fnissats",
	"fnös",
	"fnystes",
	"födas",
	"födddes",
	"föddes",
	"föds",
	"fogades",
	"fogas",
	"fogats",
	"fögelkes",
	"föjdes",
	"fokuserades",
	"fokuseras",
	"fokuserats",
	"föläggs",
	"följas",
	"följdes",
	"följs",
	"följts",
	"folkas",
	"fonderades",
	"fonderas",
	"fonderats",
	"fönsterspröjs",
	"förädlades",
	"förädlas",
	"förädlats",
	"föraktades",
	"föraktas",
	"föraktats",
	"föräldrarsomdeklasserats",
	"förändats",
	"förändrades",
	"förändrarts",
	"forandras",
	"förändras",
	"forändrats",
	"förändrats",
	"förångades",
	"förångas",
	"förångats",
	"förankrades",
	"förankras",
	"förankrats",
	"föranledas",
	"föranleddes",
	"föranleds",
	"föranletts",
	"föranmälts",
	"förannonserats",
	"föranstaltades",
	"förärades",
	"föräras",
	"förärats",
	"förargas",
	"förargats",
	"föras",
	"förbands",
	"förbannades",
	"förbannas",
	"förbannats",
	"förbättrades",
	"förbättras",
	"förbättrats",
	"förbegicks",
	"förbehållas",
	"förbehållits",
	"förbehålls",
	"förbehandlas",
	"förbehölls",
	"förberdas",
	"förberedas",
	"förbereddes",
	"förberedes",
	"förbereds",
	"förberetts",
	"förbeställas",
	"förbeställts",
	"förbigås",
	"förbigåtts",
	"förbigicks",
	"förbindas",
	"förbinds",
	"förbisågs",
	"förbises",
	"förbisetts",
	"förbittrades",
	"förbjöds",
	"förbjudas",
	"förbjudes",
	"förbjudits",
	"förbjuds",
	"förblandades",
	"förblandas",
	"förblindades",
	"förblindas",
	"förblindats",
	"förbluffades",
	"förbluffas",
	"förborgerligades",
	"förborgerligas",
	"förborgerligats",
	"förbrändes",
	"förbrännas",
	"förbränns",
	"förbränts",
	"förbrödrades",
	"förbrödras",
	"förbrukades",
	"förbrukas",
	"förbrukats",
	"förbryllades",
	"förbryllas",
	"förbryllats",
	"förbuskats",
	"förbyggts",
	"förbytas",
	"förbyts",
	"förbyttes",
	"förbytts",
	"forcerades",
	"forceras",
	"forcerats",
	"fördärvades",
	"fördärvas",
	"fördärvats",
	"fördelades",
	"fördelas",
	"fördelats",
	"fördeltas",
	"fördes",
	"fördjupades",
	"fördjupas",
	"fördjupats",
	"fördömas",
	"fördömdes",
	"fördöms",
	"fördömts",
	"fordrades",
	"fördragas",
	"fördrages",
	"fordras",
	"fördras",
	"fordrats",
	"fördrevs",
	"fördrivas",
	"fördrivits",
	"fördrivs",
	"fördröjas",
	"fördröjdes",
	"fördröjes",
	"fördröjs",
	"fördröjts",
	"fördubblades",
	"fördubblas",
	"fördubblats",
	"fördummas",
	"fördunklades",
	"fördunklas",
	"fördunklats",
	"fördyrades",
	"fördyras",
	"fördyrats",
	"fördystrades",
	"förebådades",
	"förebådas",
	"förebådats",
	"föreberedas",
	"förebragts",
	"förebrås",
	"förebyggas",
	"förebyggs",
	"föredömdes",
	"föredrages",
	"föredras",
	"föredrogs",
	"föregås",
	"föregåtts",
	"föregicks",
	"föregreps",
	"föregripits",
	"föregrips",
	"föreknippas",
	"förekommas",
	"förekommits",
	"förelades",
	"föreläggas",
	"föreläggs",
	"förelagts",
	"förelås",
	"förelästes",
	"förenades",
	"förenas",
	"förenats",
	"förenhetligas",
	"förenklades",
	"förenklas",
	"förenklats",
	"föres",
	"föreskrevs",
	"föreskrivas",
	"föreskrivs",
	"föreslagits",
	"föreslås",
	"föreslogs",
	"förespås",
	"förespeglades",
	"förespeglas",
	"förespeglats",
	"förespråkades",
	"förespråkas",
	"förespråkats",
	"föreställas",
	"föreställdes",
	"föreställs",
	"förestås",
	"förestods",
	"forests",
	"företagas",
	"företagits",
	"företas",
	"företeddes",
	"företogs",
	"företrädas",
	"företräddes",
	"företräds",
	"förevigades",
	"förevigas",
	"förevigats",
	"förevisades",
	"förevisas",
	"förevisats",
	"förfäktas",
	"förfalskades",
	"förfalskas",
	"förfalskats",
	"förfärades",
	"förfäras",
	"förfärats",
	"förfärdigades",
	"förfärdigats",
	"förfares",
	"förfasades",
	"förfasas",
	"författades",
	"författas",
	"författats",
	"förfelades",
	"förfelas",
	"förfinades",
	"förfinas",
	"förfinats",
	"förfinskas",
	"förflackas",
	"förflackats",
	"förflyktats",
	"förflyktigades",
	"förflyktigas",
	"förflyktigats",
	"förflyttades",
	"förflyttas",
	"förflyttats",
	"förföljas",
	"förföljdes",
	"förföljs",
	"förföljts",
	"förföras",
	"förfördelas",
	"förfördes",
	"förförs",
	"förförts",
	"förfranskas",
	"förfrös",
	"förfulas",
	"förfulats",
	"förfuskades",
	"förfuskas",
	"förfuskats",
	"förgasades",
	"förgasas",
	"förgasats",
	"förgiftades",
	"förgiftas",
	"förgiftats",
	"förglömmas",
	"förgöras",
	"förgrovades",
	"förgrovas",
	"förgrovats",
	"förgrymmas",
	"förgubbas",
	"förgudas",
	"förgylldes",
	"förgylls",
	"förgyllts",
	"förhalades",
	"förhalas",
	"förhalats",
	"förhållas",
	"förhånades",
	"förhånas",
	"förhånats",
	"förhandlades",
	"förhandlas",
	"förhandlats",
	"förhandscensureras",
	"förhandsetiketteras",
	"förhandsgranskas",
	"förhandsnomineras",
	"förhandsvisades",
	"förhärdas",
	"förhärligades",
	"förhärligas",
	"förhäxas",
	"förhindrades",
	"förhindras",
	"förhindrats",
	"förhöjas",
	"förhöjs",
	"förhöras",
	"förhördes",
	"förhörs",
	"förhörts",
	"förintades",
	"förintas",
	"förintats",
	"förjagas",
	"förkalkas",
	"förkapslats",
	"förkastades",
	"förkastas",
	"förkastats",
	"förkläds",
	"förklarades",
	"förklarars",
	"förklaras",
	"förklarats",
	"förknippades",
	"förknippas",
	"förknippats",
	"förkortades",
	"förkortas",
	"förkortats",
	"förkroppsligas",
	"förkrossas",
	"förkunnades",
	"förkunnas",
	"förkunnats",
	"förkvävas",
	"förkvävs",
	"förlades",
	"förläggas",
	"förläggs",
	"förlagts",
	"förlamades",
	"förlamas",
	"förlamats",
	"förlänades",
	"förlänas",
	"förlänats",
	"förlängas",
	"förlängdes",
	"förlängs",
	"förlängts",
	"förlåtas",
	"förlåts",
	"förläts",
	"förledas",
	"förledes",
	"förleds",
	"förletts",
	"förlikades",
	"förlikas",
	"förlikats",
	"förliknas",
	"förliks",
	"förliktes",
	"förlikts",
	"förljuvades",
	"förlöjligades",
	"förlöjligas",
	"förlöjligats",
	"förlorades",
	"förloras",
	"förlorats",
	"förlösas",
	"förlöses",
	"förlöstes",
	"förlustanmälas",
	"förmåddes",
	"formades",
	"formaliserades",
	"formaliseras",
	"förmanades",
	"förmanas",
	"förmånsbeskattades",
	"förmånsbeskattas",
	"förmänskligades",
	"förmänskligas",
	"förmärkas",
	"förmärks",
	"förmärktes",
	"förmärkts",
	"formas",
	"förmås",
	"formats",
	"förmåtts",
	"förmedlades",
	"förmedlas",
	"förmedlats",
	"förmenades",
	"förmenas",
	"förmenats",
	"formerades",
	"formeras",
	"förmeras",
	"formerats",
	"förmerats",
	"formges",
	"formgetts",
	"formgivits",
	"förminskades",
	"förminskas",
	"förminskats",
	"förmodades",
	"förmodas",
	"förmögenhetsbeskattas",
	"förmörkades",
	"förmörkas",
	"förmörkats",
	"formsprutas",
	"formulerades",
	"formuleras",
	"formulerats",
	"förnams",
	"förnedrades",
	"förnedras",
	"förnedrats",
	"förnekades",
	"förnekas",
	"förnekats",
	"förnimmas",
	"förnims",
	"förnöjts",
	"förnyades",
	"förnyas",
	"förnyats",
	"förödas",
	"föröddes",
	"förödes",
	"förodlas",
	"förödmjukades",
	"förödmjukas",
	"förödmjukats",
	"föröds",
	"förökas",
	"förökats",
	"förolämpas",
	"förolämpats",
	"förolyckades",
	"förolyckas",
	"förolyckats",
	"förolycklades",
	"förorättats",
	"förordades",
	"förordas",
	"förordats",
	"förordnades",
	"förordnas",
	"förordnats",
	"förorenas",
	"förorenats",
	"förorsakades",
	"förorsakas",
	"förorsakats",
	"förövades",
	"förövas",
	"förövats",
	"förpackades",
	"förpackas",
	"förpackats",
	"förpassades",
	"förpassas",
	"förpassats",
	"förpasssades",
	"förpestades",
	"förpestas",
	"förpliktades",
	"förpliktas",
	"förpuppades",
	"förpuppas",
	"förråats",
	"förrådas",
	"förråddes",
	"förräntas",
	"förrättades",
	"förrättas",
	"förrättats",
	"förringades",
	"förringas",
	"förringats",
	"förrycks",
	"förrycktes",
	"fors",
	"förs",
	"försågs",
	"försakas",
	"försäkrades",
	"försäkras",
	"försäkrats",
	"försåldes",
	"försäljas",
	"försäljes",
	"församhälleligats",
	"församlades",
	"försämrades",
	"försämras",
	"försämrats",
	"försänkas",
	"försättas",
	"försattes",
	"försatts",
	"försätts",
	"förseglades",
	"förseglats",
	"forselles",
	"försenades",
	"försenas",
	"försenats",
	"förses",
	"försetts",
	"försinkas",
	"forskades",
	"forskas",
	"forskats",
	"förskingrades",
	"förskingras",
	"förskingrats",
	"förskjöts",
	"förskjutas",
	"förskjutits",
	"förskjuts",
	"förskonades",
	"förskonas",
	"förskönas",
	"förskonats",
	"förskönats",
	"försköts",
	"förskräckas",
	"förskräckes",
	"förskräcks",
	"förskrivas",
	"förskrivits",
	"förskrivs",
	"forslades",
	"förslagits",
	"förslappats",
	"forslas",
	"förslås",
	"forslats",
	"förslavas",
	"förslavats",
	"förslits",
	"förslöats",
	"förslogs",
	"förslösades",
	"förslösas",
	"förslösats",
	"förslummades",
	"förslummas",
	"förslutits",
	"försmåddes",
	"försnävas",
	"försnillas",
	"försökas",
	"försöktes",
	"försonades",
	"försonas",
	"försonats",
	"försörjas",
	"försörjdes",
	"försörjs",
	"försörjts",
	"förspillas",
	"förspilldes",
	"förspills",
	"förspordes",
	"försports",
	"försprödas",
	"förstärkas",
	"förstärks",
	"förstärktes",
	"förstärkts",
	"förstås",
	"förståss",
	"förstatligades",
	"förstatligas",
	"förstatligats",
	"förståtts",
	"förstenades",
	"förstenas",
	"förstods",
	"förstoppas",
	"förstorades",
	"förstoras",
	"förstöras",
	"förstorats",
	"förstördes",
	"förstörs",
	"förstörts",
	"förströddes",
	"förströs",
	"förstuckits",
	"förstummades",
	"förstummas",
	"förstummats",
	"försummades",
	"försummas",
	"försummats",
	"försumpats",
	"försuras",
	"försvagades",
	"försvagas",
	"försvagats",
	"försvarades",
	"försvårades",
	"försvaras",
	"försvåras",
	"försvarats",
	"försvårats",
	"försvenskas",
	"försvenskats",
	"försvunnes",
	"förtages",
	"förtalas",
	"förtalats",
	"förtäljas",
	"förtamats",
	"förtäras",
	"förtärdes",
	"förtärs",
	"förtärts",
	"förtas",
	"förtås",
	"förtätades",
	"förtätas",
	"förtätats",
	"fortbildas",
	"förtecknas",
	"förtecknats",
	"förtegs",
	"förtidsinlösas",
	"förtidspensionerades",
	"förtidspensioneras",
	"förtidspensionerats",
	"förtigas",
	"förtiges",
	"förtigits",
	"förtigs",
	"förtingligas",
	"förtjänas",
	"förtjänats",
	"förtjusas",
	"förtjustes",
	"förtöjas",
	"förtöjdes",
	"förtöjs",
	"förtorkats",
	"fortplantades",
	"fortplantas",
	"förtrampades",
	"förträngas",
	"förträngs",
	"förtrollades",
	"förtrollas",
	"förtröttades",
	"förtröttas",
	"förtröttats",
	"förtryckas",
	"förtrycks",
	"förtrycktes",
	"förtryckts",
	"förts",
	"fortsättas",
	"fortsattes",
	"förtullades",
	"förtullas",
	"förtunnades",
	"förtunnas",
	"förtydligades",
	"förtydligas",
	"förundrades",
	"förundradts",
	"förundras",
	"förundrats",
	"förunnades",
	"förunnas",
	"förunnats",
	"förustspås",
	"förutbestäms",
	"förutsades",
	"förutsägas",
	"förutsågs",
	"förutsägs",
	"förutsagts",
	"förutsättas",
	"förutsattes",
	"förutsättes",
	"förutsatts",
	"förutsätts",
	"förutses",
	"förutsetts",
	"förutskickades",
	"förutskickas",
	"förutspåddes",
	"förutspås",
	"förutspåtts",
	"förvägrades",
	"förvägras",
	"förvägrats",
	"förvälls",
	"förvaltades",
	"förvaltas",
	"förvaltats",
	"förvånades",
	"förvånas",
	"förvånats",
	"förvandlades",
	"förvandlas",
	"förvandlats",
	"förvänds",
	"förvanskades",
	"förvanskas",
	"förvanskats",
	"förväntades",
	"förväntas",
	"förväntats",
	"förvarades",
	"förvaras",
	"förvarats",
	"förvärms",
	"förvarnas",
	"förvarnats",
	"förvärrades",
	"förvärras",
	"förvärrats",
	"förvärvades",
	"förvärvas",
	"förvärvats",
	"förväxlades",
	"förväxlas",
	"förväxlats",
	"förvedas",
	"förvekligades",
	"förvekligas",
	"förverkas",
	"förverkats",
	"förverkligades",
	"förverkligas",
	"förverkligats",
	"förvillas",
	"förvirrades",
	"förvirras",
	"förvisades",
	"förvisas",
	"förvisats",
	"förvissades",
	"förvrängas",
	"förvrängdes",
	"förvrängs",
	"förvrängts",
	"förvreds",
	"förvridas",
	"förvridits",
	"förvrids",
	"föryngrades",
	"föryngras",
	"föryngrats",
	"fös",
	"fösas",
	"föses",
	"fosforyleras",
	"föstes",
	"fostrades",
	"fostras",
	"fostrats",
	"fösts",
	"fotats",
	"fotodokumenterades",
	"fotograferades",
	"fotograferas",
	"fotograferats",
	"fotokopieras",
	"fötts",
	"frågades",
	"frågasättas",
	"frågats",
	"fragmenteras",
	"fragmentiserades",
	"fraktades",
	"fraktas",
	"fraktats",
	"fräls",
	"frälsas",
	"framarbetats",
	"frambäras",
	"frambäres",
	"frambesvärjas",
	"frambesvärjs",
	"frambringats",
	"framdrivits",
	"framflyttats",
	"framföras",
	"framfördes",
	"framföres",
	"framförhandlades",
	"framförhandlats",
	"framförs",
	"framförts",
	"framfötts",
	"framhållas",
	"framhålles",
	"framhållits",
	"framhålls",
	"framhävas",
	"framhävdes",
	"framhävs",
	"framhölls",
	"främjades",
	"främjas",
	"främjats",
	"framkallades",
	"framkallas",
	"framkallats",
	"framkastades",
	"framkastas",
	"framlades",
	"framläggas",
	"framlagts",
	"framledes",
	"frammanas",
	"framräknas",
	"framräknats",
	"framställas",
	"framställdes",
	"framställs",
	"framställts",
	"framtagits",
	"framtvingas",
	"framtvingats",
	"frångås",
	"frånhändas",
	"frånkännas",
	"frankeras",
	"frankerats",
	"frånräknas",
	"fransats",
	"fråntagits",
	"fråntas",
	"fråntogs",
	"frapperades",
	"frapperas",
	"frapperats",
	"fräs",
	"fräschades",
	"fräschats",
	"fräses",
	"frästs",
	"fräts",
	"frättes",
	"frätts",
	"fredades",
	"fredas",
	"freddes",
	"fredells",
	"fredrikornas",
	"frekvensplaneras",
	"frekventerades",
	"frekventeras",
	"freongas",
	"frestades",
	"frestas",
	"frestats",
	"friades",
	"frias",
	"friats",
	"friderikas",
	"fridlysas",
	"fridlyses",
	"fridlystes",
	"frigavs",
	"friges",
	"frigetts",
	"frigivits",
	"frigjordes",
	"frigjorts",
	"frigöras",
	"frigöres",
	"frigörs",
	"frihetsberövades",
	"frikändes",
	"frikännas",
	"frikänns",
	"frikänts",
	"friklassas",
	"frikopplades",
	"frikopplas",
	"frikopplats",
	"friköptes",
	"frilades",
	"friläggas",
	"friläggs",
	"frisätts",
	"friserades",
	"friseras",
	"friserats",
	"friskförklarats",
	"frisläppas",
	"frisläpps",
	"frisläpptes",
	"frisläppts",
	"frisöranställdas",
	"frispelades",
	"friställas",
	"friställdes",
	"friställs",
	"friställts",
	"fritagits",
	"fritällts",
	"fritas",
	"friteras",
	"friterats",
	"fritidshemsplats",
	"fritogs",
	"frodades",
	"frodas",
	"frodats",
	"fröjdades",
	"fröjdas",
	"frölundagrabbarnas",
	"frontalpressades",
	"frös",
	"frossas",
	"frössvettades",
	"frostats",
	"frotterades",
	"frotteras",
	"frotterats",
	"frubjudas",
	"fruktades",
	"fruktas",
	"fruktats",
	"fruktmos",
	"frusits",
	"frustrerades",
	"frustreras",
	"frys",
	"frysas",
	"fryses",
	"frystes",
	"frysts",
	"fudgsicles",
	"fuentes",
	"fuktades",
	"fuktats",
	"fulländades",
	"fulländas",
	"fullbordades",
	"fullbordas",
	"fullbordats",
	"fullföljas",
	"fullföljdes",
	"fullföljs",
	"fullföljts",
	"fullförts",
	"fullgjorts",
	"fullgöras",
	"fullgörs",
	"fullkomnas",
	"fullkomnats",
	"funderades",
	"funderas",
	"funderats",
	"funnes",
	"fusionerades",
	"fusioneras",
	"fusionerats",
	"fuskades",
	"fuskas",
	"fuskats",
	"fylkades",
	"fylkas",
	"fylkats",
	"fyllas",
	"fylldes",
	"fylles",
	"fylls",
	"fyllts",
	"fyndas",
	"fyrdubblades",
	"fyrdubblas",
	"fyrdubblats",
	"fyrfaldigades",
	"gäckades",
	"gäckas",
	"gäckats",
	"gafflas",
	"gagnades",
	"gagnas",
	"gagnats",
	"galas",
	"gäldas",
	"gäldats",
	"gales",
	"gallottas",
	"gallras",
	"gallrats",
	"galopperades",
	"gals",
	"gammeldags",
	"gängas",
	"gapas",
	"garanterades",
	"garanteras",
	"garanterats",
	"garderas",
	"garnerades",
	"garneras",
	"garrotterades",
	"garvats",
	"gås",
	"gasades",
	"gasas",
	"gäspas",
	"gastades",
	"gästades",
	"gästas",
	"gästats",
	"gastkramades",
	"gastkramats",
	"gåtts",
	"gaulles",
	"gauloises",
	"gavs",
	"geddes",
	"geels",
	"gefundenes",
	"gekås",
	"genas",
	"generades",
	"generaliseras",
	"generas",
	"genererades",
	"genereras",
	"genererats",
	"geniförklarades",
	"geniförklarats",
	"genmanipuleras",
	"genmanipulerats",
	"genmföras",
	"gennes",
	"genomblåsts",
	"genomborrades",
	"genomborras",
	"genomborrats",
	"genombröts",
	"genombrutits",
	"genomdrevs",
	"genomdrivas",
	"genomfares",
	"genomfars",
	"genomföras",
	"genomfördes",
	"genomfors",
	"genomförs",
	"genomförts",
	"genomgås",
	"genomgörs",
	"genomkorsades",
	"genomkorsas",
	"genomläsas",
	"genomleds",
	"genomlidas",
	"genomlidits",
	"genomlids",
	"genomlysas",
	"genomskådades",
	"genomskådas",
	"genomskådats",
	"genomskärs",
	"genomsköljdes",
	"genomsökas",
	"genomsöks",
	"genomsöktes",
	"genomsökts",
	"genomströmmades",
	"genomströmmas",
	"genomsyrades",
	"genomsyras",
	"genrebestämmas",
	"gensköts",
	"geomfördes",
	"ges",
	"gestaltades",
	"gestaltas",
	"gestaltats",
	"getts",
	"gicks",
	"giftas",
	"giftes",
	"giftmördas",
	"gifts",
	"gillades",
	"gillas",
	"gillrades",
	"gillras",
	"gills",
	"giltigförklarats",
	"gipsas",
	"gipsats",
	"gissas",
	"gisslas",
	"givas",
	"gives",
	"givits",
	"givs",
	"gjirokastras",
	"gjordes",
	"gjöres",
	"gjors",
	"gjorts",
	"gjöts",
	"gjutas",
	"gjutits",
	"gjuts",
	"gladdes",
	"glädjas",
	"glädjs",
	"gläds",
	"glammas",
	"glamourdags",
	"gläns",
	"gläntades",
	"glasas",
	"glaseras",
	"glatts",
	"glesades",
	"glesas",
	"globaliseras",
	"glömmas",
	"glömmes",
	"glöms",
	"glorifierades",
	"glorifieras",
	"glunkas",
	"gnabbades",
	"gnabbandes",
	"gnagdes",
	"gnags",
	"gnällts",
	"gneds",
	"gnetas",
	"gnidas",
	"gnidits",
	"gnids",
	"gnisslas",
	"gnolas",
	"gnolats",
	"gnuggades",
	"gnuggas",
	"gnuggats",
	"gödas",
	"godkändes",
	"godkännas",
	"godkännes",
	"godkänns",
	"godkänts",
	"gödslades",
	"gödslas",
	"gödslats",
	"godspelas",
	"godtagas",
	"godtagits",
	"godtas",
	"godtogs",
	"golas",
	"golvades",
	"golvats",
	"gömdes",
	"gömmas",
	"göms",
	"gömts",
	"göras",
	"göres",
	"görs",
	"gosas",
	"götas",
	"götes",
	"göts",
	"gottgöras",
	"gottgörs",
	"gräddades",
	"gräddas",
	"gräddsås",
	"graderas",
	"graderats",
	"grälas",
	"grälats",
	"grämas",
	"grammisbelönats",
	"grändes",
	"granquists",
	"granskades",
	"granskas",
	"granskats",
	"gränsöverskrids",
	"gråtas",
	"gratineras",
	"gratinerats",
	"gråts",
	"gräts",
	"grattas",
	"gratulerades",
	"gratuleras",
	"grävas",
	"grävdes",
	"graveras",
	"graverats",
	"grävs",
	"gravsättas",
	"gravsattes",
	"gravsatts",
	"gravsätts",
	"grävts",
	"grejades",
	"greps",
	"grigorjevs",
	"grillas",
	"grillats",
	"grimaseras",
	"gripas",
	"gripes",
	"gripits",
	"grips",
	"groggys",
	"gröps",
	"gröpts",
	"gros",
	"grovhackas",
	"grovindelas",
	"grubblas",
	"grumlades",
	"grumlas",
	"grummes",
	"grundades",
	"grundas",
	"grundats",
	"grundförstärkas",
	"grundlades",
	"grundläggas",
	"grundlägges",
	"grundläggs",
	"grundlagsfästas",
	"grundlagts",
	"grundlurades",
	"grundlurats",
	"grundutbildas",
	"grundutbildats",
	"grupperades",
	"grupperas",
	"grupperats",
	"gruppvåldtas",
	"grusades",
	"grusas",
	"grusats",
	"guidades",
	"guidas",
	"guidats",
	"gullades",
	"gungades",
	"gynnades",
	"gynnas",
	"gynnats",
	"gyttras",
	"habermas",
	"hackades",
	"hackas",
	"hackats",
	"häcklades",
	"häcklas",
	"häcklats",
	"hades",
	"haemoplas",
	"haffades",
	"haffas",
	"hafsas",
	"hägnas",
	"hägnats",
	"hagsätras",
	"hajas",
	"hakades",
	"hakas",
	"hakats",
	"hakkas",
	"häktades",
	"häktas",
	"häktats",
	"halades",
	"halas",
	"halats",
	"hållas",
	"hällas",
	"hälldes",
	"hålles",
	"hälles",
	"hållits",
	"hålls",
	"hälls",
	"hållts",
	"hällts",
	"hälsades",
	"halsas",
	"hälsas",
	"hälsats",
	"halshöggs",
	"halshuggas",
	"halshuggits",
	"halshuggs",
	"hälsningstalas",
	"halstrades",
	"halstras",
	"halvägs",
	"halverades",
	"halveras",
	"halverats",
	"halvglas",
	"halvpensioneras",
	"hamas",
	"hämmades",
	"hämmas",
	"hämmats",
	"hamnas",
	"hamrades",
	"hamras",
	"hamrats",
	"hämtades",
	"hämtas",
	"hämtats",
	"hånades",
	"hånas",
	"hånats",
	"handelsstoppades",
	"handhas",
	"handikappades",
	"handikappanpassas",
	"handikappas",
	"handlades",
	"handläggas",
	"handläggs",
	"handlagts",
	"handlas",
	"handlats",
	"handlingsförlamas",
	"handplockades",
	"handplockas",
	"handplockats",
	"handskadades",
	"handskades",
	"handskas",
	"handskats",
	"handvevas",
	"hänföras",
	"hänfördes",
	"hänförs",
	"hänförts",
	"hängas",
	"hängdes",
	"hänges",
	"hängs",
	"hängts",
	"hanhals",
	"hanns",
	"hänryckas",
	"hanses",
	"hänskjutas",
	"hänskjutits",
	"hänskjuts",
	"hänsköts",
	"hånskrattas",
	"hanterades",
	"hanteras",
	"hanterats",
	"hänvisades",
	"hänvisas",
	"hänvisats",
	"harangerades",
	"harangeras",
	"härbärgerades",
	"härbärgeras",
	"härbärgerats",
	"härdades",
	"härdas",
	"härdats",
	"hårdbantas",
	"hårdbevakas",
	"hårddrillas",
	"hårdexploaterats",
	"hårdgranskas",
	"hårdlanserades",
	"hårdlanseras",
	"hårdpumpats",
	"härjades",
	"härjas",
	"härjats",
	"härledas",
	"härleds",
	"härletts",
	"harmades",
	"harmas",
	"harmonieras",
	"harmonierats",
	"harmoniseras",
	"härröras",
	"härrydas",
	"harvas",
	"has",
	"hasades",
	"hässjades",
	"hässles",
	"hastas",
	"hastats",
	"hatades",
	"hatas",
	"haussades",
	"haussas",
	"håvas",
	"hävas",
	"hävdades",
	"hävdas",
	"hävdats",
	"hävdes",
	"häves",
	"hävs",
	"hävts",
	"hedrades",
	"hedras",
	"hedrats",
	"hejas",
	"hejdades",
	"hejdas",
	"hejdats",
	"helas",
	"helgades",
	"helgarderas",
	"helgas",
	"helgonförklarades",
	"hellacopters",
	"hells",
	"helrenoverades",
	"helrenoverats",
	"helsingfors",
	"heltidsanställs",
	"helvittes",
	"hemfördes",
	"hemförlovades",
	"hemförlovas",
	"hemkallas",
	"hemlighållas",
	"hemlighållits",
	"hemlighålls",
	"hemlighölls",
	"hemligstämplades",
	"hemligstämplas",
	"hemligstämplats",
	"hemskjuts",
	"hemsökas",
	"hemsöks",
	"hemsöktes",
	"hemsökts",
	"hetsades",
	"hetsas",
	"hetsats",
	"hettades",
	"hettas",
	"hilaritas",
	"himbas",
	"himlalots",
	"hindrades",
	"hindras",
	"hindrats",
	"hinnas",
	"hinns",
	"hispaniseras",
	"hissades",
	"hissas",
	"hissats",
	"hitleriseras",
	"hittades",
	"hittas",
	"hittats",
	"hivades",
	"hivas",
	"hivinfekterades",
	"hjälpas",
	"hjälps",
	"hjälpsåtts",
	"hjälptes",
	"hjälpts",
	"hjärntvättats",
	"hjärtopereras",
	"hjärtopererats",
	"hoas",
	"höegs",
	"höggs",
	"högindustrialiseras",
	"högpromiskuösas",
	"högtalarförmedlas",
	"högtidlighållas",
	"högtidlighålls",
	"höjas",
	"höjdes",
	"höjs",
	"hojtas",
	"höjts",
	"höljas",
	"höljdes",
	"höljes",
	"holkades",
	"holkas",
	"holkats",
	"hölls",
	"hollywoodiserades",
	"homogeniserades",
	"homogeniseras",
	"honaratiores",
	"honkas",
	"honoreras",
	"honorerats",
	"hopfogades",
	"hoppasts",
	"horas",
	"höras",
	"hördes",
	"höres",
	"horisontaliseras",
	"hormonstimulerats",
	"hormontestas",
	"hörs",
	"hörsammades",
	"hörsammas",
	"hörsammats",
	"hortas",
	"hörts",
	"hotades",
	"hotas",
	"hotats",
	"hottas",
	"hottats",
	"höves",
	"hudflängas",
	"hudflängs",
	"hudflängts",
	"hudstrykas",
	"huggas",
	"huggits",
	"huggs",
	"hukandes",
	"humaniserades",
	"humaniseras",
	"humaniserats",
	"hummades",
	"hundradubblats",
	"hundratas",
	"hunnits",
	"hunsades",
	"hunsas",
	"hunsats",
	"hurrades",
	"hurras",
	"hutades",
	"hutas",
	"huttlas",
	"huttrades",
	"huttras",
	"hutus",
	"huvudstas",
	"hycklas",
	"hyfsats",
	"hygieniseras",
	"hyllades",
	"hyllas",
	"hyllats",
	"hypas",
	"hypats",
	"hyras",
	"hyrdes",
	"hyressättas",
	"hyrs",
	"hyrts",
	"hys",
	"hysas",
	"hystes",
	"hysts",
	"hyvlades",
	"hyvlas",
	"iaktas",
	"iaktatagas",
	"iakttagas",
	"iakttages",
	"iakttagits",
	"iakttas",
	"iakttogs",
	"idénförverkligades",
	"identifierades",
	"identifieras",
	"identifieratas",
	"identifierats",
	"ideologiserats",
	"idkades",
	"idkas",
	"idoliseras",
	"idrottas",
	"idrottsskadas",
	"idylliseras",
	"ifrågasättas",
	"ifrågasattes",
	"ifrågasättes",
	"ifrågasatts",
	"ifrågasätts",
	"ifrågsattes",
	"igångsättas",
	"igångsattes",
	"igångsatts",
	"igångsätts",
	"igenkännes",
	"igenkänns",
	"ignorerades",
	"ignoreras",
	"ignorerats",
	"ihågkommas",
	"ihågkommes",
	"ihågkommits",
	"ihågkoms",
	"iklädas",
	"ikläddes",
	"ikläds",
	"ikläs",
	"iklätts",
	"ilijas",
	"illfänas",
	"illuminerades",
	"illumineras",
	"illusteras",
	"illustrerades",
	"illustreras",
	"illustrerats",
	"illustrererades",
	"illustrereras",
	"imiterades",
	"implementeras",
	"imponerades",
	"imponeras",
	"imponerats",
	"importerades",
	"importeras",
	"importerats",
	"impregneras",
	"impregnerats",
	"improviserades",
	"improviseras",
	"improviserats",
	"impulsas",
	"inackorderades",
	"inaktiveras",
	"inandades",
	"inandandes",
	"inandas",
	"inandats",
	"inarbetades",
	"inbegripas",
	"inbegrips",
	"inberäknas",
	"inbesparas",
	"inbetalas",
	"inbillas",
	"inbjöds",
	"inbjudas",
	"inbjudes",
	"inbjudits",
	"inbjuds",
	"inblandades",
	"inblandas",
	"inböjds",
	"indefinieras",
	"indelades",
	"indelas",
	"indelats",
	"indelsas",
	"indentifierats",
	"independentfilmernas",
	"indikeras",
	"individanpassas",
	"individualiseras",
	"individualiserats",
	"indoktrineras",
	"indoktrinerats",
	"indragas",
	"indunstas",
	"industrialiserades",
	"industrialiseras",
	"industrialiserats",
	"infångades",
	"infångas",
	"infasas",
	"infattades",
	"infattas",
	"infekteras",
	"infekterats",
	"infiltrerades",
	"infiltreras",
	"inflammeras",
	"inflammerats",
	"inflationsskyddas",
	"inflikas",
	"influerades",
	"influeras",
	"influerats",
	"infogades",
	"infogas",
	"infogats",
	"införas",
	"infördes",
	"infordrades",
	"infordras",
	"infordrats",
	"införes",
	"införlivades",
	"införlivas",
	"införlivats",
	"informerades",
	"informeras",
	"informerats",
	"införs",
	"införskaffades",
	"införskaffas",
	"införskaffats",
	"införts",
	"infriades",
	"infrias",
	"infriats",
	"ingås",
	"ingåtts",
	"ingavs",
	"inges",
	"ingicks",
	"ingjutits",
	"ingjuts",
	"inhägnas",
	"inhägnats",
	"inhämtades",
	"inhämtas",
	"inhämtats",
	"inhandlades",
	"inhandlas",
	"inhandlats",
	"inhängnas",
	"inhiberades",
	"inhiberas",
	"inhöstats",
	"inhysas",
	"inhystes",
	"inhysts",
	"initierades",
	"initieras",
	"initierats",
	"injicerades",
	"injiceras",
	"injicerats",
	"inkallades",
	"inkallas",
	"inkallats",
	"inkarnerades",
	"inkarneras",
	"inkasserades",
	"inkluderades",
	"inkluderas",
	"inkluderats",
	"inkoms",
	"inkomstprövas",
	"inköpas",
	"inköptes",
	"inköpts",
	"inkorpererades",
	"inkorporerades",
	"inkorporeras",
	"inkorporerats",
	"inkrävas",
	"inkvarterades",
	"inkvarteras",
	"inkvarterats",
	"inlades",
	"inlämnades",
	"inlämnas",
	"inlämnats",
	"inlånades",
	"inläras",
	"inledas",
	"inledddes",
	"inleddes",
	"inledes",
	"inleds",
	"inlemmades",
	"inlemmas",
	"inlemmats",
	"inletts",
	"inlevereras",
	"inlevererats",
	"inlines",
	"inlösas",
	"inlöses",
	"inlöstes",
	"inmonteras",
	"inmundigades",
	"inmundigas",
	"innebrändes",
	"innefattades",
	"innefattas",
	"innehades",
	"innehafts",
	"innehållas",
	"innehållsdeklareras",
	"innehas",
	"inneslutas",
	"innesluts",
	"inordnades",
	"inordnas",
	"inordnats",
	"inplaneras",
	"inplanterades",
	"inplanteras",
	"inplanterats",
	"inpräglas",
	"inpräglats",
	"inpräntades",
	"inpräntas",
	"inpräntats",
	"inprogrammerats",
	"inräknades",
	"inräknas",
	"inräknats",
	"inramades",
	"inramas",
	"inramats",
	"inrangeras",
	"inrangerats",
	"inrapporterades",
	"inrapporteras",
	"inrapporterats",
	"inrättades",
	"inrättas",
	"inrättats",
	"inredas",
	"inreddes",
	"inreds",
	"inregistrerades",
	"inregistreras",
	"inregistrerats",
	"inretts",
	"inriktades",
	"inriktas",
	"inriktats",
	"inringas",
	"inristats",
	"inrymdes",
	"inrymmas",
	"inryms",
	"inrymts",
	"insågs",
	"insamlades",
	"insamlas",
	"insamlats",
	"insänts",
	"insättas",
	"insattes",
	"insatts",
	"inseminerades",
	"insemineras",
	"inses",
	"insinueras",
	"insinuerats",
	"insisteras",
	"inskaffades",
	"inskärpas",
	"inskärptes",
	"inskeppades",
	"inskjutas",
	"inskolas",
	"inskränkas",
	"inskränks",
	"inskränktes",
	"inskränkts",
	"inskrevs",
	"inskrivas",
	"insöndras",
	"insorteras",
	"inspärras",
	"inspekterades",
	"inspekteras",
	"inspekterats",
	"inspelats",
	"inspirationsgivs",
	"inspirerades",
	"inspireras",
	"inspirerats",
	"inställas",
	"inställdes",
	"installerades",
	"installeras",
	"installerats",
	"inställs",
	"inställts",
	"instängas",
	"instiftades",
	"instiftas",
	"instiftats",
	"institutionaliserades",
	"institutionaliseras",
	"instruerades",
	"instrueras",
	"instruerats",
	"instrumentaliseras",
	"insvepas",
	"insveps",
	"insveptes",
	"insvepts",
	"intagas",
	"intagits",
	"intalleras",
	"intas",
	"intecknades",
	"intecknas",
	"intecknats",
	"integrerades",
	"integreras",
	"integrerats",
	"intellektualiseras",
	"intellektualiserats",
	"intensifierades",
	"intensifieras",
	"intensifierats",
	"interfolierades",
	"interfolieras",
	"interfolierats",
	"internationales",
	"internationaliserades",
	"internationaliseras",
	"internationaliserats",
	"internerades",
	"interneras",
	"internerats",
	"internrekryterats",
	"internutbildas",
	"interpelleras",
	"interpunkterades",
	"intervjuades",
	"intervjuas",
	"intervjuats",
	"intevjuas",
	"intimiseras",
	"intimiserats",
	"intjänas",
	"intogs",
	"intressestyras",
	"intrigeras",
	"introducerades",
	"introduceras",
	"introducerats",
	"intvingas",
	"intygades",
	"intygas",
	"invaderades",
	"invaderas",
	"invaderats",
	"invaggades",
	"invaggas",
	"invaggats",
	"invaldes",
	"invalidiserades",
	"invalidiseras",
	"invalidiserats",
	"inväljas",
	"inväljs",
	"invalts",
	"invändas",
	"invandrades",
	"inväntades",
	"inväntas",
	"invecklas",
	"inventeras",
	"inventerats",
	"investerades",
	"investeras",
	"investerats",
	"invigas",
	"invigdes",
	"invigs",
	"inviskas",
	"inviteras",
	"inviterats",
	"invlades",
	"involverades",
	"involveras",
	"involverats",
	"inympas",
	"inympats",
	"iordningsställts",
	"iordningställas",
	"iordningställdes",
	"iordningställs",
	"iordningställts",
	"irriterades",
	"irriteras",
	"irriterats",
	"isades",
	"isas",
	"iscensättas",
	"iscensattes",
	"iscensatts",
	"iscensätts",
	"isolerades",
	"isoleras",
	"isolerats",
	"iståndsätts",
	"ives",
	"jagades",
	"jagas",
	"jagats",
	"jäktas",
	"jamas",
	"jämföras",
	"jämfördes",
	"jämförs",
	"jämförts",
	"jämkades",
	"jämkas",
	"jämnades",
	"jämnas",
	"jämnats",
	"jämnsides",
	"jämnställs",
	"jämställas",
	"jämställdes",
	"jämställes",
	"jämställs",
	"jämställts",
	"järfällas",
	"järnberikats",
	"järnvägsgods",
	"järvas",
	"jäs",
	"jäses",
	"jävas",
	"jävats",
	"jävlas",
	"jävlats",
	"jayhawkes",
	"jenufas",
	"jesses",
	"jippofieras",
	"jobbades",
	"jobbas",
	"jobbats",
	"jonglerades",
	"jonhälls",
	"joniseras",
	"joniserats",
	"jordbegravas",
	"jordfästas",
	"jordfästes",
	"jordgas",
	"journalföras",
	"journalistbas",
	"jublades",
	"jublas",
	"jublats",
	"juckas",
	"julas",
	"justerades",
	"justeras",
	"justerats",
	"kabilas",
	"kablades",
	"kablas",
	"kablats",
	"kacklades",
	"kåges",
	"käkopererats",
	"kalätas",
	"kalfatras",
	"kalhöggs",
	"kalkades",
	"kalkas",
	"kalkats",
	"kalkylerades",
	"kalkyleras",
	"kalkylerats",
	"kallades",
	"kallas",
	"kallats",
	"kallistenes",
	"kallpressas",
	"kallrökas",
	"kallrökts",
	"källsorteras",
	"kallsvettades",
	"kallsvettas",
	"kambodjas",
	"kammades",
	"kammas",
	"kammats",
	"kamouflagemålats",
	"kamoufleras",
	"kämpas",
	"kanaliserades",
	"kanaliseras",
	"kanaliserats",
	"kånkades",
	"kånkas",
	"kånkats",
	"känndes",
	"kännetecknades",
	"kännetecknas",
	"kännetecknats",
	"kännts",
	"kanoniserades",
	"kanoniseras",
	"käns",
	"kantades",
	"kantas",
	"kantats",
	"kantfållas",
	"kantställas",
	"kapades",
	"kapas",
	"kapats",
	"kapitaliseras",
	"kappades",
	"kappseglas",
	"kapslades",
	"kapslas",
	"kapslats",
	"karaktäriserades",
	"karaktäriseras",
	"karaktäriserats",
	"karakteriserades",
	"karakteriseras",
	"karakteriserats",
	"karikeras",
	"kärnades",
	"kärnats",
	"kartlades",
	"kartläggas",
	"kartläggs",
	"kartlagts",
	"karvas",
	"kasserades",
	"kasseras",
	"kasserats",
	"kastades",
	"kastas",
	"kastats",
	"kastreras",
	"kastrerats",
	"katalas",
	"katalogiseras",
	"katalogiserats",
	"kategoriseras",
	"kategoriserats",
	"kattas",
	"kavlades",
	"kavlas",
	"keats",
	"kedjades",
	"kedjats",
	"keldereks",
	"kemtvättas",
	"keynes",
	"kickades",
	"kickats",
	"kidnappades",
	"kidnappas",
	"kidnappats",
	"kikås",
	"kilades",
	"kilas",
	"killas",
	"kindpussas",
	"kinshasas",
	"kissas",
	"kittades",
	"kittlades",
	"kittlas",
	"klaas",
	"kläckas",
	"kläckningsplats",
	"kläcks",
	"kläcktes",
	"kläckts",
	"klädas",
	"kladdades",
	"kladdas",
	"kladdats",
	"kläddes",
	"kläds",
	"klagades",
	"klagas",
	"klagats",
	"klämdes",
	"klämmas",
	"kläms",
	"klämtas",
	"klämts",
	"klandrades",
	"klandras",
	"klandrats",
	"klankas",
	"klappades",
	"klappas",
	"klarades",
	"klaras",
	"klarats",
	"klargjordes",
	"klargjorts",
	"klargöras",
	"klargörs",
	"klarlades",
	"klarläggas",
	"klarläggs",
	"klarlagts",
	"kläs",
	"klassades",
	"klassas",
	"klassats",
	"klassificerades",
	"klassificeras",
	"klassificerats",
	"klättrades",
	"klättras",
	"klätts",
	"klemas",
	"kletas",
	"kletats",
	"klias",
	"klickas",
	"klimpades",
	"klippas",
	"klipps",
	"klipptes",
	"klippts",
	"klipsades",
	"klistrades",
	"klistras",
	"klistrats",
	"klockades",
	"klockas",
	"klockats",
	"klonas",
	"klonats",
	"kloreras",
	"klorgas",
	"klös",
	"klösts",
	"klottras",
	"klottrats",
	"klövs",
	"klubbades",
	"klubbas",
	"klubbats",
	"klubbhus",
	"kluddats",
	"klumpades",
	"klumpas",
	"kluvits",
	"klyftas",
	"klyvas",
	"klyvs",
	"klyvts",
	"knackades",
	"knäckas",
	"knackats",
	"knäcks",
	"knäcktes",
	"knäckts",
	"knådas",
	"knådats",
	"knallas",
	"knäopereras",
	"knåpades",
	"knåpas",
	"knäppas",
	"knäpps",
	"knäpptes",
	"knarkas",
	"knas",
	"knäsattes",
	"knäsatts",
	"kneps",
	"knipas",
	"knips",
	"knivdödades",
	"knivdödas",
	"knivhöggs",
	"knivhotas",
	"knivhuggits",
	"knivhuggs",
	"knivmördades",
	"knivskars",
	"knivskärs",
	"knockades",
	"knockas",
	"knockats",
	"knölades",
	"knopas",
	"knorrades",
	"knorras",
	"knöts",
	"knottrades",
	"knuckles",
	"knuffades",
	"knuffas",
	"knuffats",
	"knusslades",
	"knutits",
	"knycklas",
	"knycktes",
	"knypplats",
	"knystas",
	"knytas",
	"knyts",
	"köas",
	"kodas",
	"kodats",
	"kodifieras",
	"kodifierats",
	"kokades",
	"kokas",
	"kokats",
	"kolgrillas",
	"kollades",
	"kollas",
	"kollats",
	"kollektivansluts",
	"kolles",
	"kolonialiseras",
	"koloniserades",
	"koloniseras",
	"koloniserats",
	"koloreras",
	"kombinerades",
	"kombineras",
	"kombinerats",
	"kommenderades",
	"kommenderas",
	"kommenderats",
	"kommenterades",
	"kommenteras",
	"kommenterats",
	"kommersialiseras",
	"kommersialiserats",
	"kommits",
	"kommunaliserades",
	"kommunaliseras",
	"kommuniceras",
	"kommunplacerades",
	"kompades",
	"kompas",
	"kompenserades",
	"kompenseras",
	"kompenserats",
	"kompetensutvecklas",
	"komplettaras",
	"kompletterades",
	"kompletteras",
	"kompletterats",
	"komplicerades",
	"kompliceras",
	"komplicerats",
	"komponerades",
	"komponeras",
	"komponerats",
	"komposterades",
	"komposteras",
	"komposterats",
	"komprimeras",
	"komprimissas",
	"komprometterats",
	"kompromissas",
	"kompromissats",
	"könas",
	"koncenteras",
	"koncenterats",
	"koncentreades",
	"koncentrerades",
	"koncentreras",
	"koncentrerats",
	"koncipierades",
	"koncipieras",
	"koncipierats",
	"kondenserades",
	"kondenseras",
	"konditionstestas",
	"konfektioneras",
	"konfirmerades",
	"konfirmeras",
	"konfirmerats",
	"konfiskerades",
	"konfiskeras",
	"konfiskerats",
	"konfronterades",
	"konfronteras",
	"konfronterats",
	"kongeliges",
	"konkretiserades",
	"konkretiseras",
	"konkretiserats",
	"konkurrensutsättas",
	"konkurrensutsattes",
	"konkurrensutsatts",
	"konkurrerades",
	"konkurreras",
	"konkurrerats",
	"konserverades",
	"konserveras",
	"konserverats",
	"könskvoteras",
	"könskvoterats",
	"konsoliderades",
	"konsolideras",
	"konsoliderats",
	"konspirerades",
	"konstaterades",
	"konstateras",
	"konstaterats",
	"konstgods",
	"konstigtueras",
	"konstituerades",
	"konstitueras",
	"konstmanifesteras",
	"konstruerades",
	"konstrueras",
	"konstruerats",
	"konsulterades",
	"konsulteras",
	"konsulterats",
	"konsumerades",
	"konsumeras",
	"konsumerats",
	"kontaktades",
	"kontaktas",
	"kontaktats",
	"konterfejas",
	"kontinentaliserats",
	"kontollerats",
	"kontrakteras",
	"kontrakterats",
	"kontras",
	"kontrasterades",
	"kontrasteras",
	"kontrollerades",
	"kontrolleras",
	"kontrollerats",
	"kontrollvägdes",
	"kontrollvägts",
	"konverteras",
	"koordinerades",
	"koordineras",
	"köpas",
	"kopierades",
	"kopieras",
	"kopierats",
	"köplats",
	"kopplades",
	"kopplas",
	"kopplats",
	"köprekommenderades",
	"köps",
	"köptes",
	"köpts",
	"kopuleras",
	"korades",
	"koras",
	"köras",
	"korats",
	"kördes",
	"koreograferats",
	"köres",
	"korkades",
	"korkas",
	"korngolds",
	"korporativiserats",
	"korrekturläses",
	"korreleras",
	"korrigerades",
	"korrigeras",
	"korrigerats",
	"korrumperas",
	"korrumperats",
	"körs",
	"korsades",
	"korsas",
	"korsats",
	"korsfästas",
	"korsfästes",
	"korsfästs",
	"kortades",
	"kortas",
	"kortats",
	"körts",
	"kortslöts",
	"kortsluts",
	"korvas",
	"kosroes",
	"kostas",
	"kostaterades",
	"kostnadsberäknades",
	"kostnadsberäknas",
	"kostnadsberäknats",
	"kostnadsföras",
	"kotrollvägdes",
	"kovacs",
	"krackeleras",
	"kramades",
	"kramas",
	"kramats",
	"kramkalas",
	"krängdes",
	"krånglats",
	"krängts",
	"kränkas",
	"kränks",
	"kränktes",
	"kränkts",
	"kransats",
	"krattas",
	"krävas",
	"krävdes",
	"kräves",
	"krävs",
	"krävts",
	"kreerades",
	"kremerades",
	"kremeras",
	"kretsloppsanpassas",
	"krigsplaceras",
	"kriminaliserades",
	"kriminaliseras",
	"kringgärdades",
	"kringgärdas",
	"kringgås",
	"kringgåtts",
	"kringgicks",
	"kringgjutits",
	"kringränts",
	"kringskäras",
	"kringskars",
	"kringvärvs",
	"kristalliserades",
	"kristalliseras",
	"kristnades",
	"kritas",
	"kritiserades",
	"kritiseras",
	"kritiserats",
	"krockades",
	"krockprovas",
	"krokades",
	"krökas",
	"krokats",
	"kröks",
	"kröktes",
	"krönas",
	"krönes",
	"kröns",
	"kröntes",
	"krönts",
	"kroppsvisiterades",
	"kroppsvisiteras",
	"krossades",
	"krossas",
	"krossats",
	"krusades",
	"krusas",
	"kryddades",
	"kryddas",
	"kryddats",
	"krympas",
	"krymps",
	"krymptes",
	"krympts",
	"krypteras",
	"krypterats",
	"krypts",
	"kryssas",
	"kryssats",
	"kryssgarderas",
	"kubbas",
	"kuggades",
	"kuggas",
	"kullas",
	"kullkastas",
	"kultiveras",
	"kultiverats",
	"kulturminnesmärkas",
	"kulturminnesskyddats",
	"kulturprofileras",
	"kulverteras",
	"kulverterats",
	"kumquats",
	"kundanpassas",
	"kundbas",
	"kundes",
	"kungjordes",
	"kungjorts",
	"kungörs",
	"kunnas",
	"kupades",
	"kuperas",
	"kuppats",
	"kureras",
	"kursas",
	"kursras",
	"kuvas",
	"kuvats",
	"kvackas",
	"kvaddades",
	"kvaddats",
	"kvalificeras",
	"kvalitetsäkras",
	"kvalitetsprövats",
	"kvalitetssäkras",
	"kvalitetssäkrats",
	"kvalitetsutbildats",
	"kväljdes",
	"kvällades",
	"kvalplats",
	"kvantifieras",
	"kvarhållas",
	"kvarhållits",
	"kvarhålls",
	"kvarhölls",
	"kväsas",
	"kvästes",
	"kvävas",
	"kvävdes",
	"kvävs",
	"kvinnoplats",
	"kvittas",
	"kvittats",
	"kvitterades",
	"kvitteras",
	"kvotbelades",
	"kvoteras",
	"kvoterats",
	"kylas",
	"kyldes",
	"kyls",
	"kylts",
	"kyssas",
	"kysstes",
	"laborades",
	"laboreras",
	"lackeras",
	"lackerats",
	"läcks",
	"läckts",
	"laddades",
	"laddas",
	"laddats",
	"lades",
	"lafis",
	"lagades",
	"lagas",
	"lagats",
	"lagerhållas",
	"lagfästes",
	"lagfästs",
	"lagföras",
	"lagfördes",
	"läggas",
	"lägges",
	"lägggas",
	"läggs",
	"lagrades",
	"lagrådsremitteras",
	"lagras",
	"lagrats",
	"lagregleras",
	"lagstadgades",
	"lagstiftas",
	"lagtrots",
	"lågtrycksgjuts",
	"lagts",
	"läkarundersökas",
	"läkarundersöktes",
	"lakas",
	"läkas",
	"lakats",
	"läks",
	"läktes",
	"läktrats",
	"läkts",
	"lambrecks",
	"lamineras",
	"lämnades",
	"lämnas",
	"lämnats",
	"lämpades",
	"lämpas",
	"lämpats",
	"lamslagits",
	"lamslås",
	"lamslogs",
	"lånades",
	"lånas",
	"lånats",
	"lanceras",
	"landades",
	"landsattes",
	"landsatts",
	"landsförvisades",
	"landsförvisas",
	"landsförvisats",
	"lånefinansieras",
	"langades",
	"langas",
	"långås",
	"långsits",
	"långtidslagras",
	"långtidsparkerades",
	"långtidsskolats",
	"längts",
	"languages",
	"länkades",
	"länkas",
	"länkats",
	"länsades",
	"länsas",
	"länsats",
	"lanserades",
	"lanseras",
	"lanserats",
	"lansertas",
	"länspumpas",
	"lapas",
	"lappades",
	"lappas",
	"lappats",
	"läras",
	"lärdes",
	"larmades",
	"larmas",
	"larmats",
	"lärs",
	"larses",
	"lårskadades",
	"lärts",
	"las",
	"lås",
	"läs",
	"låsas",
	"läsas",
	"laserats",
	"låses",
	"läses",
	"lassades",
	"lassas",
	"låssas",
	"lassats",
	"låssats",
	"lastades",
	"lastas",
	"lastats",
	"låstes",
	"lästes",
	"låsts",
	"lästs",
	"låtits",
	"lättades",
	"lättas",
	"lättats",
	"läxats",
	"leasades",
	"leasas",
	"leasats",
	"ledas",
	"leddes",
	"ledes",
	"ledigförklarades",
	"ledigförklaras",
	"ledigförklarats",
	"leds",
	"ledsagades",
	"ledsagas",
	"legalförskrevs",
	"legaliserades",
	"legaliseras",
	"legaliserats",
	"legeras",
	"legitimerades",
	"legitimeras",
	"legitimerats",
	"lekas",
	"leks",
	"lektes",
	"lemlästades",
	"lemlästas",
	"lemlästats",
	"lemströms",
	"lenas",
	"letades",
	"letas",
	"letats",
	"letts",
	"levandegörs",
	"levas",
	"levdes",
	"leverades",
	"leveraras",
	"levererades",
	"levereras",
	"levererats",
	"levertransplanteras",
	"leves",
	"levs",
	"levts",
	"lfinns",
	"liberaliseras",
	"liberaliserats",
	"licensbryggs",
	"licenserats",
	"licenstillverkats",
	"lidas",
	"lidits",
	"likformas",
	"liknades",
	"liknas",
	"liknats",
	"likställas",
	"likställdes",
	"likställs",
	"likviderades",
	"likvideras",
	"limmades",
	"limmas",
	"limmats",
	"lindades",
	"lindas",
	"lindats",
	"lindrades",
	"lindras",
	"lindrats",
	"linjeras",
	"linoljebränns",
	"lipas",
	"lirades",
	"liras",
	"lirkas",
	"lirkats",
	"listades",
	"listas",
	"listats",
	"livades",
	"livas",
	"lives",
	"livnärs",
	"livstidsförlängdes",
	"ljögs",
	"ljudas",
	"ljudisoleras",
	"ljugas",
	"ljugs",
	"ljummades",
	"ljummas",
	"ljumskskadades",
	"ljussatts",
	"lockades",
	"lockas",
	"lockats",
	"lockoutas",
	"lodas",
	"lödas",
	"löds",
	"loggas",
	"logothetis",
	"logrones",
	"lokaliserades",
	"lokaliseras",
	"lokaliserats",
	"lomas",
	"lönades",
	"lönas",
	"lönediskrimineras",
	"lönediskriminerats",
	"löneras",
	"lönesättas",
	"longeras",
	"lönnbrännes",
	"loopas",
	"loopats",
	"loosegoats",
	"löpas",
	"löps",
	"lösas",
	"löses",
	"lösgivas",
	"lösgjordes",
	"lösgjorts",
	"lösgöras",
	"lösgöres",
	"lösgörs",
	"lossades",
	"lossas",
	"lossats",
	"löstes",
	"lösts",
	"lotsades",
	"lotsas",
	"lotsats",
	"lottades",
	"lottas",
	"lottats",
	"lovades",
	"lövades",
	"lovas",
	"lövas",
	"lovats",
	"lövats",
	"lovordades",
	"lovordas",
	"lovordats",
	"lovprisades",
	"lovprisas",
	"lovsjungits",
	"lovsjungs",
	"luckrades",
	"luckras",
	"luckrats",
	"luftades",
	"luftas",
	"luftats",
	"luftlandsattes",
	"lugnades",
	"lugnas",
	"lukkes",
	"lurades",
	"luras",
	"lurats",
	"lusläses",
	"luslästes",
	"lussas",
	"lutades",
	"lutas",
	"luttras",
	"luttrats",
	"lyckes",
	"lyckets",
	"lyckönskas",
	"lycksönskades",
	"lycktas",
	"lydas",
	"lyddes",
	"lyftas",
	"lyftes",
	"lyfts",
	"lynchades",
	"lynchats",
	"lys",
	"lysas",
	"lyses",
	"lyss",
	"lyssnas",
	"lystes",
	"lysts",
	"lyxrenoveras",
	"lyxsanerades",
	"lyxsaneras",
	"lyxsanerats",
	"macoutes",
	"måddes",
	"mades",
	"magallanes",
	"magasinerades",
	"magasineras",
	"magasinerats",
	"magpumpas",
	"magpumpats",
	"magras",
	"majos",
	"mäklades",
	"makulerades",
	"makuleras",
	"målades",
	"malas",
	"målas",
	"målats",
	"malbas",
	"målbestäms",
	"maldes",
	"mals",
	"malts",
	"mammograferats",
	"manades",
	"manas",
	"månas",
	"manats",
	"mångdubblades",
	"mångdubblas",
	"mångdubblats",
	"mångfaldigades",
	"mångfaldigas",
	"mångfaldigats",
	"manglades",
	"manglas",
	"manglats",
	"månglats",
	"manifesterades",
	"manifesteras",
	"manifesterats",
	"manipulerades",
	"manipuleras",
	"manipulerats",
	"manövrerades",
	"manövreras",
	"manövrerats",
	"mantalskrivas",
	"mantalsskrivas",
	"marantas",
	"marginaliserades",
	"marginaliseras",
	"marginaliserats",
	"marineras",
	"marinerats",
	"märkas",
	"markerades",
	"markeras",
	"markerats",
	"märkes",
	"markets",
	"markledes",
	"marknadsanpassas",
	"marknadsföras",
	"marknadsfördes",
	"marknadsförs",
	"marknadsförts",
	"marknadsintroducerades",
	"märks",
	"märktes",
	"märkts",
	"markurells",
	"marples",
	"marterades",
	"martikas",
	"mås",
	"maskas",
	"maskerades",
	"maskeras",
	"maskerats",
	"maskintvättas",
	"maskinveks",
	"massakrerades",
	"massakreras",
	"mässas",
	"masserades",
	"masseras",
	"massproduceras",
	"masstillverkas",
	"mastas",
	"mästras",
	"matades",
	"matas",
	"mätas",
	"matats",
	"matchades",
	"matchas",
	"matchats",
	"matchinsats",
	"materialiserades",
	"materialiseras",
	"materialiserats",
	"mätes",
	"matplats",
	"mäts",
	"mattades",
	"mattas",
	"måttas",
	"mättas",
	"mattats",
	"mättats",
	"mättes",
	"mätts",
	"matutes",
	"maximeras",
	"medagerandes",
	"medaljeras",
	"medaljhyllades",
	"meddelades",
	"meddelas",
	"meddelats",
	"medfinansieras",
	"medföras",
	"medfördes",
	"medföres",
	"medförs",
	"medgavs",
	"medges",
	"medgivits",
	"medhavas",
	"medialiserats",
	"medicineras",
	"medicinerats",
	"medikaliserades",
	"medlas",
	"medräknas",
	"medtagas",
	"medtages",
	"medtas",
	"medtogs",
	"medvetandegöras",
	"mefistofeles",
	"mejades",
	"mejas",
	"mejats",
	"mejslades",
	"mekaniserats",
	"memoreras",
	"menades",
	"menas",
	"mennas",
	"meritvärderas",
	"mestadelas",
	"metroiseras",
	"midas",
	"mikrats",
	"mikrofilmades",
	"mikrofilmas",
	"mildrades",
	"mildras",
	"mildrats",
	"miles",
	"militariserades",
	"militariseras",
	"militariserats",
	"miljöanpassas",
	"miljöcertifierats",
	"miljödeklareras",
	"miljögranskats",
	"miljöklassas",
	"miljömärkas",
	"miljömärkts",
	"miljöprövas",
	"miljöskyddas",
	"mills",
	"mimades",
	"mimas",
	"mineraliseras",
	"mineras",
	"minerats",
	"minglats",
	"minimerades",
	"minimeras",
	"minimerats",
	"minnns",
	"minskades",
	"minskas",
	"minskats",
	"minsprängdes",
	"minutes",
	"misbruges",
	"missades",
	"missas",
	"missats",
	"missbrukades",
	"missbrukas",
	"missbrukats",
	"missfärgas",
	"missförstås",
	"missförståtts",
	"missförstods",
	"missgynnades",
	"missgynnas",
	"missgynnats",
	"misshandlades",
	"misshandlas",
	"misshandlats",
	"misshushållas",
	"missköts",
	"misskötts",
	"misskrediterades",
	"missledas",
	"missletts",
	"misssgynnas",
	"misssköts",
	"misstänkas",
	"misstänkliggjordes",
	"misstänkliggöras",
	"misstänkliggörs",
	"misstänks",
	"misstänktes",
	"misstänkts",
	"misstas",
	"misstolkas",
	"misstolkats",
	"misstroddes",
	"misstros",
	"misstydas",
	"missunnnas",
	"missupfattas",
	"missuppattades",
	"missuppfattades",
	"missuppfattas",
	"missuppfattats",
	"mixas",
	"mjölkades",
	"mjölkas",
	"mjukades",
	"mjukas",
	"mjukats",
	"mjukpressats",
	"mobbades",
	"mobbas",
	"mobbats",
	"mobiliserades",
	"mobiliseras",
	"mobiliserats",
	"möblerades",
	"möbleras",
	"möblerats",
	"mockades",
	"modeinitierades",
	"moderninserats",
	"moderniserades",
	"moderniseras",
	"moderniserats",
	"modifierades",
	"modifieras",
	"modifierats",
	"mognadslagras",
	"mogulrikets",
	"möjas",
	"möjliggjordes",
	"möjliggjorts",
	"möjliggöras",
	"möjliggörs",
	"möjligjorts",
	"momsbefrias",
	"momsbeläggas",
	"momsbeläggs",
	"momsbelagts",
	"mondes",
	"monkees",
	"monograferats",
	"monopoliseras",
	"monopoliserats",
	"monsterras",
	"mönsterskyddats",
	"mönstrades",
	"mönstras",
	"mönstrats",
	"monterades",
	"monteras",
	"monterats",
	"monumentaliseras",
	"moraliseras",
	"mörbultats",
	"mördades",
	"mördas",
	"mördats",
	"mordhotades",
	"mordhotats",
	"mörkas",
	"mörklades",
	"mörkläggas",
	"mörkläggs",
	"mörklagts",
	"morrades",
	"morras",
	"mortuis",
	"mosades",
	"mosas",
	"motades",
	"motarbetades",
	"motarbetas",
	"motarbetats",
	"motas",
	"motats",
	"motbevisas",
	"motionerades",
	"motioneras",
	"motiverades",
	"motiveras",
	"motiverats",
	"motoriseras",
	"motsades",
	"motsägas",
	"motsäges",
	"motsägs",
	"motsagts",
	"motstås",
	"motsvarades",
	"motsvaras",
	"motsvarats",
	"mottagas",
	"mottages",
	"mottagits",
	"mottas",
	"mottogs",
	"motverkades",
	"motverkas",
	"motverkats",
	"muddras",
	"multipliceras",
	"mulugetas",
	"mumifieras",
	"mumifierats",
	"mumlades",
	"mumlas",
	"mumlats",
	"mungnabbas",
	"munhöggs",
	"munhuggas",
	"munhuggs",
	"murades",
	"muras",
	"murats",
	"musicerades",
	"musiceras",
	"mutades",
	"mutas",
	"mutats",
	"muttrades",
	"muttras",
	"muttrats",
	"mutts",
	"muzungos",
	"myers",
	"myglades",
	"myndigförklaras",
	"myndighetsförklarats",
	"myntades",
	"myntas",
	"myntats",
	"mysas",
	"mystifieras",
	"mystifierats",
	"mytifieras",
	"nackas",
	"nádas",
	"nåddes",
	"nådes",
	"nafsades",
	"nagelfaras",
	"nagelfarits",
	"nagelfars",
	"nagelfors",
	"naggades",
	"naggas",
	"naggats",
	"naglades",
	"naglas",
	"nålas",
	"nålats",
	"namnades",
	"nämnas",
	"nämndes",
	"nämnes",
	"namngavs",
	"namnges",
	"namngetts",
	"namngivits",
	"nämns",
	"namnskyddas",
	"nämnts",
	"näms",
	"nämts",
	"nändes",
	"nännas",
	"nänns",
	"näns",
	"nänts",
	"näpsas",
	"näras",
	"närdes",
	"näres",
	"närmas",
	"narracotts",
	"narrades",
	"narras",
	"narrats",
	"närs",
	"närts",
	"nas",
	"nås",
	"nasas",
	"nästas",
	"nationaliserades",
	"nationaliseras",
	"nationaliserats",
	"natoanpassas",
	"natofieras",
	"nattas",
	"nåtts",
	"nattstädas",
	"nattstängs",
	"naturaliseras",
	"naturligtivs",
	"navotas",
	"nedbringas",
	"nedbringats",
	"nedbrytas",
	"nedflyttningsplats",
	"nedgjordes",
	"nedgraderas",
	"nedkämpas",
	"nedkämpats",
	"nedlades",
	"nedläggas",
	"nedlagts",
	"nedmonterades",
	"nedmonteras",
	"nedrangeras",
	"nedreviderades",
	"nedreviderats",
	"nedrustas",
	"nedsättas",
	"nedsätts",
	"nedsköljes",
	"nedskrivas",
	"nedslås",
	"nedtecknades",
	"nedtecknats",
	"nedtynges",
	"nedtystas",
	"nedvärderas",
	"nedvärderats",
	"negeras",
	"negligeras",
	"negligerats",
	"nekades",
	"nekas",
	"nekats",
	"nerslås",
	"nettoamorteras",
	"nettoexporterades",
	"nettoköptes",
	"nettoköpts",
	"nettosåldes",
	"nettosålts",
	"neurosedynskadades",
	"neutraliserades",
	"neutraliseras",
	"neutraliserats",
	"nickades",
	"nickas",
	"nitas",
	"nivågrupperas",
	"njutas",
	"njutes",
	"njuts",
	"nobbades",
	"nobbas",
	"nobbats",
	"nobelprisförbigåtts",
	"nödbromsas",
	"nödgades",
	"nödgats",
	"nödsakats",
	"nödslaktades",
	"nödslaktas",
	"nödslaktats",
	"nödstoppades",
	"nödvändiggjordes",
	"nollades",
	"nollställas",
	"nollställs",
	"nollställts",
	"nolltaxeras",
	"nominerades",
	"nomineras",
	"nominerats",
	"noms",
	"nonchalerades",
	"nonchaleras",
	"nonchalerats",
	"nordstedts",
	"normalförklaras",
	"normaliserades",
	"normaliseras",
	"normaliserats",
	"nös",
	"nötas",
	"noterades",
	"noteras",
	"noterats",
	"noteringsstoppades",
	"nöts",
	"nöttes",
	"nötts",
	"nuddas",
	"numererats",
	"numreras",
	"numrerats",
	"nuvärdeberäknas",
	"nuvärdeberäknats",
	"nuvärdesberäknas",
	"nyanlagts",
	"nyanmäldes",
	"nyanserades",
	"nyanseras",
	"nyanserats",
	"nyanställas",
	"nyanställdes",
	"nyanställs",
	"nyanställts",
	"nybeställas",
	"nybyggas",
	"nydanades",
	"nyemitteras",
	"nyetableras",
	"nygestaltades",
	"nyindustrialiseras",
	"nyinvandrades",
	"nyinvigts",
	"nykryddats",
	"nynnades",
	"nynnas",
	"nyordnas",
	"nyorienteras",
	"nyöversattes",
	"nyöversatts",
	"nyplanterades",
	"nyprövas",
	"nyps",
	"nyrekryteras",
	"nyritades",
	"nyskapas",
	"nystades",
	"nystas",
	"nystats",
	"nytillverkas",
	"nytolkas",
	"nytrycktes",
	"nyttjades",
	"nyttjas",
	"nyttjats",
	"nyutexamineras",
	"nyutgavs",
	"nyvaldes",
	"nyväljs",
	"oakes",
	"oates",
	"obducerades",
	"obduceras",
	"obducerats",
	"obligationsras",
	"obs",
	"observerades",
	"observeras",
	"observerats",
	"ocksåses",
	"ocksåstärkts",
	"ocksåtas",
	"ockuperades",
	"ockuperas",
	"ockuperats",
	"ödas",
	"ödelades",
	"ödeläggas",
	"ödeläggs",
	"ödelagts",
	"odlades",
	"odlas",
	"odlats",
	"odödligförklarats",
	"odödliggjordes",
	"ödslas",
	"ödslats",
	"odugligförklarats",
	"odyssevs",
	"offentliggjordes",
	"offentliggjorts",
	"offentliggöras",
	"offentliggörs",
	"offereras",
	"offererats",
	"offetliggjordes",
	"offrades",
	"offras",
	"offrats",
	"ofredas",
	"ogilitigförklaras",
	"ogillades",
	"ogillas",
	"ogillats",
	"ogiltigförklarades",
	"ogiltigförklaras",
	"ogiltigförklarats",
	"öis",
	"ojades",
	"ojas",
	"ökades",
	"ökas",
	"ökats",
	"olagligförklaras",
	"olagligförklarats",
	"olas",
	"olåtandes",
	"oliktänkades",
	"oljas",
	"oljats",
	"olövanes",
	"olyckas",
	"olycksfallsförsäkras",
	"omarbetades",
	"omarbetas",
	"omarbetats",
	"ombads",
	"ombedas",
	"ombedes",
	"ombeds",
	"ombes",
	"ombesörjas",
	"ombesörjdes",
	"ombesörjs",
	"ombesörjts",
	"ombetts",
	"ombildades",
	"ombildas",
	"ombildats",
	"omdanades",
	"omdanas",
	"omdanats",
	"omdaterats",
	"omdefinieras",
	"omdirigerades",
	"omdirigeras",
	"omdirigerats",
	"omdisponeras",
	"omdöpas",
	"omdöps",
	"omfamnades",
	"omfamnas",
	"omfatas",
	"omfattades",
	"omfattas",
	"omfattats",
	"omfatttas",
	"omflytes",
	"omfördelades",
	"omfördelas",
	"omfördelats",
	"omförhandlades",
	"omförhandlas",
	"omförhandlats",
	"omformades",
	"omformas",
	"omformulerades",
	"omformuleras",
	"omgärdades",
	"omgärdas",
	"omgärdats",
	"omgavs",
	"omges",
	"omgestaltades",
	"omgestaltas",
	"omgestaltats",
	"omgetts",
	"omgivits",
	"omgrupperas",
	"omhäktades",
	"omhändertagas",
	"omhändertagits",
	"omhändertas",
	"omhändertogs",
	"omhuldades",
	"omhuldas",
	"omhuldats",
	"omintetgjordes",
	"omintetgjorts",
	"omintetgöras",
	"omintetgörs",
	"omisoleras",
	"ömkas",
	"omlokaliseras",
	"ommöbleras",
	"omnamnades",
	"omnämnas",
	"omnämndes",
	"omnämns",
	"omnämnts",
	"omöjliggjordes",
	"omöjliggjorts",
	"omöjliggöras",
	"omöjliggöres",
	"omöjliggörs",
	"omorganiserades",
	"omorganiseras",
	"omorganiserats",
	"omorienteras",
	"omplacerades",
	"omplaceras",
	"omplacerats",
	"omplanteras",
	"omprioriteras",
	"omprogrammeras",
	"omprövades",
	"omprövas",
	"omräknas",
	"omramades",
	"omregistreras",
	"omringades",
	"omringas",
	"omritades",
	"omröres",
	"omsättas",
	"omsattes",
	"omsatts",
	"omsätts",
	"omskapades",
	"omskapas",
	"omskäras",
	"omskolas",
	"omskolats",
	"omskrivas",
	"omskrivits",
	"omskrivs",
	"omslingrades",
	"omslöts",
	"omslutas",
	"omslutes",
	"omsluts",
	"omställas",
	"omstöpas",
	"omstöps",
	"omstöpts",
	"omstrukturerades",
	"omstruktureras",
	"omstrukturerats",
	"omsusas",
	"omsvärmades",
	"omsvärmas",
	"omtalades",
	"omtalas",
	"omtalats",
	"omtöcknas",
	"omtolkas",
	"omvaldes",
	"omväljas",
	"omväljs",
	"omvalts",
	"omvändas",
	"omvändes",
	"omvandlades",
	"omvandlas",
	"omvandlats",
	"omvänds",
	"omvänts",
	"omvärderades",
	"omvärderas",
	"omvärderats",
	"omvittnades",
	"omvittnas",
	"omvittnats",
	"omyndigförklaras",
	"omyndigförklarats",
	"onderwijs",
	"onödiggöras",
	"önskades",
	"önskas",
	"operades",
	"opererades",
	"opereras",
	"opererats",
	"öppnades",
	"öppnas",
	"öppnats",
	"optimeras",
	"ordas",
	"ordats",
	"ordinerades",
	"ordineras",
	"ordinerats",
	"ordnades",
	"ordnas",
	"ordnats",
	"oreras",
	"orerats",
	"organiserades",
	"organiseras",
	"organiserats",
	"orienteras",
	"orienterats",
	"oroades",
	"oroas",
	"oroats",
	"öronklippas",
	"öronmärkas",
	"öronmärks",
	"öronmärktes",
	"öronmärkts",
	"örontisslas",
	"orsakades",
	"orsakas",
	"orsakats",
	"orsaksförklaras",
	"ortelgas",
	"ös",
	"osäkras",
	"ösas",
	"oscarnominerades",
	"oskadliggjordes",
	"oskadliggöras",
	"oskadliggörs",
	"oskarsnominerats",
	"östbergas",
	"östes",
	"ostgratinerats",
	"östrogenbehandlas",
	"östs",
	"osynliggjorts",
	"osynliggöras",
	"osynliggörs",
	"övades",
	"övas",
	"övats",
	"öveföres",
	"överanvänds",
	"överarbetas",
	"överås",
	"överbefolkas",
	"överbejakas",
	"överbelastades",
	"överbelastas",
	"överbeskattas",
	"överbetonades",
	"överbetonats",
	"överbevisades",
	"överbevisas",
	"överbevisats",
	"överblickas",
	"överbryggas",
	"överdäckas",
	"överdebiterats",
	"överdimensionerats",
	"överdoseras",
	"överdramatiseras",
	"överdrevs",
	"överdrivas",
	"överdrivits",
	"överdrivs",
	"överdrogs",
	"överenskommits",
	"överenskoms",
	"överexponeras",
	"överexponerats",
	"överfallas",
	"överfallits",
	"överfalls",
	"överflödades",
	"överflyglades",
	"överflyglas",
	"överflyttades",
	"överflyttas",
	"överfölls",
	"överföras",
	"överfördes",
	"överförs",
	"överförts",
	"överfyllas",
	"övergavs",
	"överges",
	"övergetts",
	"övergivas",
	"övergivits",
	"överglänses",
	"överglänstes",
	"övergöts",
	"överhettades",
	"överhettas",
	"överinskrivas",
	"överklagades",
	"överklagas",
	"överklagats",
	"överklistras",
	"överkompenseras",
	"överlagras",
	"överlämnades",
	"överlämnas",
	"överlämnats",
	"överlappas",
	"överlåtas",
	"överlåtits",
	"överlåts",
	"överläts",
	"överlevas",
	"överlistas",
	"övermannades",
	"övermannas",
	"övermannats",
	"övermättas",
	"överordnas",
	"överös",
	"överösas",
	"överöses",
	"överöstes",
	"överösts",
	"överprocuderas",
	"överprövas",
	"överprövats",
	"överpudras",
	"överräcks",
	"överräcktes",
	"överraskades",
	"överraskas",
	"överraskats",
	"överröstades",
	"överröstas",
	"överrumplades",
	"överrumplas",
	"överrumplats",
	"översändas",
	"översändes",
	"översänts",
	"översättas",
	"översattes",
	"översatts",
	"översätts",
	"överskattades",
	"överskattas",
	"överskattats",
	"översköljas",
	"översköljs",
	"översköljts",
	"överskreds",
	"överskridas",
	"överskridits",
	"överskrids",
	"överskuggades",
	"överskuggas",
	"överskuggats",
	"överspolas",
	"överstigas",
	"överstigs",
	"överstimuleras",
	"översvämmades",
	"översvämmas",
	"översvämmats",
	"övertäckas",
	"övertäcks",
	"övertäcktes",
	"övertages",
	"övertagits",
	"övertalades",
	"övertalas",
	"övertalats",
	"övertas",
	"övertecknades",
	"övertecknas",
	"övertecknats",
	"övertogs",
	"övertolkas",
	"övertolkats",
	"överträdas",
	"överträdes",
	"överträffades",
	"överträffas",
	"överträffats",
	"övertrasserades",
	"övertrasseras",
	"övertrumfas",
	"övertygades",
	"övertygas",
	"övertygats",
	"överutnyttjades",
	"överutnyttjas",
	"övervägas",
	"övervägdes",
	"övervägs",
	"övervägts",
	"övervakades",
	"övervakas",
	"övervakats",
	"överväldigades",
	"överväldigas",
	"överväldigats",
	"övervältras",
	"övervämmas",
	"övervärderas",
	"övervärderats",
	"övervinnas",
	"övervinns",
	"övervintras",
	"övervunnits",
	"oxideras",
	"påannonserades",
	"påannonseras",
	"påbjöds",
	"påbjudes",
	"påbjudits",
	"påbjuds",
	"påbörjades",
	"påbörjas",
	"påbörjats",
	"pacificeras",
	"packades",
	"packas",
	"packats",
	"pådyvlades",
	"pådyvlas",
	"påfodras",
	"påföras",
	"påförs",
	"påförts",
	"påfrestas",
	"påhejas",
	"påkallas",
	"påkallats",
	"paketeras",
	"paketerats",
	"påkördes",
	"påläggas",
	"påläggs",
	"pålagts",
	"pålas",
	"pålats",
	"pallas",
	"pallats",
	"palmas",
	"påmindes",
	"påminnas",
	"påminns",
	"påmints",
	"paneras",
	"pangas",
	"pantas",
	"pantsattes",
	"pånyttfödas",
	"påområdes",
	"påpekades",
	"påpekas",
	"påpekats",
	"påprackas",
	"parades",
	"paraferades",
	"påräknas",
	"parallellkopplades",
	"parallellkopplas",
	"paralyseras",
	"paralyserats",
	"paras",
	"parats",
	"pareras",
	"parkerades",
	"parkeras",
	"parkerats",
	"parodieras",
	"parras",
	"parsas",
	"påskrivs",
	"påskyndades",
	"påskyndas",
	"påskyndats",
	"passades",
	"passas",
	"passats",
	"passerades",
	"passeras",
	"passerats",
	"passglas",
	"passiviseras",
	"påstås",
	"påståtts",
	"pasteuriserades",
	"pastischeras",
	"påstods",
	"pastöriseras",
	"pastöriserats",
	"påtalades",
	"påtalas",
	"påtalats",
	"patentbeläggs",
	"patenteras",
	"patenterats",
	"påträffades",
	"påträffas",
	"påträffats",
	"patrokles",
	"patrullerades",
	"patrulleras",
	"patrullerats",
	"pats",
	"påtvingades",
	"påtvingas",
	"påtvingats",
	"påverkades",
	"påverkanmotarbetades",
	"påverkas",
	"påverkats",
	"påvisades",
	"påvisas",
	"påvisats",
	"payrolls",
	"pejlas",
	"pekades",
	"pekas",
	"pekats",
	"pelleas",
	"pendlades",
	"penetrerades",
	"penetreras",
	"penetrerats",
	"pensionerades",
	"pensioneras",
	"pensionerats",
	"penslas",
	"peppades",
	"peppas",
	"peppras",
	"peps",
	"perforerades",
	"perforeras",
	"permanentades",
	"permanentas",
	"permanentats",
	"permitteras",
	"permitterats",
	"perriéres",
	"persenteras",
	"personalförsörjs",
	"personifierades",
	"personifieras",
	"personkontrolleras",
	"personröstas",
	"perverteras",
	"pessoas",
	"pestas",
	"pestsmittades",
	"petades",
	"petas",
	"petats",
	"pharmacias",
	"philos",
	"piffades",
	"piffas",
	"piggats",
	"pihelgas",
	"pilats",
	"pillas",
	"pillras",
	"pinades",
	"pinas",
	"pinats",
	"pints",
	"pips",
	"piskades",
	"piskas",
	"piskats",
	"pizzasås",
	"pjoskades",
	"placerades",
	"placeras",
	"placerats",
	"pladdrats",
	"plågades",
	"plågas",
	"plågats",
	"plagieras",
	"plagierats",
	"plånades",
	"planas",
	"plånas",
	"planats",
	"plånats",
	"planerades",
	"planeras",
	"planerats",
	"plankades",
	"plankas",
	"planlades",
	"planläggs",
	"planlagts",
	"planterades",
	"planteras",
	"planterats",
	"plastades",
	"plastas",
	"plåstras",
	"plåstrats",
	"plåtas",
	"platsbyggdes",
	"plattades",
	"plattats",
	"plockades",
	"plockas",
	"plockats",
	"plogades",
	"plogas",
	"plogats",
	"plöjas",
	"plöjdes",
	"plöjs",
	"plöjts",
	"plomberades",
	"plomberas",
	"plomberats",
	"plottats",
	"plottras",
	"plottrats",
	"pluggas",
	"plundrades",
	"plundras",
	"plundrats",
	"plussades",
	"plussas",
	"plussats",
	"plutades",
	"poängbedöms",
	"poängsättas",
	"poängsattes",
	"poängsatts",
	"poängsätts",
	"poängterades",
	"poängteras",
	"poängterats",
	"poängvärderas",
	"pocahontas",
	"pocheras",
	"pockas",
	"pokuleras",
	"polariserades",
	"polariseras",
	"polariserats",
	"polerades",
	"poleras",
	"polerats",
	"polinas",
	"polisanmälas",
	"polisanmäldes",
	"polisanmäls",
	"polisanmälts",
	"politiserades",
	"politiseras",
	"politiserats",
	"polydamas",
	"polymeras",
	"poneras",
	"populariserats",
	"portades",
	"portas",
	"portförbjudas",
	"portförbjudits",
	"portionerades",
	"portioneras",
	"porträtteras",
	"porträtterats",
	"porträttrades",
	"portugaliseras",
	"positioneras",
	"postades",
	"postas",
	"postats",
	"posterades",
	"poststämplades",
	"postuleras",
	"prackats",
	"präglades",
	"präglas",
	"präglats",
	"praktiserades",
	"praktiseras",
	"praktiserats",
	"prånglades",
	"prånglats",
	"präntades",
	"präntas",
	"prasslas",
	"prästvigas",
	"prästvigdes",
	"prästvigs",
	"prästvigts",
	"pratades",
	"pratas",
	"pratats",
	"preciserades",
	"preciseras",
	"preciserats",
	"precisionsstyras",
	"predestineras",
	"predikades",
	"predikas",
	"predikats",
	"prefabriceras",
	"prejas",
	"premiärprövades",
	"premiärsändes",
	"premiäruppförs",
	"premiärutdelas",
	"premiärvisades",
	"premiärvisas",
	"premiärvisats",
	"premierades",
	"premieras",
	"premierats",
	"prepareras",
	"preparerats",
	"presenterades",
	"presenteras",
	"presenterats",
	"presenteres",
	"preskriberas",
	"preskriberats",
	"pressades",
	"pressas",
	"pressats",
	"prestenteras",
	"presterades",
	"presteras",
	"presterats",
	"prices",
	"prickades",
	"prickas",
	"prickats",
	"pricktestades",
	"primärnoterats",
	"printas",
	"prioriterades",
	"prioriteras",
	"prioriterats",
	"pripps",
	"prisades",
	"prisas",
	"prisats",
	"prisbelönades",
	"prisbelönas",
	"prisbelönats",
	"prissättas",
	"prissätts",
	"privatimporterades",
	"privatimporterats",
	"privatiserades",
	"privatiseras",
	"privatiserats",
	"problematiseras",
	"problematiserats",
	"proceedings",
	"processas",
	"processats",
	"prodotes",
	"producerades",
	"produceras",
	"producerats",
	"profaneras",
	"professionaliserades",
	"professionaliseras",
	"profeterats",
	"proffsförklarades",
	"profilerades",
	"profileras",
	"prognosticerades",
	"prognostiseras",
	"programmerades",
	"programmeras",
	"projekterades",
	"projekteras",
	"projicerades",
	"projiceras",
	"projicerats",
	"pröjts",
	"proklamerades",
	"proklameras",
	"proklamerats",
	"proletariseras",
	"prolongerades",
	"prolongeras",
	"promenerades",
	"promeneras",
	"promoverades",
	"promoveras",
	"promoverats",
	"propagerades",
	"propageras",
	"propangas",
	"proportioneras",
	"proppades",
	"proppas",
	"prosperas",
	"prostituerades",
	"protokollfördes",
	"provades",
	"prövades",
	"provas",
	"prövas",
	"provats",
	"prövats",
	"provbyggs",
	"provflugits",
	"provfotograferas",
	"provköras",
	"provkördes",
	"provkörs",
	"provmålats",
	"provmäts",
	"provocerades",
	"provoceras",
	"provocerats",
	"provsås",
	"provsittas",
	"provsmakades",
	"provsmakas",
	"provtagas",
	"prsenterats",
	"prutades",
	"prutas",
	"prutats",
	"pryddes",
	"pryds",
	"pryglas",
	"prytts",
	"pseudomonas",
	"publicerades",
	"publiceras",
	"publicerats",
	"publiserades",
	"pudrats",
	"puffas",
	"pulvriserades",
	"pulvriserats",
	"pumpades",
	"pumpas",
	"pumpats",
	"pundits",
	"punktades",
	"punkterades",
	"punkteras",
	"punkterats",
	"punktmarkerats",
	"purprades",
	"pussades",
	"pussas",
	"pussats",
	"pusslades",
	"pusslas",
	"pustas",
	"putsades",
	"putsas",
	"putsats",
	"puttades",
	"puttas",
	"puttats",
	"puttrades",
	"pyntas",
	"pyntats",
	"pysslades",
	"pysslas",
	"pytsas",
	"pytsats",
	"rabatteras",
	"rabblas",
	"räckes",
	"räcktes",
	"räckts",
	"radades",
	"radas",
	"rådas",
	"radats",
	"räddades",
	"räddas",
	"räddats",
	"råddes",
	"raderades",
	"raderas",
	"raderats",
	"rädes",
	"rådfrågats",
	"radiaksmittades",
	"radikaliserades",
	"radikaliseras",
	"radikaliserats",
	"radonsanerats",
	"råds",
	"raffineras",
	"raffinerats",
	"rafsas",
	"raggades",
	"raggats",
	"raggefanns",
	"rakades",
	"rakas",
	"rakats",
	"råknas",
	"raljerades",
	"raljeras",
	"ramades",
	"ramas",
	"ramats",
	"rammades",
	"rammas",
	"rånades",
	"rånas",
	"rånats",
	"rändes",
	"rangeras",
	"rangordnades",
	"rangordnas",
	"rankades",
	"rankas",
	"rankats",
	"rankingras",
	"rannsakades",
	"rannsakas",
	"rannsakats",
	"ransonerades",
	"ransoneras",
	"rapporterades",
	"rapporteras",
	"rapporterats",
	"rasas",
	"raserades",
	"raseras",
	"raserats",
	"rasslades",
	"rastas",
	"ratades",
	"rätades",
	"ratas",
	"rätas",
	"ratatas",
	"ratats",
	"rätats",
	"ratificerades",
	"ratificeras",
	"ratificerats",
	"ratifieras",
	"rationaliseras",
	"rationaliserats",
	"rattades",
	"rättades",
	"rättas",
	"rättats",
	"ravennas",
	"reades",
	"readymades",
	"reageras",
	"reaktiveras",
	"realiserades",
	"realiseras",
	"realiserats",
	"reas",
	"reavinstbeskattas",
	"rebbes",
	"recenserades",
	"recenseras",
	"recenserats",
	"reciteras",
	"redas",
	"redbergslids",
	"reddes",
	"redigerades",
	"redigeras",
	"redigerats",
	"redogjordes",
	"redogjorts",
	"redogörs",
	"redovisades",
	"redovisas",
	"redovisats",
	"reds",
	"reducerades",
	"reduceras",
	"reducerats",
	"refererades",
	"refereras",
	"refererats",
	"reflekterades",
	"reflekteras",
	"reflexräddades",
	"reformerades",
	"reformeras",
	"reformerats",
	"refuserades",
	"refuseras",
	"refuserats",
	"regelsattes",
	"regenereras",
	"regerades",
	"regeras",
	"regerats",
	"regeringsbehandlas",
	"regisserades",
	"regisseras",
	"regisserats",
	"registeras",
	"registerkontrolleras",
	"registrerades",
	"registreras",
	"registrerats",
	"registreringsbesiktigas",
	"reglats",
	"reglerades",
	"regleras",
	"reglerats",
	"regummeras",
	"rehabiliterades",
	"rehabiliteras",
	"rehabiliterats",
	"reintegreras",
	"reinvesteras",
	"rekapituleras",
	"rekatolicerades",
	"reklamas",
	"reklamerades",
	"reklameras",
	"reklamfinansieras",
	"reklamplats",
	"reklamspots",
	"rekommederas",
	"rekommenderades",
	"rekommenderas",
	"rekommenderats",
	"rekommeneras",
	"rekonstruerades",
	"rekonstrueras",
	"rekonstruerats",
	"rekontextualiseras",
	"rekryterades",
	"rekryteras",
	"rekryterats",
	"rekryteringsbas",
	"rekvierades",
	"rekvirerades",
	"rekvireras",
	"rekvirerats",
	"relanserades",
	"relaterades",
	"relateras",
	"relaterats",
	"relativiserades",
	"relativiseras",
	"relegerades",
	"relegeras",
	"relegerats",
	"remissbehandlades",
	"remissbehandlas",
	"remissbehandlats",
	"remitterades",
	"remitteras",
	"remitterats",
	"remixas",
	"renas",
	"renats",
	"rengjordes",
	"rengjorts",
	"rengöras",
	"rengörs",
	"rennes",
	"renodlades",
	"renodlas",
	"renodlats",
	"renoverades",
	"renoveras",
	"renoverats",
	"renrakats",
	"rensades",
	"rensas",
	"rensats",
	"renskrapas",
	"renskrivas",
	"rentvås",
	"reopererades",
	"reparerades",
	"repareras",
	"reparerats",
	"repas",
	"repatrierades",
	"repatrieras",
	"repats",
	"repererades",
	"repeterades",
	"repeteras",
	"repeterats",
	"reppas",
	"reprenteras",
	"representerades",
	"representeras",
	"representerats",
	"repriserades",
	"repriseras",
	"reprisvisas",
	"reproduceras",
	"reproducerats",
	"res",
	"resas",
	"reservades",
	"reserverades",
	"reserveras",
	"reserverats",
	"reserves",
	"reses",
	"resonerades",
	"resoneras",
	"respekterades",
	"respekteras",
	"respekterats",
	"restaurerades",
	"restaureras",
	"restaurerats",
	"restes",
	"rests",
	"resulterades",
	"results",
	"retts",
	"returnerades",
	"returneras",
	"returnerats",
	"retuscherades",
	"retuscheras",
	"retuscherats",
	"revalveras",
	"revbensopereras",
	"reviderades",
	"revideras",
	"reviderats",
	"revolutioneras",
	"revolutionerats",
	"revs",
	"rhodes",
	"rias",
	"ridas",
	"rids",
	"riggades",
	"riggas",
	"riksdagsbehandlas",
	"riktades",
	"riktas",
	"riktats",
	"rimmas",
	"ringades",
	"ringaktas",
	"ringas",
	"ringats",
	"ringbarkas",
	"ringdes",
	"ringmärks",
	"ringmärktes",
	"rings",
	"ringts",
	"risades",
	"risas",
	"risats",
	"riseras",
	"riskerades",
	"riskeras",
	"riskerats",
	"rispades",
	"rispats",
	"ristades",
	"ristas",
	"ristats",
	"ritades",
	"ritas",
	"ritats",
	"ritualiserades",
	"ritualiseras",
	"rivas",
	"rives",
	"rivits",
	"rivs",
	"roades",
	"roas",
	"roats",
	"robotbesköts",
	"robotiseras",
	"rockas",
	"roddes",
	"rohmers",
	"rojas",
	"röjas",
	"röjdes",
	"röjs",
	"röjts",
	"rökas",
	"rökfylldes",
	"roks",
	"röks",
	"rökskadas",
	"röktes",
	"rökts",
	"rollas",
	"rollbesatts",
	"rollerblades",
	"romanes",
	"romantiserades",
	"romantiseras",
	"rommas",
	"röntes",
	"röntgades",
	"röntgas",
	"röntgats",
	"rönts",
	"ropades",
	"ropas",
	"ropats",
	"röras",
	"rördes",
	"röres",
	"rörs",
	"rörts",
	"ros",
	"rös",
	"rosades",
	"rosafärgas",
	"rosas",
	"rosats",
	"rosenqvists",
	"rostades",
	"röstades",
	"rostas",
	"röstas",
	"rostats",
	"röstats",
	"rostkyddsbehandlas",
	"rostskyddsbehandlas",
	"rotades",
	"rotas",
	"rötas",
	"rotats",
	"rövades",
	"rövas",
	"rövats",
	"rovdjursdödas",
	"rubbades",
	"rubbas",
	"rubbats",
	"rubricerades",
	"rubriceras",
	"rubricerats",
	"ruckades",
	"ruckas",
	"ruckats",
	"rufsats",
	"ruggats",
	"ruinerades",
	"ruineras",
	"ruinerats",
	"rules",
	"rullades",
	"rullas",
	"rullats",
	"rumlades",
	"rundades",
	"rundas",
	"rundats",
	"rusades",
	"ruskades",
	"ruskas",
	"rustades",
	"rustas",
	"rustats",
	"ryckas",
	"rycks",
	"rycktes",
	"ryckts",
	"ryggskadas",
	"ryktades",
	"ryktas",
	"ryktats",
	"rymms",
	"rynkades",
	"rynkas",
	"rynkats",
	"sabbats",
	"sablades",
	"sablas",
	"sablats",
	"saboterades",
	"saboteras",
	"saboterats",
	"såddes",
	"sades",
	"saftades",
	"saftas",
	"sågades",
	"sågas",
	"sägas",
	"sågats",
	"säges",
	"sägs",
	"sagts",
	"säjs",
	"sakades",
	"sakas",
	"sakbehandlas",
	"säkerhetsklassas",
	"säkerhetsklassats",
	"säkerhetskontrollerats",
	"säkerhetslås",
	"säkerhetsprövas",
	"säkerställas",
	"säkerställs",
	"säkerställts",
	"saknades",
	"saknas",
	"saknats",
	"säkrades",
	"säkras",
	"säkrats",
	"saktades",
	"saktas",
	"såldes",
	"salinas",
	"säljas",
	"säljes",
	"säljs",
	"sållades",
	"sållas",
	"sållats",
	"saltades",
	"saltas",
	"saltats",
	"sålts",
	"saluföras",
	"salufördes",
	"saluförs",
	"samägas",
	"samägs",
	"sambos",
	"samhälls",
	"samköras",
	"samlades",
	"samlas",
	"samlats",
	"samlokaliserats",
	"sammanbindas",
	"sammanblandas",
	"sammanblandats",
	"sammanbringats",
	"sammanbyggts",
	"sammandragits",
	"sammandrogs",
	"sammanfattades",
	"sammanfattas",
	"sammanfattats",
	"sammanflätades",
	"sammanflätas",
	"sammanfogades",
	"sammanfogas",
	"sammanfogats",
	"sammanföras",
	"sammanfördes",
	"sammanförs",
	"sammanförts",
	"sammanhålles",
	"sammanhålls",
	"sammanjämkas",
	"sammankallades",
	"sammankallas",
	"sammankallats",
	"sammanknippades",
	"sammanknippas",
	"sammankopplas",
	"sammanlänkas",
	"sammanlyses",
	"sammansatts",
	"sammanslås",
	"sammansmälts",
	"sammanställas",
	"sammanställdes",
	"sammanställs",
	"sammanställts",
	"sammansvetsas",
	"sammanvägas",
	"sammanvägs",
	"sammanvävas",
	"sammanvigs",
	"samordnades",
	"samordnas",
	"samordnats",
	"samövas",
	"sampas",
	"samplades",
	"sams",
	"samtalas",
	"samverkas",
	"sandas",
	"sändas",
	"sandblästrats",
	"sändes",
	"sänds",
	"sanerades",
	"saneras",
	"sanerats",
	"sängplats",
	"sänkas",
	"sänkes",
	"sänks",
	"sänktes",
	"sanktioneras",
	"sanktionerats",
	"sänkts",
	"sänts",
	"saperas",
	"sårades",
	"såras",
	"säras",
	"sårats",
	"särbehandlades",
	"särbehandlas",
	"särbehandlats",
	"särbeskattas",
	"sargades",
	"sargas",
	"sargats",
	"särmärkas",
	"särnoteras",
	"sarrautes",
	"särredovisas",
	"särskildes",
	"särskiljas",
	"sas",
	"sås",
	"satanas",
	"satsades",
	"satsas",
	"satsats",
	"sättas",
	"sattes",
	"sättes",
	"satts",
	"såtts",
	"sätts",
	"scarletts",
	"schabblas",
	"schablonberäknas",
	"schabloniserats",
	"schackras",
	"schackrats",
	"schaktades",
	"schaktas",
	"schasas",
	"schemalades",
	"schemaläggas",
	"schemaläggs",
	"schnapps",
	"schweppes",
	"scorseses",
	"scoutades",
	"scoutats",
	"seedades",
	"seedas",
	"seglades",
	"seglarskolas",
	"seglas",
	"seglats",
	"segregerats",
	"sehlstedts",
	"sehnsuchts",
	"sekretessbeläggs",
	"sekretessbelagts",
	"sekretessläggs",
	"sekretesstämplas",
	"sekulariserades",
	"sekulariseras",
	"sekunderades",
	"sekunderas",
	"sekvenseras",
	"selekteras",
	"senarelades",
	"senareläggas",
	"senareläggs",
	"senarelagts",
	"sentimentaliserades",
	"separerades",
	"separeras",
	"separerats",
	"seriekopplas",
	"serieproducerades",
	"serietillverkas",
	"serietillverkats",
	"servas",
	"serverades",
	"serveras",
	"serverats",
	"setts",
	"severas",
	"sexdubblades",
	"sexfaldigats",
	"sextrakasseras",
	"sfinnas",
	"shardiks",
	"shinglas",
	"shonas",
	"sias",
	"sicas",
	"sidenförsätts",
	"sidoackrediteras",
	"sidoordnas",
	"sidsteppades",
	"sifferbestämmas",
	"signalerades",
	"signaleras",
	"signaliserades",
	"signerades",
	"signeras",
	"signerats",
	"siktades",
	"siktas",
	"siktats",
	"silades",
	"silas",
	"simmas",
	"simuleras",
	"simulerats",
	"sindings",
	"sinkades",
	"sinkas",
	"sinkats",
	"sintras",
	"sirpas",
	"sittas",
	"sivas",
	"sjabblades",
	"sjabblas",
	"självfinansieras",
	"självregleras",
	"sjanghajas",
	"sjasas",
	"sjöds",
	"sjöngs",
	"sjösättas",
	"sjösattes",
	"sjösatts",
	"sjösätts",
	"sjufaldigats",
	"sjukdomsförklarats",
	"sjukskrivas",
	"sjukskrivits",
	"sjukskrivs",
	"sjungas",
	"sjunges",
	"sjungits",
	"sjungs",
	"skadades",
	"skadas",
	"skådas",
	"skadats",
	"skådats",
	"skades",
	"skaffades",
	"skaffas",
	"skaffats",
	"skakades",
	"skakas",
	"skakats",
	"skäktas",
	"skalades",
	"skålades",
	"skalas",
	"skålas",
	"skalats",
	"skalkeas",
	"skallades",
	"skållas",
	"skällas",
	"skälldes",
	"skälls",
	"skålslipas",
	"skambeläggs",
	"skämdes",
	"skamfilats",
	"skämmas",
	"skäms",
	"skämtades",
	"skämtas",
	"skämts",
	"skändades",
	"skandaliserades",
	"skändas",
	"skändats",
	"skanderades",
	"skanderas",
	"skänkas",
	"skänkes",
	"skänks",
	"skänktes",
	"skänkts",
	"skapades",
	"skåpades",
	"skapas",
	"skåpas",
	"skapats",
	"skåras",
	"skäras",
	"skäres",
	"skärhöras",
	"skärmades",
	"skärmas",
	"skärpas",
	"skarpnäcks",
	"skärps",
	"skärptes",
	"skärpts",
	"skars",
	"skärs",
	"skärscannrats",
	"skärskådades",
	"skärskådas",
	"skarvades",
	"skarvas",
	"skattades",
	"skattas",
	"skattebefrias",
	"skattefinansieras",
	"skatteprivilegieras",
	"skattesubventineras",
	"skattesubventioneras",
	"skattlades",
	"skavas",
	"skavdes",
	"skavts",
	"skenbeskattas",
	"skeppades",
	"skeppas",
	"skeppats",
	"skickades",
	"skickas",
	"skickats",
	"skickliggjordes",
	"skiftades",
	"skiftas",
	"skiftats",
	"skiktas",
	"skildes",
	"skildrades",
	"skildras",
	"skildrats",
	"skiljas",
	"skiljdes",
	"skiljs",
	"skiljts",
	"skilldes",
	"skils",
	"skilts",
	"skingrades",
	"skingras",
	"skingrats",
	"skinnades",
	"skinnas",
	"skinnheads",
	"skins",
	"skipades",
	"skipas",
	"skipats",
	"skippades",
	"skissades",
	"skissas",
	"skissats",
	"skisserades",
	"skisseras",
	"skisserats",
	"skivas",
	"skivats",
	"skivinspelas",
	"skjöts",
	"skjutas",
	"skjutits",
	"skjuts",
	"skjutsades",
	"skjutsas",
	"skockades",
	"skockas",
	"skockats",
	"skogas",
	"skogås",
	"skojades",
	"skojas",
	"skojats",
	"skolades",
	"skolas",
	"skolats",
	"sköljas",
	"sköljdes",
	"sköljs",
	"sköljts",
	"skolmognadstestas",
	"skonades",
	"skonas",
	"skonats",
	"skönjas",
	"skönjdes",
	"skönjes",
	"skönjs",
	"sköntaxeras",
	"sköras",
	"skördades",
	"skördas",
	"skördats",
	"skörtats",
	"skotas",
	"skötas",
	"sköts",
	"skottas",
	"skottats",
	"sköttes",
	"skötts",
	"skottskadades",
	"skottskadas",
	"skottskadats",
	"skovlades",
	"skövlades",
	"skovlas",
	"skövlas",
	"skövlats",
	"skräddarsyddes",
	"skräddarsys",
	"skräddarsytts",
	"skräddas",
	"skrålades",
	"skrålas",
	"skrämdes",
	"skrämmas",
	"skräms",
	"skränas",
	"skrapades",
	"skrapas",
	"skrapats",
	"skrattades",
	"skrattas",
	"skrattats",
	"skrävlas",
	"skreds",
	"skreks",
	"skrevs",
	"skrikas",
	"skriks",
	"skringrats",
	"skrinlades",
	"skrinläggas",
	"skrinläggs",
	"skrinlagts",
	"skrivas",
	"skrives",
	"skrivits",
	"skrivs",
	"skrotades",
	"skrotas",
	"skrotats",
	"skröts",
	"skrubbades",
	"skrubbas",
	"skrubbats",
	"skrudas",
	"skruvades",
	"skruvas",
	"skruvats",
	"skrynklades",
	"skuffades",
	"skuffas",
	"skuffats",
	"skuggades",
	"skuggas",
	"skuggats",
	"skuggboxades",
	"skuggboxas",
	"skuldbeläggs",
	"skulpterades",
	"skulpteras",
	"skulpterats",
	"skummas",
	"skummats",
	"skurades",
	"skuras",
	"skurats",
	"skurits",
	"skvallrades",
	"skvallras",
	"skvalpas",
	"skvätts",
	"skyddades",
	"skyddas",
	"skyddats",
	"skyddes",
	"skyfflades",
	"skyfflas",
	"skyfflats",
	"skylas",
	"skyles",
	"skyllas",
	"skylldes",
	"skylls",
	"skyllts",
	"skyls",
	"skyltades",
	"skyltas",
	"skyltats",
	"skymdes",
	"skymfas",
	"skymfats",
	"skymmas",
	"skyms",
	"skymtades",
	"skymtas",
	"skymts",
	"skyndas",
	"skyttegilles",
	"släckas",
	"släcks",
	"släcktes",
	"släckts",
	"slaktades",
	"slaktas",
	"slaktats",
	"slammades",
	"slammas",
	"slamras",
	"slamsas",
	"slängas",
	"slängdes",
	"slänges",
	"slängs",
	"slängts",
	"släpades",
	"släpas",
	"släpats",
	"slappades",
	"släppas",
	"släppptes",
	"släpps",
	"släpptes",
	"släppts",
	"slarvades",
	"slarvas",
	"slarvats",
	"slås",
	"slätades",
	"slätas",
	"slätats",
	"slåttrades",
	"slåttras",
	"slavas",
	"slets",
	"slickades",
	"slickas",
	"slickats",
	"slipades",
	"slipas",
	"slipats",
	"slitas",
	"slites",
	"slitits",
	"slits",
	"slopades",
	"slopas",
	"slopats",
	"slösas",
	"slösats",
	"slöts",
	"slukades",
	"slukas",
	"slukats",
	"slumpades",
	"slumpas",
	"slumsaneras",
	"slungades",
	"slungas",
	"slungats",
	"slussades",
	"slussas",
	"slussats",
	"slutades",
	"slutas",
	"slutavverkades",
	"slutbearbetas",
	"slutbehandlas",
	"slutbetalades",
	"slutbetalas",
	"slutes",
	"slutföras",
	"slutfördes",
	"slutförhandlades",
	"slutförhandlas",
	"slutförhandlats",
	"slutförs",
	"slutförts",
	"slutförvaras",
	"slutits",
	"slutlevereras",
	"slutmonteras",
	"slutnoterades",
	"slutrepeteras",
	"sluts",
	"slutspelas",
	"sluttestas",
	"småbråkas",
	"smädas",
	"småfräs",
	"småfrös",
	"småjävlas",
	"smakas",
	"smaksättas",
	"smaksättes",
	"smaksatts",
	"smaksätts",
	"smakvarieras",
	"smälldes",
	"smalls",
	"smälls",
	"smällts",
	"smalnas",
	"smältas",
	"smältes",
	"smälts",
	"småretades",
	"smekas",
	"smeks",
	"smektes",
	"smetades",
	"smetas",
	"smetats",
	"smets",
	"smidas",
	"smiddes",
	"smides",
	"smidits",
	"smids",
	"sminkades",
	"sminkas",
	"smiskas",
	"smittades",
	"smittas",
	"smittats",
	"smitts",
	"smögs",
	"smordes",
	"smörjas",
	"smörjs",
	"smorts",
	"smugglades",
	"smugglas",
	"smugglats",
	"smugits",
	"smulades",
	"smulas",
	"smulats",
	"smusslades",
	"smusslas",
	"smusslats",
	"smutsades",
	"smutsas",
	"smutsats",
	"smutskastas",
	"smuttas",
	"smyckades",
	"smyckas",
	"smyckats",
	"smygas",
	"smygavlyssnades",
	"smygfilmades",
	"smygits",
	"smygs",
	"snabbbehandlas",
	"snabbehandlas",
	"snabbfrysas",
	"snabbinkallades",
	"snabbinkallas",
	"snabbkäftades",
	"snabbkopieras",
	"snabbladdas",
	"snabbredigeras",
	"snabbreparerats",
	"snabbstoppades",
	"snabbstoppas",
	"snabbtolkas",
	"snabbutbildas",
	"snabbutredas",
	"snabbutreds",
	"snackades",
	"snackas",
	"snackats",
	"snålas",
	"snålkodas",
	"snappades",
	"snappas",
	"snarats",
	"snärjas",
	"snärjdes",
	"snärjs",
	"snärjts",
	"snattas",
	"snävas",
	"snävats",
	"snedgås",
	"snedvridas",
	"snedvridits",
	"snedvrids",
	"sneglas",
	"snickrades",
	"snickrats",
	"sniffas",
	"snittas",
	"snöpas",
	"snördes",
	"snörptes",
	"snörs",
	"snörts",
	"snörvlades",
	"snos",
	"snotts",
	"snubblas",
	"snuddades",
	"snurrades",
	"snurras",
	"snuttas",
	"snuvades",
	"snuvas",
	"snuvats",
	"snyftades",
	"snyggas",
	"snyggats",
	"snyltas",
	"soares",
	"socialdelegerades",
	"socialiseras",
	"socialiserats",
	"socialistes",
	"sockras",
	"sockrats",
	"södras",
	"sögs",
	"sökas",
	"sökes",
	"söks",
	"söktes",
	"sökts",
	"sölades",
	"solas",
	"solkas",
	"solkats",
	"solochvåras",
	"sonas",
	"soncks",
	"sönderdelas",
	"sönderskakas",
	"sönderslets",
	"sönderslitas",
	"sönderstyckades",
	"sondmatades",
	"söndras",
	"songs",
	"sopades",
	"sopas",
	"sopats",
	"söps",
	"sörjdes",
	"sörjes",
	"sörjs",
	"sorlades",
	"sorlas",
	"sörplas",
	"sorterades",
	"sorteras",
	"sorterats",
	"sotades",
	"sötades",
	"sotas",
	"sötas",
	"sötats",
	"sovas",
	"sövas",
	"sövdes",
	"sovelbitarnas",
	"sovras",
	"sovs",
	"sövs",
	"sövts",
	"späckas",
	"spacklas",
	"spädas",
	"spåddes",
	"späddes",
	"späds",
	"spaghettisås",
	"spaltades",
	"spaltas",
	"spanas",
	"spändes",
	"spångas",
	"spännas",
	"spanns",
	"spänns",
	"spänts",
	"sparades",
	"spårades",
	"sparas",
	"spåras",
	"sparats",
	"spårats",
	"sparkades",
	"sparkas",
	"sparkats",
	"spärrades",
	"spärras",
	"spärrats",
	"spärrförklarats",
	"spås",
	"späs",
	"spåtts",
	"spätts",
	"specialbeställas",
	"specialbeställdes",
	"specialbeställts",
	"specialbevakas",
	"specialbyggdes",
	"specialbyggts",
	"specialdesignats",
	"specialdestineras",
	"specialdrillas",
	"specialgranskades",
	"specialgranskats",
	"specialinretts",
	"specialiseras",
	"specialistutbildades",
	"specialkonstruerades",
	"speciallottats",
	"specialpreparerats",
	"specialrekryterats",
	"specialriktats",
	"specialskrevs",
	"specialskrivs",
	"specialstuderades",
	"specialtillverkas",
	"specialutbildas",
	"specialutbildats",
	"specificerades",
	"specificeras",
	"specificerats",
	"speedas",
	"speglades",
	"speglas",
	"speglats",
	"spejas",
	"spekulerades",
	"spekuleras",
	"spekulerats",
	"spelades",
	"spelas",
	"spelats",
	"spenderades",
	"spenderas",
	"spenderats",
	"spetsades",
	"spetsas",
	"spetsats",
	"spikades",
	"spikas",
	"spikats",
	"spillas",
	"spilldes",
	"spills",
	"spillts",
	"spinnas",
	"spinns",
	"spioneras",
	"spionmisstänktes",
	"spiras",
	"spisas",
	"spjälkades",
	"spjälkas",
	"splitsas",
	"splitterskadades",
	"splittrades",
	"splittras",
	"splittrats",
	"spolades",
	"spolas",
	"spolats",
	"spolierades",
	"spolieras",
	"spolierats",
	"sponsrades",
	"sponsras",
	"sponsrats",
	"spörjs",
	"sporrades",
	"sporras",
	"spörs",
	"sports",
	"spottades",
	"spottas",
	"spräckas",
	"spräcks",
	"spräcktes",
	"spräckts",
	"språktestas",
	"sprängas",
	"sprangs",
	"sprängs",
	"sprängts",
	"sprättades",
	"sprättas",
	"sprätts",
	"sprayas",
	"sprayats",
	"spreds",
	"sprejas",
	"sprejats",
	"spridas",
	"spriddes",
	"sprides",
	"spridits",
	"sprids",
	"springas",
	"springs",
	"spritas",
	"spritsas",
	"spritsats",
	"spritts",
	"sprödvärmts",
	"sprungits",
	"sprutades",
	"sprutas",
	"spunnits",
	"spurtades",
	"stabiliserades",
	"stabiliseras",
	"stabiliserats",
	"stäckas",
	"stacks",
	"stäcktes",
	"städades",
	"städas",
	"städats",
	"städes",
	"stadfästas",
	"stadfästes",
	"stadfästs",
	"stadgas",
	"stadgats",
	"städslades",
	"städslas",
	"städslats",
	"stagades",
	"stagas",
	"stajlas",
	"stakades",
	"stakas",
	"stakats",
	"stålas",
	"stallas",
	"ställas",
	"ställdes",
	"ställes",
	"ställs",
	"ställts",
	"stals",
	"stämdes",
	"stammas",
	"stämmas",
	"stampades",
	"stampas",
	"stämplades",
	"stämplas",
	"stämplats",
	"stäms",
	"stämts",
	"ständigtmåstegöras",
	"stångades",
	"stångas",
	"stängas",
	"stångats",
	"stängdes",
	"stängs",
	"stängts",
	"stånkas",
	"stänkas",
	"stänkts",
	"stannades",
	"stansas",
	"stansats",
	"staplades",
	"staplas",
	"staplats",
	"starkars",
	"stärkas",
	"stärks",
	"stärktes",
	"stärkts",
	"startades",
	"startas",
	"startats",
	"startgas",
	"stås",
	"stationerades",
	"stationeras",
	"stationerats",
	"statuerades",
	"statueras",
	"stavades",
	"stavas",
	"stavats",
	"stävjas",
	"stegas",
	"steglas",
	"stegrades",
	"stegras",
	"stegrats",
	"stekas",
	"steks",
	"stektes",
	"stekts",
	"stenades",
	"stenas",
	"stencilerats",
	"stenungsundshems",
	"steriliseras",
	"stickas",
	"stickats",
	"sticks",
	"stiftades",
	"stiftas",
	"stiftats",
	"stigmatiserades",
	"stigmatiseras",
	"stiliserats",
	"stillas",
	"stillats",
	"stills",
	"stimmades",
	"stimulerades",
	"stimuleras",
	"stimulerats",
	"stipendierats",
	"stipulerades",
	"stipuleras",
	"stjälas",
	"stjälpas",
	"stjälps",
	"stjälptes",
	"stjäls",
	"stockas",
	"stockholmsanpassats",
	"stockholmutsätts",
	"stöddes",
	"stödjas",
	"stöds",
	"stöldanmäldes",
	"stöldanmälts",
	"stöldresas",
	"stomiopererades",
	"stomiopereras",
	"stöpas",
	"stoppades",
	"stoppas",
	"stoppats",
	"stopppades",
	"stöps",
	"stöptes",
	"stöpts",
	"störas",
	"stördes",
	"storklas",
	"stormades",
	"stormas",
	"stormats",
	"stormfälldes",
	"stormtrivas",
	"stormtrivs",
	"störs",
	"storstädas",
	"storstädats",
	"störtades",
	"störtas",
	"störtats",
	"stortrivas",
	"stortrivdes",
	"stortrivs",
	"stortrutades",
	"störts",
	"stötas",
	"stötes",
	"stöts",
	"stöttades",
	"stöttas",
	"stöttats",
	"stöttes",
	"stötts",
	"sträckas",
	"sträcks",
	"sträcktes",
	"sträckts",
	"straffades",
	"straffas",
	"straffats",
	"straffbeläggas",
	"straffbeskattas",
	"straffsanktioneras",
	"strålas",
	"strålbehandlas",
	"strålbehandlats",
	"strålningstestas",
	"strålskadades",
	"stramades",
	"stramas",
	"stramats",
	"strandades",
	"strandats",
	"strandsattes",
	"strävas",
	"streckas",
	"strejkas",
	"strejkats",
	"stressades",
	"stressas",
	"stretchats",
	"strids",
	"strilas",
	"strimlas",
	"strimlats",
	"strimmades",
	"ströddes",
	"ströks",
	"strömlinjeformas",
	"ströps",
	"strös",
	"strötts",
	"strukits",
	"strukturerades",
	"struktureras",
	"strukturerats",
	"strukturrationaliserades",
	"strykas",
	"strykes",
	"stryks",
	"strypas",
	"strypes",
	"stryps",
	"stryptes",
	"strypts",
	"stuckits",
	"studerades",
	"studeras",
	"studerats",
	"stuffas",
	"stukades",
	"stukas",
	"stukats",
	"stulits",
	"stunts",
	"stuvades",
	"stuvas",
	"stuvats",
	"styckades",
	"styckas",
	"styckats",
	"stylades",
	"stylas",
	"stylats",
	"stympades",
	"stympas",
	"stympats",
	"styras",
	"styrdes",
	"styrkas",
	"styrks",
	"styrktes",
	"styrkts",
	"styrs",
	"styrts",
	"sublimeras",
	"subtraheras",
	"subventionerades",
	"subventioneras",
	"subventionerats",
	"suckas",
	"suddades",
	"suddas",
	"suddats",
	"sufflerats",
	"sugas",
	"suges",
	"sugits",
	"sugs",
	"summerades",
	"summeras",
	"summerats",
	"supes",
	"supits",
	"sups",
	"surkörs",
	"surrades",
	"surras",
	"susades",
	"suspenderades",
	"suspenderas",
	"suspenderats",
	"svagbegåvades",
	"svaldes",
	"sväljas",
	"sväljs",
	"svalkas",
	"svälldes",
	"svältas",
	"svälts",
	"svämmas",
	"svämmats",
	"svängdes",
	"svängs",
	"svängts",
	"svanskuperas",
	"svarades",
	"svaras",
	"sväras",
	"svärs",
	"svärtades",
	"svärtas",
	"svärtats",
	"svartlistades",
	"svartlistas",
	"svartlistats",
	"svartmålades",
	"svartmålas",
	"svartmålats",
	"svedas",
	"svekivs",
	"sveks",
	"svennevads",
	"svepas",
	"svepes",
	"sveps",
	"sveptes",
	"svepts",
	"svetlas",
	"svetsades",
	"svetsas",
	"svikas",
	"svikits",
	"sviks",
	"svinas",
	"svingades",
	"svingas",
	"svors",
	"svurits",
	"swandes",
	"syddes",
	"sydgas",
	"syds",
	"syftas",
	"sykes",
	"syltades",
	"syltas",
	"symboliserades",
	"symboliseras",
	"sympatilockoutas",
	"sympatiseras",
	"synades",
	"synats",
	"syndats",
	"synkroniseras",
	"synliggjordes",
	"synliggjorts",
	"synliggöras",
	"synliggörs",
	"syntetiserats",
	"syresättas",
	"syresätts",
	"syrsätts",
	"sys",
	"sysselsättas",
	"sysselsattes",
	"sysselsätts",
	"sytts",
	"tackades",
	"tackas",
	"täckas",
	"tacklades",
	"tacklas",
	"täcks",
	"täcktes",
	"täckts",
	"tagas",
	"tages",
	"tagits",
	"tags",
	"talades",
	"talas",
	"tålas",
	"talats",
	"tåldes",
	"tallas",
	"tallriksserveras",
	"tåls",
	"talts",
	"tämjas",
	"tämjs",
	"tämjts",
	"tändas",
	"tändes",
	"tänds",
	"tångas",
	"tangerades",
	"tangeras",
	"tangerats",
	"tangiers",
	"tångonduleras",
	"tänjas",
	"tänjdes",
	"tänjes",
	"tänjs",
	"tänjts",
	"tankas",
	"tänkas",
	"tänkes",
	"tänks",
	"tänkts",
	"tänts",
	"tapetserades",
	"tapetserats",
	"tappades",
	"tappas",
	"tappats",
	"täpps",
	"tårades",
	"tareras",
	"tärnas",
	"tärts",
	"tarvas",
	"tas",
	"tasslades",
	"tasslas",
	"tätades",
	"tätas",
	"tävlades",
	"tävlas",
	"tävlats",
	"taxeras",
	"taxerats",
	"technologies",
	"tecknades",
	"tecknas",
	"tecknats",
	"tegs",
	"teiresias",
	"tejakulas",
	"tejpades",
	"tejpas",
	"tejpats",
	"teknologiseras",
	"telefaxbekräftas",
	"telefonavlyssnas",
	"telefonerades",
	"telefonintervjuades",
	"telefonterroriseras",
	"telegraferats",
	"televiserades",
	"televiseras",
	"telias",
	"telomeras",
	"tematiserades",
	"tematiseras",
	"tempereras",
	"terminerats",
	"terminssäkras",
	"terroriserades",
	"terroriseras",
	"terroriserats",
	"terroriststämplas",
	"terroriststämplats",
	"testades",
	"testamenterats",
	"testas",
	"testats",
	"testkörs",
	"textas",
	"thorgils",
	"tidigarelades",
	"tidigareläggas",
	"tidigareläggs",
	"tidigarelagts",
	"tidsbegränsas",
	"tidsbegränsats",
	"tidsbestämdes",
	"tidsbestämmas",
	"tidsbestäms",
	"tidsbestämts",
	"tidsflödes",
	"tidsordnats",
	"tietotehdas",
	"tigits",
	"tigs",
	"tillades",
	"tillagas",
	"tillägas",
	"tilläggas",
	"tilläggs",
	"tilläggsdebiteras",
	"tillägnades",
	"tillägnas",
	"tillägnats",
	"tillämmpas",
	"tillämpades",
	"tillämpas",
	"tillämpats",
	"tillåtas",
	"tillåtes",
	"tillåtits",
	"tillåts",
	"tilläts",
	"tillbads",
	"tillbakabildas",
	"tillbakabildats",
	"tillbakavisades",
	"tillbakavisas",
	"tillbakavisats",
	"tillbakes",
	"tillbes",
	"tillbetts",
	"tillbringades",
	"tillbringas",
	"tillbyggts",
	"tillbytas",
	"tilldelades",
	"tilldelas",
	"tilldelats",
	"tilldömas",
	"tilldömdes",
	"tilldöms",
	"tilldömts",
	"tillerkändes",
	"tillerkännas",
	"tillerkänns",
	"tillerkänts",
	"tillfångatagits",
	"tillfångatas",
	"tillfångatogs",
	"tillfogades",
	"tillfogas",
	"tillfogats",
	"tillföras",
	"tillfördes",
	"tillförs",
	"tillförsäkras",
	"tillförsäkrats",
	"tillförts",
	"tillfrågades",
	"tillfrågas",
	"tillfrågats",
	"tillfredsställas",
	"tillfredsställdes",
	"tillfredsställs",
	"tillgivits",
	"tillgodoräknas",
	"tillgodosågs",
	"tillgodoses",
	"tillgodosetts",
	"tillgreps",
	"tillgripas",
	"tillgripes",
	"tillgripits",
	"tillgrips",
	"tillhållas",
	"tillhålls",
	"tillhandahållas",
	"tillhandahålles",
	"tillhandahålls",
	"tillhandahölls",
	"tillhandhölls",
	"tillhölls",
	"tillintetgjorts",
	"tillintetgörs",
	"tillkallades",
	"tillkallas",
	"tillkallats",
	"tillkännagavs",
	"tillkännages",
	"tillkännagetts",
	"tillkännagivits",
	"tillläggas",
	"tilllämpas",
	"tilllämpats",
	"tilllåtas",
	"tilllåtits",
	"tilllåts",
	"tillläts",
	"tillmätas",
	"tillmätits",
	"tillmäts",
	"tillmättes",
	"tillmätts",
	"tillmötesgås",
	"tillönskas",
	"tillordnas",
	"tillråddes",
	"tillrådes",
	"tillråds",
	"tillrättaläggs",
	"tillrättavisas",
	"tillredas",
	"tillreds",
	"tillretts",
	"tillryggalades",
	"tillsägs",
	"tillsagts",
	"tillsamamns",
	"tillsammamns",
	"tillsammas",
	"tillsammns",
	"tillsändas",
	"tillsas",
	"tillsättas",
	"tillsattes",
	"tillsatts",
	"tillsätts",
	"tillses",
	"tillskapas",
	"tillskapats",
	"tillskjuts",
	"tillskrevs",
	"tillskrivas",
	"tillskrives",
	"tillskrivits",
	"tillskrivs",
	"tillspetsades",
	"tillspetsas",
	"tillspetsats",
	"tillställas",
	"tillställdes",
	"tillställs",
	"tillställts",
	"tillstås",
	"tillstyrks",
	"tillstyrktes",
	"tillstyrkts",
	"tilltalades",
	"tilltalas",
	"tilltalats",
	"tillträdas",
	"tilltros",
	"tillvaratagas",
	"tillvaratagits",
	"tillvaratas",
	"tillvaratogs",
	"tillverkades",
	"tillverkas",
	"tillverkats",
	"tillvitades",
	"tillvitas",
	"tillvitats",
	"tillyxas",
	"tinas",
	"tinats",
	"tingades",
	"tingas",
	"tingats",
	"tiodubblades",
	"tiodubblas",
	"tiodubblats",
	"tiofaldigades",
	"tiofaldigas",
	"tiofaldigats",
	"tippades",
	"tippas",
	"tippats",
	"tipsades",
	"tipsas",
	"tipsats",
	"tisslades",
	"tisslas",
	"tittas",
	"titulerades",
	"tituleras",
	"tivs",
	"tjafsas",
	"tjågas",
	"tjänades",
	"tjänas",
	"tjänats",
	"tjatades",
	"tjatas",
	"tjatats",
	"tjoas",
	"tjubajs",
	"tjudras",
	"tjusades",
	"tjusas",
	"tjusats",
	"tjuvkopplas",
	"tjuvlästes",
	"tjyvröktes",
	"togs",
	"töjdes",
	"töjs",
	"tolererades",
	"tolereras",
	"tolererats",
	"tolkades",
	"tolkas",
	"tolkats",
	"tolvdubblats",
	"tolvfaldigats",
	"tömdes",
	"tömmas",
	"tommingas",
	"töms",
	"tömts",
	"tonades",
	"tonas",
	"tonats",
	"toppades",
	"toppas",
	"toppats",
	"topplaceras",
	"topprenoverats",
	"toppseedats",
	"toppstyras",
	"tordas",
	"torgföras",
	"torgfördes",
	"torgförs",
	"torkades",
	"torkas",
	"torkats",
	"tornbas",
	"torpederades",
	"torpederas",
	"torpederats",
	"torrkokas",
	"torrlades",
	"torrläggas",
	"torrläggs",
	"torrlagts",
	"torrmarineras",
	"torrsättas",
	"torrsätts",
	"torterades",
	"torteras",
	"torterats",
	"torts",
	"totalassimilerats",
	"totalavvekas",
	"totalbojkottats",
	"totaldemolerats",
	"totalfinansieras",
	"totalförbjöds",
	"totalförbjudas",
	"totalförbjudits",
	"totalförbjuds",
	"totalförlamades",
	"totalförlamas",
	"totalförstöras",
	"totalförstördes",
	"totalförstörs",
	"totalförstörts",
	"totalförsvarspliktigas",
	"totalfredades",
	"totalintegrerats",
	"totalredovisas",
	"totalrenoverades",
	"totalrenoveras",
	"totalsaneras",
	"totalstoppas",
	"tråcklas",
	"tradades",
	"tråddes",
	"träddes",
	"traderas",
	"traderats",
	"trades",
	"trådhäftades",
	"trådhäftas",
	"träds",
	"träffades",
	"träffats",
	"trafikerades",
	"trafikeras",
	"trafikerats",
	"tragglas",
	"trakasserades",
	"trakasseras",
	"trakasserats",
	"trakterades",
	"trakteras",
	"trakterats",
	"trampades",
	"trampats",
	"tramsas",
	"tränades",
	"tränas",
	"tränats",
	"trängas",
	"trängdes",
	"trängs",
	"trängts",
	"transformerades",
	"transformeras",
	"transformerats",
	"transkriberas",
	"transplanterades",
	"transplanteras",
	"transplanterats",
	"transponeras",
	"transporterades",
	"transporteras",
	"transporterats",
	"transportvigas",
	"trappades",
	"trappas",
	"trappats",
	"träs",
	"trasades",
	"trasas",
	"trasats",
	"trasslas",
	"trätas",
	"trätts",
	"traumatiserats",
	"travades",
	"travas",
	"travats",
	"travintresserades",
	"tredskades",
	"tredskas",
	"tredubblades",
	"tredubblas",
	"tredubblats",
	"trefaldigades",
	"trefaldigas",
	"trefaldigats",
	"triffids",
	"trimmades",
	"trimmas",
	"trimmats",
	"trissades",
	"trissats",
	"trivialiserats",
	"trixas",
	"troddes",
	"trollades",
	"trollas",
	"trollats",
	"trollbands",
	"trollbindas",
	"trollbinds",
	"trollbundits",
	"tros",
	"tröskas",
	"tröskats",
	"tröstades",
	"tröstas",
	"tröstats",
	"tröttas",
	"trotts",
	"trotzigs",
	"trubbades",
	"trubbas",
	"trubbats",
	"trumfades",
	"trumfas",
	"trummas",
	"trummats",
	"trumpetades",
	"tryckas",
	"tryckes",
	"trycks",
	"trycktes",
	"tryckts",
	"tryfferades",
	"tryfferas",
	"tryfferats",
	"tryggas",
	"trygghetsavtalets",
	"tryzas",
	"tsokas",
	"tsvetajevas",
	"tubbades",
	"tubbas",
	"tudelades",
	"tudelas",
	"tuggades",
	"tuggas",
	"tuggats",
	"tugindas",
	"tuktades",
	"tuktas",
	"tuktats",
	"tullas",
	"tullbehandlas",
	"tullinges",
	"tullvisiteras",
	"tummas",
	"tunnades",
	"tunnas",
	"tunnats",
	"turades",
	"turas",
	"turats",
	"turistifierats",
	"turneras",
	"tusendubblats",
	"tussas",
	"tutades",
	"tutas",
	"tvåddes",
	"tvålades",
	"tvangs",
	"tvångsanslutas",
	"tvångsavverkades",
	"tvångsevakuerats",
	"tvångsförflyttades",
	"tvångsförflyttas",
	"tvångsförflyttats",
	"tvångsförvaltas",
	"tvångsinlösas",
	"tvångsintagits",
	"tvångskommenderades",
	"tvångskommenderas",
	"tvångsmatades",
	"tvångsmatas",
	"tvångsmatats",
	"tvångsnedflyttades",
	"tvångsomhändertagits",
	"tvångsomhändertas",
	"tvångsomhändertogs",
	"tvångspensionerats",
	"tvångsplaceras",
	"tvångsrekryterades",
	"tvångsrekryteras",
	"tvångstömdes",
	"tvångsvårdas",
	"tvångsvårdats",
	"tvångsvärvas",
	"tvås",
	"tvättades",
	"tvättas",
	"tvättats",
	"tvingades",
	"tvingas",
	"tvingats",
	"tvinnades",
	"tvinnas",
	"tvistades",
	"tvistas",
	"tvistats",
	"tyas",
	"tydas",
	"tyddes",
	"tydliggjordes",
	"tydliggjorts",
	"tydliggöras",
	"tydliggörs",
	"tyds",
	"tyglades",
	"tyglas",
	"tyngas",
	"tyngdes",
	"tyngs",
	"tyngts",
	"typiseras",
	"tyranniserats",
	"tyrolersås",
	"tystades",
	"tystas",
	"tystats",
	"uefas",
	"ugnsbakas",
	"undandras",
	"undanhållas",
	"undanhållits",
	"undanhålls",
	"undanhölls",
	"undanröjas",
	"undanröjdes",
	"undanröjs",
	"undanröjts",
	"undantagits",
	"undantas",
	"undantogs",
	"undanträngas",
	"undanträngs",
	"underbalanseras",
	"underblåses",
	"underblåstes",
	"underbyggs",
	"underdånas",
	"underförstås",
	"undergrävas",
	"undergrävdes",
	"undergrävs",
	"undergrävts",
	"underhållas",
	"underhållits",
	"underhålls",
	"underhölls",
	"underkändes",
	"underkännas",
	"underkänns",
	"underkänts",
	"underkastades",
	"underkastas",
	"underkastats",
	"underkuvas",
	"underkuvats",
	"underlåtas",
	"underlättades",
	"underlättas",
	"underlättats",
	"underminerades",
	"undermineras",
	"underminerats",
	"underordnades",
	"underordnas",
	"underordnats",
	"underrättades",
	"underrättas",
	"underrättats",
	"underskattades",
	"underskattas",
	"underskattats",
	"underskreds",
	"underskridas",
	"underskridits",
	"underskrids",
	"undersökas",
	"undersöks",
	"undersöktes",
	"undersökts",
	"underställas",
	"underställs",
	"understöddes",
	"understödjas",
	"understöds",
	"understötts",
	"underströks",
	"understrukits",
	"understrykas",
	"understryks",
	"undertecknades",
	"undertecknas",
	"undertecknats",
	"underträffades",
	"undertryckas",
	"undertrycks",
	"undertryckts",
	"undervärderas",
	"undervärderats",
	"undervisades",
	"undervisas",
	"undervisats",
	"undfägnades",
	"undfägnas",
	"undfägnats",
	"undrades",
	"undras",
	"undrats",
	"undsättas",
	"undsattes",
	"undvaras",
	"undveks",
	"undvikas",
	"undvikes",
	"undvikits",
	"undviks",
	"unitas",
	"unlimiteds",
	"unnades",
	"unnas",
	"unnras",
	"uoppskattas",
	"upgavs",
	"upmanades",
	"uppammas",
	"uppammats",
	"upparbetas",
	"upparbetats",
	"uppättades",
	"uppbådades",
	"uppbådas",
	"uppbäras",
	"uppbars",
	"uppblandas",
	"uppbrännas",
	"uppbringades",
	"uppbringas",
	"uppbringats",
	"uppbyggas",
	"uppbyggnadsfas",
	"uppdagades",
	"uppdagas",
	"uppdagats",
	"uppdateras",
	"uppdaterats",
	"uppdelades",
	"uppdelas",
	"uppdragits",
	"uppdras",
	"uppdrogs",
	"uppehållas",
	"uppehölls",
	"uppenbarades",
	"uppenbaras",
	"uppenbarats",
	"uppfångades",
	"uppfångas",
	"uppfångats",
	"uppfanns",
	"uppfattades",
	"uppfattas",
	"uppfattats",
	"uppfinnas",
	"uppfinns",
	"uppfödas",
	"uppföddes",
	"uppföds",
	"uppföras",
	"uppfördes",
	"uppförs",
	"uppförstorades",
	"uppförstoras",
	"uppförts",
	"uppfostrades",
	"uppfostras",
	"uppfostrats",
	"uppfunnits",
	"uppfyllas",
	"uppfylles",
	"uppfylls",
	"uppgavs",
	"uppges",
	"uppgetts",
	"uppgives",
	"uppgivits",
	"uppgraderades",
	"uppgraderas",
	"uppgraderats",
	"upphandlades",
	"upphandlas",
	"upphandlats",
	"upphävas",
	"upphävdes",
	"upphävs",
	"upphävts",
	"upphettades",
	"upphettas",
	"upphöjas",
	"upphöjdes",
	"upphöjs",
	"upphöjts",
	"uppjusteras",
	"uppjusterats",
	"uppkallades",
	"uppkallas",
	"uppkallats",
	"upplageras",
	"uppläsas",
	"uppläses",
	"upplästes",
	"upplästs",
	"upplåtas",
	"upplåtes",
	"upplåtits",
	"upplåts",
	"uppläts",
	"uppletas",
	"upplevas",
	"upplevdes",
	"upplevs",
	"upplevts",
	"upplivades",
	"upplös",
	"upplösas",
	"upplöses",
	"upplöstes",
	"upplösts",
	"upplysas",
	"upplyses",
	"upplystes",
	"upplysts",
	"uppmäksammats",
	"uppmålas",
	"uppmanades",
	"uppmanas",
	"uppmanats",
	"uppmandes",
	"uppmärksammades",
	"uppmärksammas",
	"uppmärksammats",
	"uppmätas",
	"uppmäts",
	"uppmättes",
	"uppmätts",
	"uppmuntrades",
	"uppmuntras",
	"uppmuntrats",
	"uppnåddes",
	"uppnås",
	"uppnåtts",
	"uppövats",
	"upppdagas",
	"uppräknades",
	"upprätas",
	"upprättades",
	"upprättas",
	"upprättats",
	"upprätthållas",
	"upprätthålles",
	"upprätthållits",
	"upprätthålls",
	"upprätthölls",
	"upprepades",
	"upprepas",
	"upprepats",
	"uppresas",
	"uppreses",
	"upprestes",
	"uppröras",
	"upprördes",
	"upprörs",
	"upprörts",
	"upprustas",
	"uppsamlades",
	"uppsändas",
	"uppsättas",
	"uppsattes",
	"uppsatts",
	"uppskalas",
	"uppskattades",
	"uppskattas",
	"uppskattats",
	"uppskjutas",
	"uppskjutits",
	"uppskjuts",
	"uppsköts",
	"uppslukades",
	"uppslukas",
	"uppslukats",
	"uppsnappas",
	"uppsökas",
	"uppsöks",
	"uppsöktes",
	"uppsökts",
	"uppställas",
	"uppställs",
	"uppställts",
	"upptäckas",
	"upptäcks",
	"upptäcktes",
	"upptäckts",
	"upptagas",
	"upptages",
	"upptagits",
	"upptändes",
	"upptänds",
	"upptänts",
	"upptas",
	"upptaxeras",
	"upptecknades",
	"upptecknats",
	"upptogs",
	"uppväckas",
	"uppväcktes",
	"uppvägas",
	"uppvägdes",
	"uppvägs",
	"uppvägts",
	"uppvaktades",
	"uppvaktas",
	"uppvaktats",
	"uppvärderades",
	"uppvärderas",
	"uppvärmdes",
	"uppvisades",
	"uppvisas",
	"uppvisningflygas",
	"urbaniserats",
	"urgröps",
	"urholkades",
	"urholkas",
	"urholkats",
	"urkalkas",
	"urladdas",
	"urlakats",
	"ursäktas",
	"ursäktats",
	"urskiljas",
	"urskiljs",
	"urskuldas",
	"uruppföras",
	"uruppfördes",
	"uruppförs",
	"uruppförts",
	"urvattnas",
	"usurperats",
	"utandades",
	"utandas",
	"utandats",
	"utannonserades",
	"utannonseras",
	"utannonserats",
	"utanordnats",
	"utarbetades",
	"utarbetas",
	"utarbetats",
	"utarmades",
	"utarmas",
	"utarmats",
	"utarrenderas",
	"utbasunerades",
	"utbasuneras",
	"utbetalades",
	"utbetalas",
	"utbetalats",
	"utbildades",
	"utbildas",
	"utbildats",
	"utbjöds",
	"utbjudas",
	"utbjuds",
	"utbringades",
	"utbringas",
	"utbroderas",
	"utbyts",
	"utbyttes",
	"utbytts",
	"utdefinieras",
	"utdelades",
	"utdelas",
	"utdelats",
	"utdikades",
	"utdömas",
	"utdömdes",
	"utdöms",
	"utdömts",
	"utdrivas",
	"utelämnas",
	"utelämnats",
	"uteslöts",
	"uteslutas",
	"uteslutits",
	"utesluts",
	"utestängas",
	"utestängdes",
	"utestängs",
	"utestängts",
	"utexaminerades",
	"utexamineras",
	"utexaminerats",
	"utfalls",
	"utfärdades",
	"utfärdas",
	"utfärdats",
	"utfästas",
	"utfästs",
	"utflyttas",
	"utfodras",
	"utföras",
	"utfördelas",
	"utfördes",
	"utfordras",
	"utfordrats",
	"utföres",
	"utformades",
	"utformas",
	"utformats",
	"utförs",
	"utförsäkras",
	"utförsäljas",
	"utforskades",
	"utforskas",
	"utförts",
	"utfösas",
	"utfrågades",
	"utfrågas",
	"utfrågats",
	"utgavs",
	"utges",
	"utgetts",
	"utgivits",
	"utgjordes",
	"utgjorts",
	"utgjutits",
	"utglesas",
	"utgöras",
	"utgöres",
	"utgörs",
	"uthärdas",
	"uthyrdes",
	"utjämnades",
	"utjämnas",
	"utjämnats",
	"utkämpades",
	"utkämpas",
	"utkämpats",
	"utklassats",
	"utkommenderades",
	"utkonkurrerades",
	"utkonkurreras",
	"utkoras",
	"utkorats",
	"utkrävas",
	"utkrävdes",
	"utkräves",
	"utkrävts",
	"utkrisalliseras",
	"utkristalliserades",
	"utkristalliseras",
	"utkristalliserats",
	"utkvitteras",
	"utlades",
	"utläggas",
	"utläggs",
	"utlämnades",
	"utlämnas",
	"utlämnats",
	"utlandsstationerades",
	"utlandstationerades",
	"utläs",
	"utläsas",
	"utläses",
	"utlokaliserades",
	"utlokaliseras",
	"utlokaliserats",
	"utlösas",
	"utlöses",
	"utlöstes",
	"utlösts",
	"utlottades",
	"utlottas",
	"utlovades",
	"utlovas",
	"utlovats",
	"utlys",
	"utlysas",
	"utlyses",
	"utlystes",
	"utlysts",
	"utmålades",
	"utmålas",
	"utmålats",
	"utmanades",
	"utmanas",
	"utmanats",
	"utmanövrerades",
	"utmanövreras",
	"utmärkas",
	"utmärks",
	"utmärktes",
	"utmärkts",
	"utmätas",
	"utmäts",
	"utmattas",
	"utmättes",
	"utmätts",
	"utmejslades",
	"utminuterades",
	"utmönstrades",
	"utmönstras",
	"utnämnas",
	"utnämndes",
	"utnämns",
	"utnämnts",
	"utnyttjades",
	"utnyttjas",
	"utnyttjats",
	"utoands",
	"utökades",
	"utökas",
	"utökats",
	"utövades",
	"utövas",
	"utövats",
	"utpekades",
	"utpekas",
	"utpekats",
	"utplacerades",
	"utplaceras",
	"utplacerats",
	"utplånades",
	"utplånas",
	"utplånats",
	"utplanteras",
	"utposteras",
	"utpressas",
	"utpressats",
	"utprovades",
	"utprovas",
	"utprovats",
	"utraderades",
	"utraderas",
	"utraderats",
	"utrangeras",
	"utrangerats",
	"uträttades",
	"uträttas",
	"uträttats",
	"utredas",
	"utreddes",
	"utredningshäktades",
	"utreds",
	"utrensades",
	"utretts",
	"utropades",
	"utropas",
	"utropats",
	"utrotades",
	"utrotas",
	"utrotats",
	"utrustades",
	"utrustas",
	"utrustats",
	"utrycks",
	"utrymdes",
	"utrymmas",
	"utryms",
	"utrymts",
	"utsades",
	"utsägas",
	"utsågs",
	"utsägs",
	"utsagts",
	"utsändas",
	"utsändes",
	"utsänds",
	"utsänts",
	"utsättas",
	"utsattes",
	"utsättes",
	"utsatts",
	"utsätts",
	"utses",
	"utsetts",
	"utsiras",
	"utskeppas",
	"utskiljas",
	"utslungas",
	"utslungats",
	"utsmyckas",
	"utsöndras",
	"utspanns",
	"utspelades",
	"utspelas",
	"utspelats",
	"utspionerades",
	"utspisades",
	"utspisas",
	"utspisats",
	"utstakades",
	"utstakats",
	"utställas",
	"utställdes",
	"utställs",
	"utstöttes",
	"utsträckas",
	"utsträcks",
	"utsträcktes",
	"utstrålas",
	"utströs",
	"uttages",
	"uttagits",
	"uttalades",
	"uttalas",
	"uttalats",
	"uttänkas",
	"uttas",
	"uttnyttjas",
	"uttogs",
	"uttolkas",
	"uttöms",
	"utträttats",
	"uttröttas",
	"uttryckas",
	"uttrycks",
	"uttrycktes",
	"uttryckts",
	"utttrycks",
	"uttunnades",
	"uttunnas",
	"uttydas",
	"uttydes",
	"uttyds",
	"utuppfördes",
	"utvaldes",
	"utväljas",
	"utvalts",
	"utvanns",
	"utvärderades",
	"utvärderas",
	"utvärderats",
	"utvattnas",
	"utväxlades",
	"utväxlas",
	"utväxlats",
	"utveckas",
	"utvecklades",
	"utvecklas",
	"utvecklats",
	"utveklas",
	"utverkats",
	"utvidgades",
	"utvidgas",
	"utvidgats",
	"utvinnas",
	"utvinns",
	"utvisades",
	"utvisas",
	"utvisats",
	"utvunnits",
	"uvecklas",
	"uvecklats",
	"vaccinerades",
	"vaccineras",
	"vaccinerats",
	"vachettes",
	"väckas",
	"väcks",
	"väcktes",
	"väckts",
	"vådaskjuts",
	"vådasköts",
	"vades",
	"vädrades",
	"vädras",
	"vädrats",
	"vågas",
	"vägas",
	"vägdes",
	"väges",
	"vaggades",
	"vaggas",
	"vaggats",
	"vägledas",
	"vägleddes",
	"vägleds",
	"vägletts",
	"vägrades",
	"vägras",
	"vägrats",
	"vägs",
	"vägts",
	"vakantsätts",
	"vaktades",
	"vaktas",
	"vakuummöras",
	"valderas",
	"valdes",
	"våldtagits",
	"våldtas",
	"våldtogs",
	"valenciennes",
	"väljas",
	"väljes",
	"väljs",
	"välkomnades",
	"välkomnas",
	"välkomnats",
	"vallades",
	"vållades",
	"vallas",
	"vallås",
	"vållas",
	"vållats",
	"vallfärdas",
	"valsas",
	"välsignades",
	"välsignas",
	"välsignats",
	"vältas",
	"vältes",
	"vältrades",
	"vältras",
	"vältrats",
	"valts",
	"välts",
	"välvdes",
	"välvs",
	"vämjdes",
	"vanäras",
	"våndades",
	"vandaliserades",
	"vandaliseras",
	"vandaliserats",
	"våndas",
	"vändas",
	"våndats",
	"vandes",
	"vändes",
	"vandkunsts",
	"vandrades",
	"vandras",
	"vänds",
	"vändsteks",
	"vanhedrats",
	"vanhelgas",
	"vanhelgats",
	"vänjas",
	"vankades",
	"vankats",
	"vanns",
	"vanprydas",
	"vanskötas",
	"vansköts",
	"vansköttes",
	"vansläktades",
	"vansläktas",
	"vansläktats",
	"vanställs",
	"vanstyrs",
	"väntades",
	"väntas",
	"väntats",
	"vantolkas",
	"vantolkats",
	"vänts",
	"vanvårdas",
	"vanvårdats",
	"våransas",
	"varas",
	"vårdades",
	"vårdas",
	"vårdats",
	"värdebas",
	"värderades",
	"värderas",
	"värderats",
	"värdes",
	"värdesättas",
	"värdesattes",
	"värdesatts",
	"värdesätts",
	"värdigades",
	"värdigas",
	"vares",
	"vargas",
	"varieras",
	"varierats",
	"värks",
	"värmas",
	"värmdes",
	"varmhållas",
	"varmkörs",
	"varmmanglades",
	"varmrökas",
	"värms",
	"värmts",
	"varnades",
	"värnades",
	"varnas",
	"värnas",
	"varnats",
	"värnats",
	"vårseglats",
	"varslades",
	"varslas",
	"varslats",
	"varsnas",
	"varvades",
	"värvades",
	"varvas",
	"värvas",
	"varvats",
	"värvats",
	"väs",
	"vaskades",
	"vaskas",
	"vaskats",
	"vässas",
	"västallierades",
	"västs",
	"vattenfyllas",
	"vattenfylls",
	"vattengjutits",
	"vattnades",
	"vattnas",
	"vattnats",
	"vattrades",
	"vattras",
	"vävas",
	"vävdes",
	"vävs",
	"vävts",
	"växlades",
	"växlas",
	"växlats",
	"växtfärgats",
	"veckats",
	"vecklades",
	"vecklas",
	"vederfaras",
	"vederfares",
	"vederfarits",
	"vederfars",
	"vederfors",
	"vederlades",
	"vederläggas",
	"vederläggs",
	"vederlagts",
	"veks",
	"veldes",
	"venables",
	"vendanges",
	"veninivas",
	"venstres",
	"ventilerades",
	"ventileras",
	"ventilerats",
	"verbaliseras",
	"verderfarits",
	"verdes",
	"verifieras",
	"verifierats",
	"verkställas",
	"verkställdes",
	"verkställs",
	"verkställts",
	"vetas",
	"veterinärundersökas",
	"vetetortillas",
	"vevades",
	"vevas",
	"vevats",
	"vickas",
	"vidarebefodrades",
	"vidarebefordrades",
	"vidarebefordras",
	"vidarebefordrats",
	"vidarebehandlas",
	"vidareexporteras",
	"vidareexporterats",
	"vidareförsäljas",
	"vidareförsäljs",
	"vidaresändas",
	"vidaresänts",
	"vidareutbildas",
	"vidareutvecklades",
	"vidareutvecklas",
	"vidareutvecklats",
	"videodokumenteras",
	"videofilmades",
	"videofilmas",
	"videofilmats",
	"videoinspelats",
	"vidgades",
	"vidgas",
	"vidgats",
	"vidgåtts",
	"vidhållas",
	"vidimerades",
	"vidimeras",
	"vidkännas",
	"vidmakthållas",
	"vidmakthålles",
	"vidmakthålls",
	"vidmakthölls",
	"vidröras",
	"vidrörs",
	"vidrörts",
	"vidtagas",
	"vidtages",
	"vidtagits",
	"vidtalades",
	"vidtalas",
	"vidtas",
	"vidtogs",
	"viftades",
	"viftas",
	"viftats",
	"vigas",
	"vigdes",
	"vigs",
	"vigts",
	"vikas",
	"vikits",
	"viks",
	"viktas",
	"vikts",
	"vilas",
	"villfaras",
	"villkoras",
	"villkorats",
	"villkorsändrades",
	"vilseförts",
	"vilseledas",
	"vilseleddes",
	"vilseleds",
	"vilseletts",
	"vimlades",
	"vimlats",
	"vindas",
	"vindfälldes",
	"vindtorkas",
	"vineras",
	"vingklippas",
	"vinglas",
	"vinifieras",
	"vinkades",
	"vinkas",
	"vinklades",
	"vinklas",
	"vinnas",
	"vinnes",
	"vinns",
	"vinschas",
	"vinterförvarats",
	"vinterkonserverats",
	"vintersportades",
	"vippas",
	"virades",
	"viras",
	"virats",
	"virkats",
	"virvlades",
	"virvlas",
	"visades",
	"visas",
	"visats",
	"visiones",
	"visiterades",
	"visiteras",
	"viskades",
	"viskas",
	"viskats",
	"vispades",
	"vispas",
	"vispats",
	"visslades",
	"visslas",
	"visslats",
	"visstes",
	"visualiseras",
	"vitaliserades",
	"vitaliseras",
	"vitaliserats",
	"vitesföreläggas",
	"vitesförelagts",
	"vitlimmas",
	"vitsordas",
	"vittjas",
	"vittjats",
	"vittnas",
	"vittras",
	"vogts",
	"voltas",
	"vördades",
	"vördas",
	"voterades",
	"vrakades",
	"vräkas",
	"vräks",
	"vräktes",
	"vräkts",
	"vrålas",
	"vrängas",
	"vrängs",
	"vranjes",
	"vredgades",
	"vredgas",
	"vredgats",
	"vreds",
	"vrenskades",
	"vrenskas",
	"vridas",
	"vrides",
	"vridits",
	"vrids",
	"vunnits",
	"walesas",
	"walkabouts",
	"wannadies",
	"wästfelts",
	"waves",
	"williams",
	"wokas",
	"yeats",
	"ylikangas",
	"ympades",
	"ympas",
	"ympats",
	"yorkbörs",
	"yppades",
	"yppas",
	"yrkades",
	"yrkas",
	"ystades",
	"ytbehandlas",
	"yttrades",
	"yttras",
	"yttrats",
	"zappas",
	"zonindelades",
	"zoomas",
];

